// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * * `zendesk` - Zendesk * `customer` - Customer
 * @export
 * @enum {string}
 */

export const AgentEnum = {
    Zendesk: 'zendesk',
    Customer: 'customer'
} as const;

export type AgentEnum = typeof AgentEnum[keyof typeof AgentEnum];


/**
 * @type ArrayOrPaginatedCommunityFullList
 * @export
 */
export type ArrayOrPaginatedCommunityFullList = Array<CommunityFull> | PaginatedCommunityFullList;

/**
 * @type ArrayOrPaginatedCommunityInvitationList
 * @export
 */
export type ArrayOrPaginatedCommunityInvitationList = Array<CommunityInvitation> | PaginatedCommunityInvitationList;

/**
 * @type ArrayOrPaginatedCommunityList
 * @export
 */
export type ArrayOrPaginatedCommunityList = Array<Community> | PaginatedCommunityList;

/**
 * @type ArrayOrPaginatedCommunitySignUpRequestList
 * @export
 */
export type ArrayOrPaginatedCommunitySignUpRequestList = Array<CommunitySignUpRequest> | PaginatedCommunitySignUpRequestList;

/**
 * @type ArrayOrPaginatedOrganisationList
 * @export
 */
export type ArrayOrPaginatedOrganisationList = Array<Organisation> | PaginatedOrganisationList;

/**
 * @type ArrayOrPaginatedPrivateWriteUserList
 * @export
 */
export type ArrayOrPaginatedPrivateWriteUserList = Array<PrivateWriteUser> | PaginatedPrivateWriteUserList;

/**
 * @type ArrayOrPaginatedSpaceGroupList
 * @export
 */
export type ArrayOrPaginatedSpaceGroupList = Array<SpaceGroup> | PaginatedSpaceGroupList;

/**
 * @type ArrayOrPaginatedSpaceGroupWithNotificationsList
 * @export
 */
export type ArrayOrPaginatedSpaceGroupWithNotificationsList = Array<SpaceGroupWithNotifications> | PaginatedSpaceGroupWithNotificationsList;

/**
 * @type ArrayOrPaginatedSpaceGroupWithPermissionsList
 * @export
 */
export type ArrayOrPaginatedSpaceGroupWithPermissionsList = Array<SpaceGroupWithPermissions> | PaginatedSpaceGroupWithPermissionsList;

/**
 * @type ArrayOrPaginatedToolList
 * @export
 */
export type ArrayOrPaginatedToolList = Array<Tool> | PaginatedToolList;

/**
 * @type ArrayOrPaginatedUserList
 * @export
 */
export type ArrayOrPaginatedUserList = Array<User> | PaginatedUserList;

/**
 * @type ArrayOrPaginatedWebHookList
 * @export
 */
export type ArrayOrPaginatedWebHookList = Array<WebHook> | PaginatedWebHookList;

/**
 * 
 * @export
 * @interface AuthToken
 */
export interface AuthToken {
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AuthToken
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface AuthedPayload
 */
export interface AuthedPayload {
    /**
     * 
     * @type {string}
     * @memberof AuthedPayload
     */
    'signature': string;
    /**
     * 
     * @type {string}
     * @memberof AuthedPayload
     */
    'payload': string;
}
/**
 * 
 * @export
 * @interface Author
 */
export interface Author {
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'handle': string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'profileImage': string;
}
/**
 * * `user` - User * `business` - Business * `ai` - AI
 * @export
 * @enum {string}
 */

export const AuthorTypeEnum = {
    User: 'user',
    Business: 'business',
    Ai: 'ai'
} as const;

export type AuthorTypeEnum = typeof AuthorTypeEnum[keyof typeof AuthorTypeEnum];


/**
 * 
 * @export
 * @interface BasePostSearchResult
 */
export interface BasePostSearchResult {
    /**
     * 
     * @type {string}
     * @memberof BasePostSearchResult
     */
    'seqNum': string;
    /**
     * 
     * @type {User}
     * @memberof BasePostSearchResult
     */
    'author': User;
}
/**
 * 
 * @export
 * @interface CRDTDocument
 */
export interface CRDTDocument {
    /**
     * 
     * @type {string}
     * @memberof CRDTDocument
     */
    'crdt': string;
    /**
     * 
     * @type {string}
     * @memberof CRDTDocument
     */
    'text': string;
    /**
     * 
     * @type {any}
     * @memberof CRDTDocument
     */
    'json': any;
}
/**
 * 
 * @export
 * @interface CRDTDraft
 */
export interface CRDTDraft {
    /**
     * 
     * @type {string}
     * @memberof CRDTDraft
     */
    'crdt': string;
    /**
     * 
     * @type {any}
     * @memberof CRDTDraft
     */
    'json': any;
}
/**
 * * `category` - Category * `section` - Section
 * @export
 * @enum {string}
 */

export const CategoryTypeEnum = {
    Category: 'category',
    Section: 'section'
} as const;

export type CategoryTypeEnum = typeof CategoryTypeEnum[keyof typeof CategoryTypeEnum];


/**
 * 
 * @export
 * @interface ChangelogEntry
 */
export interface ChangelogEntry {
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'uuid': string;
    /**
     * 
     * @type {Author}
     * @memberof ChangelogEntry
     */
    'author': Author;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'summary'?: string;
    /**
     * 
     * @type {any}
     * @memberof ChangelogEntry
     */
    'content': any;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntry
     */
    'image'?: string | null;
}
/**
 * 
 * @export
 * @interface ChangelogEntryWrite
 */
export interface ChangelogEntryWrite {
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntryWrite
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntryWrite
     */
    'summary'?: string;
    /**
     * 
     * @type {any}
     * @memberof ChangelogEntryWrite
     */
    'content': any;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntryWrite
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntryWrite
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntryWrite
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangelogEntryWrite
     */
    'image'?: string | null;
}
/**
 * 
 * @export
 * @interface ChatFeedback
 */
export interface ChatFeedback {
    /**
     * 
     * @type {boolean}
     * @memberof ChatFeedback
     */
    'isPositive': boolean;
}
/**
 * 
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'traceId': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'author': string;
    /**
     * Returns the timestamp in ISO format
     * @type {string}
     * @memberof Comment
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'authorHandle': string;
    /**
     * 
     * @type {AuthorTypeEnum}
     * @memberof Comment
     */
    'authorType': AuthorTypeEnum;
    /**
     * 
     * @type {CommentConversationItemTypeEnum}
     * @memberof Comment
     */
    'conversationItemType': CommentConversationItemTypeEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CommentConversationItemTypeEnum = {
    Comment: 'comment'
} as const;

export type CommentConversationItemTypeEnum = typeof CommentConversationItemTypeEnum[keyof typeof CommentConversationItemTypeEnum];


/**
 * @type Community
 * @export
 */
export type Community = { accessType: 'full' } & CommunityFull | { accessType: 'restricted' } & CommunityRestricted;

/**
 * 
 * @export
 * @interface CommunityCRM
 */
export interface CommunityCRM {
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'companyProductName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'currentDocTool'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'sendUpdates'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'aspirations'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'usedDiscord'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'usedSlack'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'usedDiscourse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'usedFacebook'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'usedOther'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCRM
     */
    'usedNone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityCRM
     */
    'planSelected'?: string;
}
/**
 * 
 * @export
 * @interface CommunityCreation
 */
export interface CommunityCreation {
    /**
     * 
     * @type {string}
     * @memberof CommunityCreation
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityCreation
     */
    'primaryColor'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCreation
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityCreation
     */
    'slug'?: string;
}
/**
 * 
 * @export
 * @interface CommunityFull
 */
export interface CommunityFull {
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'logoImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'primaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'backgroundColorDark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'coverImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'about'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'indexable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'gtmId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isMemberDirectoryShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isEventCalendarShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isDocumentsEnabled'?: boolean;
    /**
     * 
     * @type {DocumentsPrivacyEnum}
     * @memberof CommunityFull
     */
    'documentsPrivacy'?: DocumentsPrivacyEnum;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'documentsName'?: string;
    /**
     * 
     * @type {FullAccess}
     * @memberof CommunityFull
     */
    'accessType': FullAccess;
    /**
     * hybrid property-ish: if `member_count` was previously set (by queryset) use it, otherwise calculate it.
     * @type {number}
     * @memberof CommunityFull
     */
    'memberCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isContentLibraryEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'contentLibraryTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isExternalLinkShown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLinkUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLinkTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLinkImage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isExternalLink2Shown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLink2Url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLink2Tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLink2Image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isExternalLink3Shown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLink3Url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLink3Tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'externalLink3Image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isCommunityEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'communitySectionName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isChangelogEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isAskAiTeamOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'changelogVisible': boolean;
    /**
     * 
     * @type {Array<Flag>}
     * @memberof CommunityFull
     */
    'flags': Array<Flag>;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'docsVisible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isForumsFullWidth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isChangelogExpanded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isSemanticRelationShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'isDocMetadataShown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'changelogDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetAgentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetFooter'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetAccentColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetLogo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetButtonText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetCustomActionLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'widgetCustomActionPrompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'zendeskSubdomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityFull
     */
    'modified': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'zendeskIntegrationEnabled': boolean;
    /**
     * Returns True if the community has Zendesk chat integration configured. This is determined by whether the zendesk_conversation_app_key_id is set.
     * @type {boolean}
     * @memberof CommunityFull
     */
    'zendeskChatEnabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityFull
     */
    'intercomIntegrationEnabled': boolean;
}


/**
 * 
 * @export
 * @interface CommunityIntercomAppId
 */
export interface CommunityIntercomAppId {
    /**
     * 
     * @type {string}
     * @memberof CommunityIntercomAppId
     */
    'intercomAppId': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityIntercomAppId
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface CommunityInvitation
 */
export interface CommunityInvitation {
    /**
     * 
     * @type {string}
     * @memberof CommunityInvitation
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityInvitation
     */
    'created': string;
    /**
     * 
     * @type {number}
     * @memberof CommunityInvitation
     */
    'community'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityInvitation
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityInvitation
     */
    'isAdmin'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityInviteCode
 */
export interface CommunityInviteCode {
    /**
     * 
     * @type {string}
     * @memberof CommunityInviteCode
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityInviteCode
     */
    'modified': string;
}
/**
 * 
 * @export
 * @interface CommunityNotifications
 */
export interface CommunityNotifications {
    /**
     * 
     * @type {boolean}
     * @memberof CommunityNotifications
     */
    'isSubscribedToNewMemberEvent': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommunityPermission = {
    AccessCommunityServer: 'access_community_server',
    AddSpacegroup: 'add_spacegroup',
    ChangeSpacegroup: 'change_spacegroup',
    DeleteSpacegroup: 'delete_spacegroup',
    ViewUserPermissions: 'view_user_permissions',
    ViewInvitations: 'view_invitations',
    ViewSignUps: 'view_sign_ups',
    ChangeCommunity: 'change_community',
    ViewCommunityrole: 'view_communityrole',
    AddCommunityrole: 'add_communityrole',
    ChangeCommunityrole: 'change_communityrole',
    DeleteCommunityrole: 'delete_communityrole',
    RemoveCommunityMember: 'remove_community_member',
    InviteMembers: 'invite_members',
    ManageTeamMembers: 'manage_team_members',
    ManageLabels: 'manage_labels',
    ManageAgents: 'manage_agents',
    ManageEscalationRules: 'manage_escalation_rules',
    ConfigureWebhooks: 'configure_webhooks',
    CanReceiveAdminNotifications: 'can_receive_admin_notifications',
    CanViewAnalytics: 'can_view_analytics',
    CanViewConversationHistory: 'can_view_conversation_history',
    ViewContextSources: 'view_context_sources',
    AddForumspaceCommunity: 'add_forumspace_community',
    ChangeForumspaceCommunity: 'change_forumspace_community',
    DeleteForumspaceCommunity: 'delete_forumspace_community',
    HideForumthreadForumspaceCommunity: 'hide_forumthread_forumspace_community',
    MarksolvedForumthreadForumspaceCommunity: 'marksolved_forumthread_forumspace_community',
    AddCustomspaceCommunity: 'add_customspace_community',
    ChangeCustomspaceCommunity: 'change_customspace_community',
    DeleteCustomspaceCommunity: 'delete_customspace_community',
    ViewContentlinkCommunity: 'view_contentlink_community',
    AddContentlinkCommunity: 'add_contentlink_community',
    ChangeContentlinkCommunity: 'change_contentlink_community',
    DeleteContentlinkCommunity: 'delete_contentlink_community',
    AddDocumentCommunity: 'add_document_community',
    ViewDocumentCommunity: 'view_document_community',
    ChangeDocumentCommunity: 'change_document_community',
    DeleteDocumentCommunity: 'delete_document_community',
    ViewChangelogEntryCommunity: 'view_changelog_entry_community',
    AddChangelogEntryCommunity: 'add_changelog_entry_community',
    ChangeChangelogEntryCommunity: 'change_changelog_entry_community',
    DeleteChangelogEntryCommunity: 'delete_changelog_entry_community'
} as const;

export type CommunityPermission = typeof CommunityPermission[keyof typeof CommunityPermission];


/**
 * 
 * @export
 * @interface CommunityPermissions
 */
export interface CommunityPermissions {
    /**
     * 
     * @type {string}
     * @memberof CommunityPermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<CommunityPermission>}
     * @memberof CommunityPermissions
     */
    'permissions': Array<CommunityPermission> | null;
}
/**
 * 
 * @export
 * @interface CommunityRestricted
 */
export interface CommunityRestricted {
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'logoImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'primaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'backgroundColorDark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'coverImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'about'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'indexable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'gtmId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isMemberDirectoryShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isEventCalendarShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isDocumentsEnabled'?: boolean;
    /**
     * 
     * @type {DocumentsPrivacyEnum}
     * @memberof CommunityRestricted
     */
    'documentsPrivacy'?: DocumentsPrivacyEnum;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'documentsName'?: string;
    /**
     * 
     * @type {RestrictedAccess}
     * @memberof CommunityRestricted
     */
    'accessType': RestrictedAccess;
    /**
     * hybrid property-ish: if `member_count` was previously set (by queryset) use it, otherwise calculate it.
     * @type {number}
     * @memberof CommunityRestricted
     */
    'memberCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isContentLibraryEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'contentLibraryTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isExternalLinkShown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLinkUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLinkTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLinkImage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isExternalLink2Shown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLink2Url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLink2Tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLink2Image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isExternalLink3Shown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLink3Url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLink3Tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'externalLink3Image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isCommunityEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'communitySectionName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isChangelogEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isAskAiTeamOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'changelogVisible': boolean;
    /**
     * 
     * @type {Array<Flag>}
     * @memberof CommunityRestricted
     */
    'flags': Array<Flag>;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'docsVisible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isForumsFullWidth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isChangelogExpanded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isSemanticRelationShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRestricted
     */
    'isDocMetadataShown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'changelogDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetAgentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetFooter'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetAccentColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetLogo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetButtonText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetCustomActionLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'widgetCustomActionPrompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRestricted
     */
    'zendeskSubdomain'?: string | null;
}


/**
 * 
 * @export
 * @interface CommunityRole
 */
export interface CommunityRole {
    /**
     * 
     * @type {string}
     * @memberof CommunityRole
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRole
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRole
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRole
     */
    'created': string;
    /**
     * 
     * @type {Array<PermsGroupingsEnum>}
     * @memberof CommunityRole
     */
    'permsGroupings'?: Array<PermsGroupingsEnum>;
    /**
     * 
     * @type {Array<User>}
     * @memberof CommunityRole
     */
    'users': Array<User>;
    /**
     * 
     * @type {number}
     * @memberof CommunityRole
     */
    'usersCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRole
     */
    'isCommunityMembers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRole
     */
    'isCommunityAdmins': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRole
     */
    'isCommunityTeam': boolean;
}
/**
 * A _fast_ Community Role serialiser optimised by not using ModelSerializer.  ModelSerializer is _slow_ due to intropsection/validation.
 * @export
 * @interface CommunityRolePreview
 */
export interface CommunityRolePreview {
    /**
     * 
     * @type {string}
     * @memberof CommunityRolePreview
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityRolePreview
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommunityRolePreview
     */
    'color'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRolePreview
     */
    'isMembers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRolePreview
     */
    'isAdmins': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityRolePreview
     */
    'isTeam': boolean;
}
/**
 * 
 * @export
 * @interface CommunitySEOSerialiser
 */
export interface CommunitySEOSerialiser {
    /**
     * 
     * @type {string}
     * @memberof CommunitySEOSerialiser
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof CommunitySEOSerialiser
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CommunitySignUpRequest
 */
export interface CommunitySignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitySignUpRequest
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CommunitySignUpRequest
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof CommunitySignUpRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommunitySignUpRequest
     */
    'community'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommunitySignUpRequest
     */
    'invitation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CommunitySignUpRequest
     */
    'inviteCodeCode'?: string;
    /**
     * 
     * @type {CommunitySignUpRequestStatusEnum}
     * @memberof CommunitySignUpRequest
     */
    'status': CommunitySignUpRequestStatusEnum;
}


/**
 * * `PENDING` - 1 * `APPROVED` - 2 * `DENIED` - 3 * `DENIED_WRONG_USER` - 4 * `ALREADY_MEMBER` - 5
 * @export
 * @enum {string}
 */

export const CommunitySignUpRequestStatusEnum = {
    Pending: 'PENDING',
    Approved: 'APPROVED',
    Denied: 'DENIED',
    DeniedWrongUser: 'DENIED_WRONG_USER',
    AlreadyMember: 'ALREADY_MEMBER'
} as const;

export type CommunitySignUpRequestStatusEnum = typeof CommunitySignUpRequestStatusEnum[keyof typeof CommunitySignUpRequestStatusEnum];


/**
 * 
 * @export
 * @interface CommunityZendeskSubdomain
 */
export interface CommunityZendeskSubdomain {
    /**
     * 
     * @type {string}
     * @memberof CommunityZendeskSubdomain
     */
    'zendeskSubdomain': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityZendeskSubdomain
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface ContentLink
 */
export interface ContentLink {
    /**
     * 
     * @type {string}
     * @memberof ContentLink
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ContentLink
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ContentLink
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContentLink
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentLink
     */
    'description'?: string;
    /**
     * 
     * @type {ContentLinkType}
     * @memberof ContentLink
     */
    'type'?: ContentLinkType;
}


/**
 * 
 * @export
 * @interface ContentLinkListItem
 */
export interface ContentLinkListItem {
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'description'?: string;
    /**
     * 
     * @type {ContentLinkType}
     * @memberof ContentLinkListItem
     */
    'type'?: ContentLinkType;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'highlightedTitle': string;
    /**
     * 
     * @type {string}
     * @memberof ContentLinkListItem
     */
    'highlightedDescription': string;
}


/**
 * * `link` - Link * `video` - Video * `article` - Article
 * @export
 * @enum {string}
 */

export const ContentLinkType = {
    Link: 'link',
    Video: 'video',
    Article: 'article'
} as const;

export type ContentLinkType = typeof ContentLinkType[keyof typeof ContentLinkType];


/**
 * 
 * @export
 * @interface ContentSearchResult
 */
export interface ContentSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ContentSearchResult
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ContentSearchResult
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ContentSearchResult
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ContentSearchResult
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ContentSearchResult
     */
    'highlightedTitle': string;
    /**
     * 
     * @type {string}
     * @memberof ContentSearchResult
     */
    'highlightedDescription': string;
}
/**
 * 
 * @export
 * @interface Context
 */
export interface Context {
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'uuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof Context
     */
    'isSnippet': boolean;
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'externalUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof Context
     */
    'wasCited': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Context
     */
    'citations': Array<string>;
}
/**
 * 
 * @export
 * @interface ContextSource
 */
export interface ContextSource {
    /**
     * 
     * @type {string}
     * @memberof ContextSource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ContextSource
     */
    'docCount': string;
    /**
     * 
     * @type {string}
     * @memberof ContextSource
     */
    'lastRunAt': string;
    /**
     * 
     * @type {ContextSourceStatusEnum}
     * @memberof ContextSource
     */
    'status': ContextSourceStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ContextSource
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ContextSource
     */
    'lastSuccessfulRunAt': string;
}


/**
 * * `init` - Init * `scanning` - Scanning * `crawling` - Crawling * `running` - Running * `success` - Success * `partial` - Partial * `failed` - Failed
 * @export
 * @enum {string}
 */

export const ContextSourceStatusEnum = {
    Init: 'init',
    Scanning: 'scanning',
    Crawling: 'crawling',
    Running: 'running',
    Success: 'success',
    Partial: 'partial',
    Failed: 'failed'
} as const;

export type ContextSourceStatusEnum = typeof ContextSourceStatusEnum[keyof typeof ContextSourceStatusEnum];


/**
 * @type ConversationItem
 * @export
 */
export type ConversationItem = { conversationItemType: 'comment' } & Comment | { conversationItemType: 'trace' } & Trace;

/**
 * 
 * @export
 * @interface CopilotConfig
 */
export interface CopilotConfig {
    /**
     * 
     * @type {string}
     * @memberof CopilotConfig
     */
    'zendeskTicket': string;
    /**
     * 
     * @type {string}
     * @memberof CopilotConfig
     */
    'conversationId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CopilotConfig
     */
    'summary'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateUserSerialiser
 */
export interface CreateUserSerialiser {
    /**
     * 
     * @type {string}
     * @memberof CreateUserSerialiser
     */
    'captcha': string;
}
/**
 * 
 * @export
 * @interface CustomSpace
 */
export interface CustomSpace {
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'emoji'?: string | null;
    /**
     * 
     * @type {SpaceTypeC91Enum}
     * @memberof CustomSpace
     */
    'spaceType': SpaceTypeC91Enum;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'spaceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'title': string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof CustomSpace
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<CustomSpacePerms>}
     * @memberof CustomSpace
     */
    'permissions': Array<CustomSpacePerms>;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'iconDark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'crdt'?: string;
    /**
     * 
     * @type {any}
     * @memberof CustomSpace
     */
    'json'?: any;
    /**
     * 
     * @type {string}
     * @memberof CustomSpace
     */
    'text'?: string;
}


/**
 * Update just the content of a custom space.  Require all fields.
 * @export
 * @interface CustomSpaceContent
 */
export interface CustomSpaceContent {
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceContent
     */
    'crdt': string;
    /**
     * 
     * @type {any}
     * @memberof CustomSpaceContent
     */
    'json': any;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceContent
     */
    'text': string;
}
/**
 * Serialises custom space meta data without content for use in lists.
 * @export
 * @interface CustomSpaceList
 */
export interface CustomSpaceList {
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'emoji'?: string | null;
    /**
     * 
     * @type {SpaceTypeC91Enum}
     * @memberof CustomSpaceList
     */
    'spaceType': SpaceTypeC91Enum;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'spaceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'title': string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof CustomSpaceList
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<CustomSpacePerms>}
     * @memberof CustomSpaceList
     */
    'permissions': Array<CustomSpacePerms>;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'iconDark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceList
     */
    'uuid': string;
}


/**
 * 
 * @export
 * @interface CustomSpaceListNotifications
 */
export interface CustomSpaceListNotifications {
    /**
     * 
     * @type {string}
     * @memberof CustomSpaceListNotifications
     */
    'uuid': string;
    /**
     * 
     * @type {SpaceTypeC91Enum}
     * @memberof CustomSpaceListNotifications
     */
    'spaceType': SpaceTypeC91Enum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomSpacePermission = {
    AddCustomspace: 'add_customspace',
    ViewCustomspace: 'view_customspace',
    ChangeCustomspace: 'change_customspace',
    DeleteCustomspace: 'delete_customspace',
    ChangeContentCustomspace: 'change_content_customspace'
} as const;

export type CustomSpacePermission = typeof CustomSpacePermission[keyof typeof CustomSpacePermission];


/**
 * 
 * @export
 * @interface CustomSpacePermissions
 */
export interface CustomSpacePermissions {
    /**
     * 
     * @type {string}
     * @memberof CustomSpacePermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<CustomSpacePermission>}
     * @memberof CustomSpacePermissions
     */
    'permissions': Array<CustomSpacePermission> | null;
}
/**
 * 
 * @export
 * @interface CustomSpacePerms
 */
export interface CustomSpacePerms {
    /**
     * 
     * @type {string}
     * @memberof CustomSpacePerms
     */
    'code': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomSpacePerms
     */
    'roles': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomSpacePerms
     */
    'users': Array<string>;
}
/**
 * 
 * @export
 * @interface CustomSpaceWithPermissions
 */
export interface CustomSpaceWithPermissions {
    /**
     * 
     * @type {CustomSpace}
     * @memberof CustomSpaceWithPermissions
     */
    'customSpace': CustomSpace;
    /**
     * 
     * @type {CustomSpacePermissions}
     * @memberof CustomSpaceWithPermissions
     */
    'myPermissions': CustomSpacePermissions;
}
/**
 * 
 * @export
 * @interface CustomToken
 */
export interface CustomToken {
    /**
     * 
     * @type {string}
     * @memberof CustomToken
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface Dataset
 */
export interface Dataset {
    /**
     * 
     * @type {string}
     * @memberof Dataset
     */
    'label': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Dataset
     */
    'values': Array<number>;
}
/**
 * 
 * @export
 * @interface Discussion
 */
export interface Discussion {
    /**
     * 
     * @type {ForumThread}
     * @memberof Discussion
     */
    'thread': ForumThread;
    /**
     * 
     * @type {Array<DiscussionItem>}
     * @memberof Discussion
     */
    'discussionItems': Array<DiscussionItem>;
}
/**
 * @type DiscussionItem
 * @export
 */
export type DiscussionItem = { discussionItemType: 'ForumThread' } & ForumThread | { discussionItemType: 'ThreadPost' } & ThreadPost;

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'folder'?: string | null;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof Document
     */
    'privacy': PrivacyEnum;
    /**
     * 
     * @type {Array<DocumentPerms>}
     * @memberof Document
     */
    'permissions': Array<DocumentPerms>;
    /**
     * 
     * @type {StatusD10Enum}
     * @memberof Document
     */
    'status'?: StatusD10Enum;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'isPublished': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'isDraft': boolean;
    /**
     * 
     * @type {CRDTDocument}
     * @memberof Document
     */
    'content': CRDTDocument;
    /**
     * 
     * @type {Array<string>}
     * @memberof Document
     */
    'authors': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'modified': string;
    /**
     * 
     * @type {Author}
     * @memberof Document
     */
    'createdBy': Author;
    /**
     * 
     * @type {Author}
     * @memberof Document
     */
    'modifiedBy': Author;
    /**
     * 
     * @type {Author}
     * @memberof Document
     */
    'draftUpdatedBy': Author;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'draftUpdatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'favourite': boolean;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    'latestVersionId': number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'latestVersionAt': string;
    /**
     * 
     * @type {Author}
     * @memberof Document
     */
    'latestVersionBy': Author;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'isSnippet'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Document
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface DocumentFeedback
 */
export interface DocumentFeedback {
    /**
     * 
     * @type {number}
     * @memberof DocumentFeedback
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentFeedback
     */
    'documentVersion': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentFeedback
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentFeedback
     */
    'modified': string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentFeedback
     */
    'isPositive': boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentFeedback
     */
    'anonymousUserId'?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentList
 */
export interface DocumentList {
    /**
     * 
     * @type {string}
     * @memberof DocumentList
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentList
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentList
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentList
     */
    'modified': string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof DocumentList
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {StatusD10Enum}
     * @memberof DocumentList
     */
    'status'?: StatusD10Enum;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentList
     */
    'isPublished': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentList
     */
    'isDraft': boolean;
    /**
     * 
     * @type {Array<Author>}
     * @memberof DocumentList
     */
    'authors': Array<Author>;
    /**
     * 
     * @type {FolderList}
     * @memberof DocumentList
     */
    'folder': FolderList;
    /**
     * 
     * @type {DocumentListFolderItemTypeEnum}
     * @memberof DocumentList
     */
    'folderItemType': DocumentListFolderItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentList
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentList
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentListFolderItemTypeEnum = {
    NestedDocument: 'nested_document'
} as const;

export type DocumentListFolderItemTypeEnum = typeof DocumentListFolderItemTypeEnum[keyof typeof DocumentListFolderItemTypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentPermission = {
    ViewDocument: 'view_document',
    AddDocument: 'add_document',
    ChangeDocument: 'change_document',
    DeleteDocument: 'delete_document'
} as const;

export type DocumentPermission = typeof DocumentPermission[keyof typeof DocumentPermission];


/**
 * 
 * @export
 * @interface DocumentPermissions
 */
export interface DocumentPermissions {
    /**
     * 
     * @type {string}
     * @memberof DocumentPermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<DocumentPermission>}
     * @memberof DocumentPermissions
     */
    'permissions': Array<DocumentPermission> | null;
}
/**
 * 
 * @export
 * @interface DocumentPerms
 */
export interface DocumentPerms {
    /**
     * 
     * @type {string}
     * @memberof DocumentPerms
     */
    'code': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentPerms
     */
    'roles': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentPerms
     */
    'users': Array<string>;
}
/**
 * 
 * @export
 * @interface DocumentSearchResult
 */
export interface DocumentSearchResult {
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'folder': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'section': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'highlightedTitle': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentSearchResult
     */
    'highlightedText': string;
}
/**
 * 
 * @export
 * @interface DocumentWithPermissions
 */
export interface DocumentWithPermissions {
    /**
     * 
     * @type {Document}
     * @memberof DocumentWithPermissions
     */
    'document': Document;
    /**
     * 
     * @type {DocumentPermissions}
     * @memberof DocumentWithPermissions
     */
    'myPermissions': DocumentPermissions;
}
/**
 * * `public` - Public * `open` - Open * `private` - Private * `secret` - Secret
 * @export
 * @enum {string}
 */

export const DocumentsPrivacyEnum = {
    Public: 'public',
    Open: 'open',
    Private: 'private',
    Secret: 'secret'
} as const;

export type DocumentsPrivacyEnum = typeof DocumentsPrivacyEnum[keyof typeof DocumentsPrivacyEnum];


/**
 * 
 * @export
 * @interface Email
 */
export interface Email {
    /**
     * 
     * @type {string}
     * @memberof Email
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EmailVerification
 */
export interface EmailVerification {
    /**
     * 
     * @type {string}
     * @memberof EmailVerification
     */
    'communitySlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailVerification
     */
    'redirectUrl': string;
    /**
     * 
     * @type {string}
     * @memberof EmailVerification
     */
    'baseFrontendUrl': string;
}
/**
 * 
 * @export
 * @interface Escalation
 */
export interface Escalation {
    /**
     * 
     * @type {string}
     * @memberof Escalation
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Escalation
     */
    'ruleMatchReasoning'?: string;
}
/**
 * 
 * @export
 * @interface EscalationRule
 */
export interface EscalationRule {
    /**
     * 
     * @type {number}
     * @memberof EscalationRule
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof EscalationRule
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRule
     */
    'modified': string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRule
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRule
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EscalationRule
     */
    'rule': string;
    /**
     * 
     * @type {boolean}
     * @memberof EscalationRule
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EscalationRule
     */
    'requiresConfirmation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EscalationRule
     */
    'isTriggeredEarly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EscalationRule
     */
    'createdBy': number;
    /**
     * 
     * @type {number}
     * @memberof EscalationRule
     */
    'modifiedBy': number;
    /**
     * 
     * @type {AgentEnum}
     * @memberof EscalationRule
     */
    'agent'?: AgentEnum;
}


/**
 * * `thread.created` - Thread Created * `reply.created` - Reply Created * `direct-reply.created` - Direct Reply Created * `community.member-joined` - Community Member Joined * `thread.reported` - Thread Reported * `reply.reported` - Reply Reported * `mention.created` - Mention Created
 * @export
 * @enum {string}
 */

export const EventEnum = {
    ThreadCreated: 'thread.created',
    ReplyCreated: 'reply.created',
    DirectReplyCreated: 'direct-reply.created',
    CommunityMemberJoined: 'community.member-joined',
    ThreadReported: 'thread.reported',
    ReplyReported: 'reply.reported',
    MentionCreated: 'mention.created'
} as const;

export type EventEnum = typeof EventEnum[keyof typeof EventEnum];


/**
 * 
 * @export
 * @interface Favourite
 */
export interface Favourite {
    /**
     * 
     * @type {string}
     * @memberof Favourite
     */
    'uuid': string;
    /**
     * 
     * @type {FavouriteContentObject}
     * @memberof Favourite
     */
    'contentObject': FavouriteContentObject;
}
/**
 * @type FavouriteContentObject
 * @export
 */
export type FavouriteContentObject = { type: 'document' } & FavouriteDocument | { type: 'forumspace' } & FavouriteForumSpace | { type: 'forumthread' } & FavouriteThread;

/**
 * 
 * @export
 * @interface FavouriteDocument
 */
export interface FavouriteDocument {
    /**
     * 
     * @type {string}
     * @memberof FavouriteDocument
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteDocument
     */
    'title': string;
    /**
     * 
     * @type {FavouriteDocumentTypeEnum}
     * @memberof FavouriteDocument
     */
    'type': FavouriteDocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FavouriteDocument
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteDocument
     */
    'iconDark': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FavouriteDocumentTypeEnum = {
    Document: 'document'
} as const;

export type FavouriteDocumentTypeEnum = typeof FavouriteDocumentTypeEnum[keyof typeof FavouriteDocumentTypeEnum];


/**
 * 
 * @export
 * @interface FavouriteForumSpace
 */
export interface FavouriteForumSpace {
    /**
     * 
     * @type {string}
     * @memberof FavouriteForumSpace
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteForumSpace
     */
    'title': string;
    /**
     * 
     * @type {FavouriteForumSpaceTypeEnum}
     * @memberof FavouriteForumSpace
     */
    'type': FavouriteForumSpaceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FavouriteForumSpace
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteForumSpace
     */
    'iconDark': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FavouriteForumSpaceTypeEnum = {
    Forumspace: 'forumspace'
} as const;

export type FavouriteForumSpaceTypeEnum = typeof FavouriteForumSpaceTypeEnum[keyof typeof FavouriteForumSpaceTypeEnum];


/**
 * 
 * @export
 * @interface FavouriteThread
 */
export interface FavouriteThread {
    /**
     * 
     * @type {string}
     * @memberof FavouriteThread
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteThread
     */
    'title': string;
    /**
     * 
     * @type {FavouriteThreadForumSpace}
     * @memberof FavouriteThread
     */
    'forumSpace': FavouriteThreadForumSpace;
    /**
     * 
     * @type {FavouriteThreadTypeEnum}
     * @memberof FavouriteThread
     */
    'type': FavouriteThreadTypeEnum;
}


/**
 * 
 * @export
 * @interface FavouriteThreadForumSpace
 */
export interface FavouriteThreadForumSpace {
    /**
     * 
     * @type {string}
     * @memberof FavouriteThreadForumSpace
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FavouriteThreadForumSpace
     */
    'title': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FavouriteThreadTypeEnum = {
    Forumthread: 'forumthread'
} as const;

export type FavouriteThreadTypeEnum = typeof FavouriteThreadTypeEnum[keyof typeof FavouriteThreadTypeEnum];


/**
 * 
 * @export
 * @interface Feedback
 */
export interface Feedback {
    /**
     * 
     * @type {number}
     * @memberof Feedback
     */
    'positive': number;
    /**
     * 
     * @type {number}
     * @memberof Feedback
     */
    'negative': number;
}
/**
 * 
 * @export
 * @interface FeedbackCount
 */
export interface FeedbackCount {
    /**
     * 
     * @type {number}
     * @memberof FeedbackCount
     */
    'positive': number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackCount
     */
    'negative': number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackCount
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface Flag
 */
export interface Flag {
    /**
     * 
     * @type {string}
     * @memberof Flag
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Flag
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface FlagToggleSerialiser
 */
export interface FlagToggleSerialiser {
    /**
     * 
     * @type {string}
     * @memberof FlagToggleSerialiser
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Folder
 */
export interface Folder {
    /**
     * 
     * @type {string}
     * @memberof Folder
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Folder
     */
    'title': string;
    /**
     * 
     * @type {CategoryTypeEnum}
     * @memberof Folder
     */
    'categoryType'?: CategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Folder
     */
    'created': string;
    /**
     * 
     * @type {Array<GenericFolderItem>}
     * @memberof Folder
     */
    'items': Array<GenericFolderItem>;
    /**
     * 
     * @type {boolean}
     * @memberof Folder
     */
    'isDefault': boolean;
    /**
     * 
     * @type {string}
     * @memberof Folder
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Folder
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface FolderList
 */
export interface FolderList {
    /**
     * 
     * @type {string}
     * @memberof FolderList
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FolderList
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof FolderList
     */
    'isDefault': boolean;
    /**
     * 
     * @type {CategoryTypeEnum}
     * @memberof FolderList
     */
    'categoryType'?: CategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FolderList
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FolderList
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface FolderPermissions
 */
export interface FolderPermissions {
    /**
     * 
     * @type {string}
     * @memberof FolderPermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FolderPermissions
     */
    'permissions': Array<string> | null;
}
/**
 * 
 * @export
 * @interface FolderWithPermissions
 */
export interface FolderWithPermissions {
    /**
     * 
     * @type {Folder}
     * @memberof FolderWithPermissions
     */
    'folder': Folder;
    /**
     * 
     * @type {FolderPermissions}
     * @memberof FolderWithPermissions
     */
    'myPermissions': FolderPermissions;
    /**
     * 
     * @type {FolderWithPermissionsFolderItemTypeEnum}
     * @memberof FolderWithPermissions
     */
    'folderItemType': FolderWithPermissionsFolderItemTypeEnum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FolderWithPermissionsFolderItemTypeEnum = {
    NestedFolder: 'nested_folder'
} as const;

export type FolderWithPermissionsFolderItemTypeEnum = typeof FolderWithPermissionsFolderItemTypeEnum[keyof typeof FolderWithPermissionsFolderItemTypeEnum];


/**
 * 
 * @export
 * @interface ForumSpace
 */
export interface ForumSpace {
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'publiclyViewable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'solvableThreads'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'threadUpvotesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'postUpvotesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'labelsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'favourite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'viewModeListEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpace
     */
    'viewModeGalleryEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'emoji'?: string | null;
    /**
     * 
     * @type {SpaceType980Enum}
     * @memberof ForumSpace
     */
    'spaceType': SpaceType980Enum;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'spaceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'title': string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof ForumSpace
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<ForumSpacePerm>}
     * @memberof ForumSpace
     */
    'permissions': Array<ForumSpacePerm>;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForumSpace
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface ForumSpaceFull
 */
export interface ForumSpaceFull {
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'publiclyViewable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'solvableThreads'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'threadUpvotesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'postUpvotesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'labelsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'favourite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'viewModeListEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'viewModeGalleryEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'emoji'?: string | null;
    /**
     * 
     * @type {SpaceType980Enum}
     * @memberof ForumSpaceFull
     */
    'spaceType': SpaceType980Enum;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'spaceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'title': string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof ForumSpaceFull
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<ForumSpacePerm>}
     * @memberof ForumSpaceFull
     */
    'permissions': Array<ForumSpacePerm>;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceFull
     */
    'iconDark'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'isSubscribedToActivity': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceFull
     */
    'newActivity': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumSpaceFull
     */
    'highValueNewThreadsCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumSpaceFull
     */
    'highValueNewRepliesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumSpaceFull
     */
    'directRepliesCount': number;
}


/**
 * 
 * @export
 * @interface ForumSpaceNotifications
 */
export interface ForumSpaceNotifications {
    /**
     * 
     * @type {string}
     * @memberof ForumSpaceNotifications
     */
    'uuid': string;
    /**
     * 
     * @type {SpaceType980Enum}
     * @memberof ForumSpaceNotifications
     */
    'spaceType': SpaceType980Enum;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceNotifications
     */
    'isSubscribedToActivity': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumSpaceNotifications
     */
    'newActivity': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumSpaceNotifications
     */
    'highValueNewThreadsCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumSpaceNotifications
     */
    'highValueNewRepliesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumSpaceNotifications
     */
    'directRepliesCount': number;
}


/**
 * 
 * @export
 * @interface ForumSpacePerm
 */
export interface ForumSpacePerm {
    /**
     * 
     * @type {string}
     * @memberof ForumSpacePerm
     */
    'code': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForumSpacePerm
     */
    'roles': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForumSpacePerm
     */
    'users': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ForumSpacePermission = {
    AddForumspace: 'add_forumspace',
    ViewForumspace: 'view_forumspace',
    ChangeForumspace: 'change_forumspace',
    DeleteForumspace: 'delete_forumspace',
    UpvoteThreadForumspace: 'upvote_thread_forumspace',
    UpvotePostForumspace: 'upvote_post_forumspace',
    AddForumthreadForumspace: 'add_forumthread_forumspace',
    ChangeForumthreadForumspace: 'change_forumthread_forumspace',
    DeleteForumthreadForumspace: 'delete_forumthread_forumspace',
    HideForumthreadForumspace: 'hide_forumthread_forumspace',
    MarksolvedForumthreadForumspace: 'marksolved_forumthread_forumspace',
    AddThreadpostForumspace: 'add_threadpost_forumspace',
    DeleteThreadpostForumspace: 'delete_threadpost_forumspace'
} as const;

export type ForumSpacePermission = typeof ForumSpacePermission[keyof typeof ForumSpacePermission];


/**
 * 
 * @export
 * @interface ForumSpacePermissions
 */
export interface ForumSpacePermissions {
    /**
     * 
     * @type {string}
     * @memberof ForumSpacePermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<ForumSpacePermission>}
     * @memberof ForumSpacePermissions
     */
    'permissions': Array<ForumSpacePermission> | null;
}
/**
 * 
 * @export
 * @interface ForumSpaceWithPermissions
 */
export interface ForumSpaceWithPermissions {
    /**
     * 
     * @type {ForumSpaceFull}
     * @memberof ForumSpaceWithPermissions
     */
    'forumSpace': ForumSpaceFull;
    /**
     * 
     * @type {ForumSpacePermissions}
     * @memberof ForumSpaceWithPermissions
     */
    'myPermissions': ForumSpacePermissions;
}
/**
 * 
 * @export
 * @interface ForumThread
 */
export interface ForumThread {
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'text'?: string;
    /**
     * 
     * @type {any}
     * @memberof ForumThread
     */
    'content': any;
    /**
     * 
     * @type {ThreadAuthor}
     * @memberof ForumThread
     */
    'author': ThreadAuthor;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'publiclyViewable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumThread
     */
    'replyCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumThread
     */
    'deletedCount': number;
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'lastRepliedAt': string;
    /**
     * 
     * @type {Array<ReplierSerialiser>}
     * @memberof ForumThread
     */
    'repliers': Array<ReplierSerialiser>;
    /**
     * 
     * @type {Array<Reaction>}
     * @memberof ForumThread
     */
    'reactions': Array<Reaction>;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'isSubscribedToActivity': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'isSubscribedToReplies': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'pinned': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'maximized': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'locked': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumThread
     */
    'directRepliesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumThread
     */
    'newRepliesCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'hidden': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'solved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'solvable': boolean;
    /**
     * 
     * @type {SolutionPost}
     * @memberof ForumThread
     */
    'solution': SolutionPost;
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'solvedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'userUpvoted': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumThread
     */
    'upvoteCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThread
     */
    'favourite': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumThread
     */
    'forumSpace': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForumThread
     */
    'labels': Array<string>;
}
/**
 * 
 * @export
 * @interface ForumThreadAnnotations
 */
export interface ForumThreadAnnotations {
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'text'?: string;
    /**
     * 
     * @type {any}
     * @memberof ForumThreadAnnotations
     */
    'content': any;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'publiclyViewable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'pinned': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'locked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'maximized': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'forumSpace': string;
    /**
     * 
     * @type {ThreadAuthor}
     * @memberof ForumThreadAnnotations
     */
    'author': ThreadAuthor;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'userUpvoted': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadAnnotations
     */
    'upvoteCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'favourite': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForumThreadAnnotations
     */
    'labels': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadAnnotations
     */
    'replyCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'solvable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'solved': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'solvedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadAnnotations
     */
    'deletedCount': number;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadAnnotations
     */
    'lastRepliedAt': string;
    /**
     * 
     * @type {Array<ReplierSerialiser>}
     * @memberof ForumThreadAnnotations
     */
    'repliers': Array<ReplierSerialiser>;
    /**
     * 
     * @type {Array<Reaction>}
     * @memberof ForumThreadAnnotations
     */
    'reactions': Array<Reaction>;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'isSubscribedToActivity': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'isSubscribedToReplies': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadAnnotations
     */
    'directRepliesCount': number;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadAnnotations
     */
    'newRepliesCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadAnnotations
     */
    'hidden': boolean;
    /**
     * 
     * @type {SolutionPost}
     * @memberof ForumThreadAnnotations
     */
    'solution': SolutionPost;
}
/**
 * 
 * @export
 * @interface ForumThreadMainFields
 */
export interface ForumThreadMainFields {
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'lastRepliedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'text': string;
    /**
     * 
     * @type {any}
     * @memberof ForumThreadMainFields
     */
    'content': any;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'publiclyViewable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'pinned': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'maximized': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'locked': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'forumSpace': string;
    /**
     * 
     * @type {ThreadAuthor}
     * @memberof ForumThreadMainFields
     */
    'author': ThreadAuthor;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'userUpvoted': boolean;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadMainFields
     */
    'upvoteCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'favourite': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ForumThreadMainFields
     */
    'labels': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ForumThreadMainFields
     */
    'replyCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'solvable': boolean;
    /**
     * 
     * @type {string}
     * @memberof ForumThreadMainFields
     */
    'solvedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ForumThreadMainFields
     */
    'solved': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ForumThreadPermission = {
    AddForumthread: 'add_forumthread',
    ViewForumthread: 'view_forumthread',
    ChangeForumthread: 'change_forumthread',
    DeleteForumthread: 'delete_forumthread',
    PinForumthread: 'pin_forumthread',
    MaximizeForumthread: 'maximize_forumthread',
    LockForumthread: 'lock_forumthread',
    HideForumthread: 'hide_forumthread',
    MarksolvedForumthread: 'marksolved_forumthread',
    UpvoteForumthread: 'upvote_forumthread',
    AddThreadpostForumthread: 'add_threadpost_forumthread',
    DeleteThreadpostForumthread: 'delete_threadpost_forumthread'
} as const;

export type ForumThreadPermission = typeof ForumThreadPermission[keyof typeof ForumThreadPermission];


/**
 * 
 * @export
 * @interface ForumThreadPermissions
 */
export interface ForumThreadPermissions {
    /**
     * 
     * @type {string}
     * @memberof ForumThreadPermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<ForumThreadPermission>}
     * @memberof ForumThreadPermissions
     */
    'permissions': Array<ForumThreadPermission> | null;
}
/**
 * 
 * @export
 * @interface ForumThreadWithAnnotations
 */
export interface ForumThreadWithAnnotations {
    /**
     * 
     * @type {ForumThreadAnnotations}
     * @memberof ForumThreadWithAnnotations
     */
    'forumThread': ForumThreadAnnotations;
    /**
     * 
     * @type {ForumThreadPermissions}
     * @memberof ForumThreadWithAnnotations
     */
    'myPermissions': ForumThreadPermissions;
}
/**
 * 
 * @export
 * @interface ForumThreadWithPermissions
 */
export interface ForumThreadWithPermissions {
    /**
     * 
     * @type {ForumThread}
     * @memberof ForumThreadWithPermissions
     */
    'forumThread': ForumThread;
    /**
     * 
     * @type {ForumThreadPermissions}
     * @memberof ForumThreadWithPermissions
     */
    'myPermissions': ForumThreadPermissions;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FullAccess = {
    Full: 'full'
} as const;

export type FullAccess = typeof FullAccess[keyof typeof FullAccess];


/**
 * @type GenericFolderItem
 * @export
 */
export type GenericFolderItem = { folderItemType: 'nested_document' } & DocumentList | { folderItemType: 'nested_folder' } & FolderWithPermissions;

/**
 * @type GenericSpace
 * @export
 */
export type GenericSpace = { spaceType: 'custom' } & CustomSpaceList | { spaceType: 'forum' } & ForumSpace | { spaceType: 'group' } & SpaceGroup;

/**
 * @type GenericSpaceNotifications
 * @export
 */
export type GenericSpaceNotifications = { spaceType: 'custom' } & CustomSpaceListNotifications | { spaceType: 'forum' } & ForumSpaceNotifications | { spaceType: 'group' } & SpaceGroupSpaceNotifications;

/**
 * 
 * @export
 * @interface HookEvent
 */
export interface HookEvent {
    /**
     * 
     * @type {string}
     * @memberof HookEvent
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof HookEvent
     */
    'id': string;
}
/**
 * A _fast_ read-only User serialiser.
 * @export
 * @interface HookUser
 */
export interface HookUser {
    /**
     * 
     * @type {string}
     * @memberof HookUser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof HookUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HookUser
     */
    'handle': string;
}
/**
 * 
 * @export
 * @interface Insight
 */
export interface Insight {
    /**
     * 
     * @type {Array<string>}
     * @memberof Insight
     */
    'labels': Array<string>;
    /**
     * 
     * @type {Array<Dataset>}
     * @memberof Insight
     */
    'datasets': Array<Dataset>;
}
/**
 * 
 * @export
 * @interface Intent
 */
export interface Intent {
    /**
     * 
     * @type {string}
     * @memberof Intent
     */
    'uuid': string;
    /**
     * Unique name/identifier for this intent
     * @type {string}
     * @memberof Intent
     */
    'name': string;
    /**
     * Description of what this intent covers
     * @type {string}
     * @memberof Intent
     */
    'description': string;
    /**
     * The policy/instructions for handling this intent
     * @type {string}
     * @memberof Intent
     */
    'policy': string;
    /**
     * 
     * @type {any}
     * @memberof Intent
     */
    'policyJson'?: any;
    /**
     * Whether this intent is currently active
     * @type {boolean}
     * @memberof Intent
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Intent
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Intent
     */
    'modified': string;
    /**
     * 
     * @type {User}
     * @memberof Intent
     */
    'createdBy': User;
    /**
     * 
     * @type {User}
     * @memberof Intent
     */
    'modifiedBy': User;
}
/**
 * 
 * @export
 * @interface IntentWrite
 */
export interface IntentWrite {
    /**
     * Unique name/identifier for this intent
     * @type {string}
     * @memberof IntentWrite
     */
    'name': string;
    /**
     * Description of what this intent covers
     * @type {string}
     * @memberof IntentWrite
     */
    'description': string;
    /**
     * The policy/instructions for handling this intent
     * @type {string}
     * @memberof IntentWrite
     */
    'policy': string;
    /**
     * 
     * @type {any}
     * @memberof IntentWrite
     */
    'policyJson'?: any;
    /**
     * Whether this intent is currently active
     * @type {boolean}
     * @memberof IntentWrite
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface IntercomOauthUrlResponse
 */
export interface IntercomOauthUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof IntercomOauthUrlResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof IntercomOauthUrlResponse
     */
    'oauthUrl': string;
}
/**
 * 
 * @export
 * @interface InviteCodeCheckResponse
 */
export interface InviteCodeCheckResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InviteCodeCheckResponse
     */
    'isValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InviteCodeCheckResponse
     */
    'isAdditive': boolean;
    /**
     * 
     * @type {RoleEnum}
     * @memberof InviteCodeCheckResponse
     */
    'role'?: RoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof InviteCodeCheckResponse
     */
    'isForRequester': boolean;
}


/**
 * 
 * @export
 * @interface InviteMember
 */
export interface InviteMember {
    /**
     * 
     * @type {string}
     * @memberof InviteMember
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface InviteMemberError
 */
export interface InviteMemberError {
    /**
     * 
     * @type {InviteMemberErrorEnum}
     * @memberof InviteMemberError
     */
    'inviteMemberError': InviteMemberErrorEnum;
}


/**
 * * `MEMBER_ALREADY_EXISTS` - Member Already Exists * `TOO_SOON` - Too Soon
 * @export
 * @enum {string}
 */

export const InviteMemberErrorEnum = {
    MemberAlreadyExists: 'MEMBER_ALREADY_EXISTS',
    TooSoon: 'TOO_SOON'
} as const;

export type InviteMemberErrorEnum = typeof InviteMemberErrorEnum[keyof typeof InviteMemberErrorEnum];


/**
 * 
 * @export
 * @interface InviteTeamMember
 */
export interface InviteTeamMember {
    /**
     * 
     * @type {string}
     * @memberof InviteTeamMember
     */
    'email': string;
    /**
     * 
     * @type {RoleEnum}
     * @memberof InviteTeamMember
     */
    'role': RoleEnum;
}


/**
 * 
 * @export
 * @interface InviteTeamMemberError
 */
export interface InviteTeamMemberError {
    /**
     * 
     * @type {InviteTeamMemberErrorEnum}
     * @memberof InviteTeamMemberError
     */
    'inviteTeamMemberError': InviteTeamMemberErrorEnum;
}


/**
 * * `TEAM_MEMBER_ALREADY_EXISTS` - Team Member Already Exists * `ADMIN_ALREADY_EXISTS` - Admin Already Exists * `TOO_SOON` - Too Soon
 * @export
 * @enum {string}
 */

export const InviteTeamMemberErrorEnum = {
    TeamMemberAlreadyExists: 'TEAM_MEMBER_ALREADY_EXISTS',
    AdminAlreadyExists: 'ADMIN_ALREADY_EXISTS',
    TooSoon: 'TOO_SOON'
} as const;

export type InviteTeamMemberErrorEnum = typeof InviteTeamMemberErrorEnum[keyof typeof InviteTeamMemberErrorEnum];


/**
 * 
 * @export
 * @interface LabelSerialiser
 */
export interface LabelSerialiser {
    /**
     * 
     * @type {string}
     * @memberof LabelSerialiser
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof LabelSerialiser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LabelSerialiser
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof LabelSerialiser
     */
    'uuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LabelSerialiser
     */
    'teamOnly'?: boolean;
}
/**
 * Metadata verification serializer for the user viewset.
 * @export
 * @interface MetadataVerification
 */
export interface MetadataVerification {
    /**
     * 
     * @type {string}
     * @memberof MetadataVerification
     */
    'community': string;
    /**
     * 
     * @type {string}
     * @memberof MetadataVerification
     */
    'metadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataVerification
     */
    'signature'?: string;
}
/**
 * 
 * @export
 * @interface NotificationChannelPreference
 */
export interface NotificationChannelPreference {
    /**
     * 
     * @type {EventEnum}
     * @memberof NotificationChannelPreference
     */
    'event': EventEnum;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationChannelPreference
     */
    'email'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationChannelPreference
     */
    'slack'?: boolean;
}


/**
 * 
 * @export
 * @interface NotificationChannelPreferences
 */
export interface NotificationChannelPreferences {
    /**
     * 
     * @type {Array<NotificationChannelPreference>}
     * @memberof NotificationChannelPreferences
     */
    'channelPreferences': Array<NotificationChannelPreference>;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationChannelPreferences
     */
    'hasSlackOauth': boolean;
}
/**
 * 
 * @export
 * @interface OpenGraph
 */
export interface OpenGraph {
    /**
     * 
     * @type {string}
     * @memberof OpenGraph
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenGraph
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenGraph
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OpenGraph
     */
    'image'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OpenGraph
     */
    'imageWidth'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OpenGraph
     */
    'imageHeight'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Ordering
 */
export interface Ordering {
    /**
     * 
     * @type {string}
     * @memberof Ordering
     */
    'uuid': string;
    /**
     * 
     * @type {number}
     * @memberof Ordering
     */
    'order': number;
}
/**
 * 
 * @export
 * @interface Organisation
 */
export interface Organisation {
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'modified': string;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'logoImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Organisation
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof Organisation
     */
    'admins': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Organisation
     */
    'communities': Array<number>;
}
/**
 * 
 * @export
 * @interface PaginatedChangelogEntryList
 */
export interface PaginatedChangelogEntryList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedChangelogEntryList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedChangelogEntryList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedChangelogEntryList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ChangelogEntry>}
     * @memberof PaginatedChangelogEntryList
     */
    'results': Array<ChangelogEntry>;
}
/**
 * 
 * @export
 * @interface PaginatedCommunityFullList
 */
export interface PaginatedCommunityFullList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCommunityFullList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunityFullList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunityFullList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CommunityFull>}
     * @memberof PaginatedCommunityFullList
     */
    'results': Array<CommunityFull>;
}
/**
 * 
 * @export
 * @interface PaginatedCommunityInvitationList
 */
export interface PaginatedCommunityInvitationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCommunityInvitationList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunityInvitationList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunityInvitationList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CommunityInvitation>}
     * @memberof PaginatedCommunityInvitationList
     */
    'results': Array<CommunityInvitation>;
}
/**
 * 
 * @export
 * @interface PaginatedCommunityList
 */
export interface PaginatedCommunityList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCommunityList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunityList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunityList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Community>}
     * @memberof PaginatedCommunityList
     */
    'results': Array<Community>;
}
/**
 * 
 * @export
 * @interface PaginatedCommunitySEOSerialiserList
 */
export interface PaginatedCommunitySEOSerialiserList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCommunitySEOSerialiserList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunitySEOSerialiserList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunitySEOSerialiserList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CommunitySEOSerialiser>}
     * @memberof PaginatedCommunitySEOSerialiserList
     */
    'results': Array<CommunitySEOSerialiser>;
}
/**
 * 
 * @export
 * @interface PaginatedCommunitySignUpRequestList
 */
export interface PaginatedCommunitySignUpRequestList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCommunitySignUpRequestList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunitySignUpRequestList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCommunitySignUpRequestList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<CommunitySignUpRequest>}
     * @memberof PaginatedCommunitySignUpRequestList
     */
    'results': Array<CommunitySignUpRequest>;
}
/**
 * 
 * @export
 * @interface PaginatedContentLinkListItemList
 */
export interface PaginatedContentLinkListItemList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedContentLinkListItemList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContentLinkListItemList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContentLinkListItemList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ContentLinkListItem>}
     * @memberof PaginatedContentLinkListItemList
     */
    'results': Array<ContentLinkListItem>;
}
/**
 * 
 * @export
 * @interface PaginatedContentSearchResultList
 */
export interface PaginatedContentSearchResultList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedContentSearchResultList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContentSearchResultList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContentSearchResultList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ContentSearchResult>}
     * @memberof PaginatedContentSearchResultList
     */
    'results': Array<ContentSearchResult>;
}
/**
 * 
 * @export
 * @interface PaginatedDocumentList
 */
export interface PaginatedDocumentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDocumentList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDocumentList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDocumentList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof PaginatedDocumentList
     */
    'results': Array<Document>;
}
/**
 * 
 * @export
 * @interface PaginatedDocumentSearchResultList
 */
export interface PaginatedDocumentSearchResultList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedDocumentSearchResultList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDocumentSearchResultList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedDocumentSearchResultList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<DocumentSearchResult>}
     * @memberof PaginatedDocumentSearchResultList
     */
    'results': Array<DocumentSearchResult>;
}
/**
 * 
 * @export
 * @interface PaginatedEscalationRuleList
 */
export interface PaginatedEscalationRuleList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedEscalationRuleList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEscalationRuleList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEscalationRuleList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<EscalationRule>}
     * @memberof PaginatedEscalationRuleList
     */
    'results': Array<EscalationRule>;
}
/**
 * 
 * @export
 * @interface PaginatedFavouriteList
 */
export interface PaginatedFavouriteList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedFavouriteList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFavouriteList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFavouriteList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Favourite>}
     * @memberof PaginatedFavouriteList
     */
    'results': Array<Favourite>;
}
/**
 * 
 * @export
 * @interface PaginatedForumSpaceWithPermissionsList
 */
export interface PaginatedForumSpaceWithPermissionsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedForumSpaceWithPermissionsList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedForumSpaceWithPermissionsList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedForumSpaceWithPermissionsList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ForumSpaceWithPermissions>}
     * @memberof PaginatedForumSpaceWithPermissionsList
     */
    'results': Array<ForumSpaceWithPermissions>;
}
/**
 * 
 * @export
 * @interface PaginatedForumThreadMainFieldsList
 */
export interface PaginatedForumThreadMainFieldsList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedForumThreadMainFieldsList
     */
    'nextCursor'?: string | null;
    /**
     * 
     * @type {Array<ForumThreadMainFields>}
     * @memberof PaginatedForumThreadMainFieldsList
     */
    'results'?: Array<ForumThreadMainFields>;
}
/**
 * 
 * @export
 * @interface PaginatedForumThreadWithAnnotationsList
 */
export interface PaginatedForumThreadWithAnnotationsList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedForumThreadWithAnnotationsList
     */
    'nextCursor'?: string | null;
    /**
     * 
     * @type {Array<ForumThreadWithAnnotations>}
     * @memberof PaginatedForumThreadWithAnnotationsList
     */
    'results'?: Array<ForumThreadWithAnnotations>;
}
/**
 * 
 * @export
 * @interface PaginatedIntentList
 */
export interface PaginatedIntentList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedIntentList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedIntentList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedIntentList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Intent>}
     * @memberof PaginatedIntentList
     */
    'results': Array<Intent>;
}
/**
 * 
 * @export
 * @interface PaginatedLabelSerialiserList
 */
export interface PaginatedLabelSerialiserList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedLabelSerialiserList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLabelSerialiserList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLabelSerialiserList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<LabelSerialiser>}
     * @memberof PaginatedLabelSerialiserList
     */
    'results': Array<LabelSerialiser>;
}
/**
 * 
 * @export
 * @interface PaginatedOrganisationList
 */
export interface PaginatedOrganisationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedOrganisationList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedOrganisationList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedOrganisationList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Organisation>}
     * @memberof PaginatedOrganisationList
     */
    'results': Array<Organisation>;
}
/**
 * 
 * @export
 * @interface PaginatedPostSearchResultList
 */
export interface PaginatedPostSearchResultList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPostSearchResultList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPostSearchResultList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPostSearchResultList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PostSearchResult>}
     * @memberof PaginatedPostSearchResultList
     */
    'results': Array<PostSearchResult>;
}
/**
 * 
 * @export
 * @interface PaginatedPrivateWriteUserList
 */
export interface PaginatedPrivateWriteUserList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPrivateWriteUserList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPrivateWriteUserList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPrivateWriteUserList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<PrivateWriteUser>}
     * @memberof PaginatedPrivateWriteUserList
     */
    'results': Array<PrivateWriteUser>;
}
/**
 * 
 * @export
 * @interface PaginatedSessionList
 */
export interface PaginatedSessionList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSessionList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSessionList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSessionList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Session>}
     * @memberof PaginatedSessionList
     */
    'results': Array<Session>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSessionList
     */
    'traceCount': number;
}
/**
 * 
 * @export
 * @interface PaginatedSpaceGroupList
 */
export interface PaginatedSpaceGroupList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSpaceGroupList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSpaceGroupList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSpaceGroupList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<SpaceGroup>}
     * @memberof PaginatedSpaceGroupList
     */
    'results': Array<SpaceGroup>;
}
/**
 * 
 * @export
 * @interface PaginatedSpaceGroupWithNotificationsList
 */
export interface PaginatedSpaceGroupWithNotificationsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSpaceGroupWithNotificationsList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSpaceGroupWithNotificationsList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSpaceGroupWithNotificationsList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<SpaceGroupWithNotifications>}
     * @memberof PaginatedSpaceGroupWithNotificationsList
     */
    'results': Array<SpaceGroupWithNotifications>;
}
/**
 * 
 * @export
 * @interface PaginatedSpaceGroupWithPermissionsList
 */
export interface PaginatedSpaceGroupWithPermissionsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSpaceGroupWithPermissionsList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSpaceGroupWithPermissionsList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSpaceGroupWithPermissionsList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<SpaceGroupWithPermissions>}
     * @memberof PaginatedSpaceGroupWithPermissionsList
     */
    'results': Array<SpaceGroupWithPermissions>;
}
/**
 * 
 * @export
 * @interface PaginatedThreadPostWithPermissionsList
 */
export interface PaginatedThreadPostWithPermissionsList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedThreadPostWithPermissionsList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedThreadPostWithPermissionsList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedThreadPostWithPermissionsList
     */
    'nextCursor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedThreadPostWithPermissionsList
     */
    'previousCursor'?: string | null;
    /**
     * 
     * @type {Array<ThreadPostWithPermissions>}
     * @memberof PaginatedThreadPostWithPermissionsList
     */
    'results'?: Array<ThreadPostWithPermissions>;
}
/**
 * 
 * @export
 * @interface PaginatedThreadSearchResultList
 */
export interface PaginatedThreadSearchResultList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedThreadSearchResultList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedThreadSearchResultList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedThreadSearchResultList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<ThreadSearchResult>}
     * @memberof PaginatedThreadSearchResultList
     */
    'results': Array<ThreadSearchResult>;
}
/**
 * 
 * @export
 * @interface PaginatedToolList
 */
export interface PaginatedToolList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedToolList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedToolList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedToolList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<Tool>}
     * @memberof PaginatedToolList
     */
    'results': Array<Tool>;
}
/**
 * 
 * @export
 * @interface PaginatedTraceFeedbackList
 */
export interface PaginatedTraceFeedbackList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedTraceFeedbackList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceFeedbackList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedTraceFeedbackList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<TraceFeedback>}
     * @memberof PaginatedTraceFeedbackList
     */
    'results': Array<TraceFeedback>;
}
/**
 * 
 * @export
 * @interface PaginatedUserList
 */
export interface PaginatedUserList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUserList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUserList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUserList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<User>}
     * @memberof PaginatedUserList
     */
    'results': Array<User>;
}
/**
 * 
 * @export
 * @interface PaginatedUserSessionList
 */
export interface PaginatedUserSessionList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUserSessionList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUserSessionList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUserSessionList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<UserSession>}
     * @memberof PaginatedUserSessionList
     */
    'results': Array<UserSession>;
}
/**
 * 
 * @export
 * @interface PaginatedWebHookList
 */
export interface PaginatedWebHookList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedWebHookList
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedWebHookList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedWebHookList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<WebHook>}
     * @memberof PaginatedWebHookList
     */
    'results': Array<WebHook>;
}
/**
 * 
 * @export
 * @interface PatchedChangelogEntryWrite
 */
export interface PatchedChangelogEntryWrite {
    /**
     * 
     * @type {string}
     * @memberof PatchedChangelogEntryWrite
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedChangelogEntryWrite
     */
    'summary'?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedChangelogEntryWrite
     */
    'content'?: any;
    /**
     * 
     * @type {string}
     * @memberof PatchedChangelogEntryWrite
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedChangelogEntryWrite
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedChangelogEntryWrite
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedChangelogEntryWrite
     */
    'image'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchedCommunityCRM
 */
export interface PatchedCommunityCRM {
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'companyProductName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'currentDocTool'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'sendUpdates'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'aspirations'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'usedDiscord'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'usedSlack'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'usedDiscourse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'usedFacebook'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'usedOther'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityCRM
     */
    'usedNone'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityCRM
     */
    'planSelected'?: string;
}
/**
 * 
 * @export
 * @interface PatchedCommunityFull
 */
export interface PatchedCommunityFull {
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'logoImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'primaryColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'backgroundColorDark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'coverImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'about'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'indexable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'gtmId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isMemberDirectoryShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isEventCalendarShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isDocumentsEnabled'?: boolean;
    /**
     * 
     * @type {DocumentsPrivacyEnum}
     * @memberof PatchedCommunityFull
     */
    'documentsPrivacy'?: DocumentsPrivacyEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'documentsName'?: string;
    /**
     * 
     * @type {FullAccess}
     * @memberof PatchedCommunityFull
     */
    'accessType'?: FullAccess;
    /**
     * hybrid property-ish: if `member_count` was previously set (by queryset) use it, otherwise calculate it.
     * @type {number}
     * @memberof PatchedCommunityFull
     */
    'memberCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isContentLibraryEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'contentLibraryTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isExternalLinkShown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLinkUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLinkTag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLinkImage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isExternalLink2Shown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLink2Url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLink2Tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLink2Image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isExternalLink3Shown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLink3Url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLink3Tag'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'externalLink3Image'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isCommunityEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'communitySectionName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isChangelogEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isAskAiTeamOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'changelogVisible'?: boolean;
    /**
     * 
     * @type {Array<Flag>}
     * @memberof PatchedCommunityFull
     */
    'flags'?: Array<Flag>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'docsVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isForumsFullWidth'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isChangelogExpanded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isSemanticRelationShown'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'isDocMetadataShown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'changelogDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetAgentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetFooter'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetAccentColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetLogo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetButtonText'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetCustomActionLabel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'widgetCustomActionPrompt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'zendeskSubdomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityFull
     */
    'modified'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'zendeskIntegrationEnabled'?: boolean;
    /**
     * Returns True if the community has Zendesk chat integration configured. This is determined by whether the zendesk_conversation_app_key_id is set.
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'zendeskChatEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityFull
     */
    'intercomIntegrationEnabled'?: boolean;
}


/**
 * 
 * @export
 * @interface PatchedCommunityRole
 */
export interface PatchedCommunityRole {
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityRole
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityRole
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityRole
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCommunityRole
     */
    'created'?: string;
    /**
     * 
     * @type {Array<PermsGroupingsEnum>}
     * @memberof PatchedCommunityRole
     */
    'permsGroupings'?: Array<PermsGroupingsEnum>;
    /**
     * 
     * @type {Array<User>}
     * @memberof PatchedCommunityRole
     */
    'users'?: Array<User>;
    /**
     * 
     * @type {number}
     * @memberof PatchedCommunityRole
     */
    'usersCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityRole
     */
    'isCommunityMembers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityRole
     */
    'isCommunityAdmins'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedCommunityRole
     */
    'isCommunityTeam'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedContentLink
 */
export interface PatchedContentLink {
    /**
     * 
     * @type {string}
     * @memberof PatchedContentLink
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedContentLink
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedContentLink
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedContentLink
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedContentLink
     */
    'description'?: string;
    /**
     * 
     * @type {ContentLinkType}
     * @memberof PatchedContentLink
     */
    'type'?: ContentLinkType;
}


/**
 * 
 * @export
 * @interface PatchedCustomSpace
 */
export interface PatchedCustomSpace {
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'emoji'?: string | null;
    /**
     * 
     * @type {SpaceTypeC91Enum}
     * @memberof PatchedCustomSpace
     */
    'spaceType'?: SpaceTypeC91Enum;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'spaceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'title'?: string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof PatchedCustomSpace
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<CustomSpacePerms>}
     * @memberof PatchedCustomSpace
     */
    'permissions'?: Array<CustomSpacePerms>;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'iconDark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'crdt'?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedCustomSpace
     */
    'json'?: any;
    /**
     * 
     * @type {string}
     * @memberof PatchedCustomSpace
     */
    'text'?: string;
}


/**
 * 
 * @export
 * @interface PatchedDocument
 */
export interface PatchedDocument {
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'folder'?: string | null;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof PatchedDocument
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<DocumentPerms>}
     * @memberof PatchedDocument
     */
    'permissions'?: Array<DocumentPerms>;
    /**
     * 
     * @type {StatusD10Enum}
     * @memberof PatchedDocument
     */
    'status'?: StatusD10Enum;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedDocument
     */
    'isPublished'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedDocument
     */
    'isDraft'?: boolean;
    /**
     * 
     * @type {CRDTDocument}
     * @memberof PatchedDocument
     */
    'content'?: CRDTDocument;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedDocument
     */
    'authors'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'modified'?: string;
    /**
     * 
     * @type {Author}
     * @memberof PatchedDocument
     */
    'createdBy'?: Author;
    /**
     * 
     * @type {Author}
     * @memberof PatchedDocument
     */
    'modifiedBy'?: Author;
    /**
     * 
     * @type {Author}
     * @memberof PatchedDocument
     */
    'draftUpdatedBy'?: Author;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'draftUpdatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedDocument
     */
    'favourite'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedDocument
     */
    'latestVersionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'latestVersionAt'?: string;
    /**
     * 
     * @type {Author}
     * @memberof PatchedDocument
     */
    'latestVersionBy'?: Author;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedDocument
     */
    'isSnippet'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedDocument
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedDocument
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface PatchedEscalationRule
 */
export interface PatchedEscalationRule {
    /**
     * 
     * @type {number}
     * @memberof PatchedEscalationRule
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedEscalationRule
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEscalationRule
     */
    'modified'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEscalationRule
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEscalationRule
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedEscalationRule
     */
    'rule'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEscalationRule
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEscalationRule
     */
    'requiresConfirmation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedEscalationRule
     */
    'isTriggeredEarly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedEscalationRule
     */
    'createdBy'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedEscalationRule
     */
    'modifiedBy'?: number;
    /**
     * 
     * @type {AgentEnum}
     * @memberof PatchedEscalationRule
     */
    'agent'?: AgentEnum;
}


/**
 * 
 * @export
 * @interface PatchedFolder
 */
export interface PatchedFolder {
    /**
     * 
     * @type {string}
     * @memberof PatchedFolder
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedFolder
     */
    'title'?: string;
    /**
     * 
     * @type {CategoryTypeEnum}
     * @memberof PatchedFolder
     */
    'categoryType'?: CategoryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchedFolder
     */
    'created'?: string;
    /**
     * 
     * @type {Array<GenericFolderItem>}
     * @memberof PatchedFolder
     */
    'items'?: Array<GenericFolderItem>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedFolder
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedFolder
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedFolder
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface PatchedForumSpace
 */
export interface PatchedForumSpace {
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'publiclyViewable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'solvableThreads'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'threadUpvotesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'postUpvotesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'labelsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'favourite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'viewModeListEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumSpace
     */
    'viewModeGalleryEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'emoji'?: string | null;
    /**
     * 
     * @type {SpaceType980Enum}
     * @memberof PatchedForumSpace
     */
    'spaceType'?: SpaceType980Enum;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'spaceGroup'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'title'?: string;
    /**
     * 
     * @type {PrivacyEnum}
     * @memberof PatchedForumSpace
     */
    'privacy'?: PrivacyEnum;
    /**
     * 
     * @type {Array<ForumSpacePerm>}
     * @memberof PatchedForumSpace
     */
    'permissions'?: Array<ForumSpacePerm>;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'icon'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumSpace
     */
    'iconDark'?: string | null;
}


/**
 * 
 * @export
 * @interface PatchedForumThread
 */
export interface PatchedForumThread {
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'text'?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedForumThread
     */
    'content'?: any;
    /**
     * 
     * @type {ThreadAuthor}
     * @memberof PatchedForumThread
     */
    'author'?: ThreadAuthor;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'publiclyViewable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedForumThread
     */
    'replyCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedForumThread
     */
    'deletedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'lastRepliedAt'?: string;
    /**
     * 
     * @type {Array<ReplierSerialiser>}
     * @memberof PatchedForumThread
     */
    'repliers'?: Array<ReplierSerialiser>;
    /**
     * 
     * @type {Array<Reaction>}
     * @memberof PatchedForumThread
     */
    'reactions'?: Array<Reaction>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'isSubscribedToActivity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'isSubscribedToReplies'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'pinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'maximized'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'locked'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedForumThread
     */
    'directRepliesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedForumThread
     */
    'newRepliesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'hidden'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'solved'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'solvable'?: boolean;
    /**
     * 
     * @type {SolutionPost}
     * @memberof PatchedForumThread
     */
    'solution'?: SolutionPost;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'solvedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'userUpvoted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedForumThread
     */
    'upvoteCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedForumThread
     */
    'favourite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedForumThread
     */
    'forumSpace'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedForumThread
     */
    'labels'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatchedIntentWrite
 */
export interface PatchedIntentWrite {
    /**
     * Unique name/identifier for this intent
     * @type {string}
     * @memberof PatchedIntentWrite
     */
    'name'?: string;
    /**
     * Description of what this intent covers
     * @type {string}
     * @memberof PatchedIntentWrite
     */
    'description'?: string;
    /**
     * The policy/instructions for handling this intent
     * @type {string}
     * @memberof PatchedIntentWrite
     */
    'policy'?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchedIntentWrite
     */
    'policyJson'?: any;
    /**
     * Whether this intent is currently active
     * @type {boolean}
     * @memberof PatchedIntentWrite
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedLabelSerialiser
 */
export interface PatchedLabelSerialiser {
    /**
     * 
     * @type {string}
     * @memberof PatchedLabelSerialiser
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedLabelSerialiser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedLabelSerialiser
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedLabelSerialiser
     */
    'uuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedLabelSerialiser
     */
    'teamOnly'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchedNotificationChannelPreference
 */
export interface PatchedNotificationChannelPreference {
    /**
     * 
     * @type {EventEnum}
     * @memberof PatchedNotificationChannelPreference
     */
    'event'?: EventEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedNotificationChannelPreference
     */
    'email'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedNotificationChannelPreference
     */
    'slack'?: boolean;
}


/**
 * 
 * @export
 * @interface PatchedOrganisation
 */
export interface PatchedOrganisation {
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganisation
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganisation
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganisation
     */
    'modified'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganisation
     */
    'logoImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganisation
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedOrganisation
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedOrganisation
     */
    'admins'?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof PatchedOrganisation
     */
    'communities'?: Array<number>;
}
/**
 * Inlined as it is a private user serialiser and should be used with caution. Inherits ModelSerializer for validation on write.
 * @export
 * @interface PatchedPrivateWriteUser
 */
export interface PatchedPrivateWriteUser {
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'handle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'profileImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'profileColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'bio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'headline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'github'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'linkedin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPrivateWriteUser
     */
    'location'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PatchedPrivateWriteUser
     */
    'preferences'?: any;
}
/**
 * 
 * @export
 * @interface PatchedSpaceGroup
 */
export interface PatchedSpaceGroup {
    /**
     * 
     * @type {string}
     * @memberof PatchedSpaceGroup
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedSpaceGroup
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedSpaceGroup
     */
    'created'?: string;
    /**
     * 
     * @type {Array<GenericSpace>}
     * @memberof PatchedSpaceGroup
     */
    'spaces'?: Array<GenericSpace>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedSpaceGroup
     */
    'isDefault'?: boolean;
    /**
     * 
     * @type {SpaceType312Enum}
     * @memberof PatchedSpaceGroup
     */
    'spaceType'?: SpaceType312Enum;
}


/**
 * 
 * @export
 * @interface PatchedThreadPost
 */
export interface PatchedThreadPost {
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'modified'?: string;
    /**
     * 
     * @type {ThreadAuthor}
     * @memberof PatchedThreadPost
     */
    'author'?: ThreadAuthor;
    /**
     * 
     * @type {number}
     * @memberof PatchedThreadPost
     */
    'seqNum'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedThreadPost
     */
    'isRemoved'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PatchedThreadPost
     */
    'content'?: any;
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'parentIsRemoved'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'replyToPostUuid'?: string | null;
    /**
     * 
     * @type {User}
     * @memberof PatchedThreadPost
     */
    'replyToPostAuthor'?: User | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedThreadPost
     */
    'repliesCount'?: number;
    /**
     * 
     * @type {Array<Reaction>}
     * @memberof PatchedThreadPost
     */
    'reactions'?: Array<Reaction>;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedThreadPost
     */
    'userUpvoted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedThreadPost
     */
    'upvoteCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedThreadPost
     */
    'thread'?: string;
}
/**
 * 
 * @export
 * @interface PatchedTraceFeedback
 */
export interface PatchedTraceFeedback {
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceFeedback
     */
    'trace'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedTraceFeedback
     */
    'comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedTraceFeedback
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface PatchedUserId
 */
export interface PatchedUserId {
    /**
     * 
     * @type {string}
     * @memberof PatchedUserId
     */
    'id'?: string;
}
/**
 * 
 * @export
 * @interface PatchedWebHook
 */
export interface PatchedWebHook {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchedWebHook
     */
    'events'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatchedWebHook
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedWebHook
     */
    'target'?: string;
    /**
     * 
     * @type {HookUser}
     * @memberof PatchedWebHook
     */
    'user'?: HookUser;
    /**
     * 
     * @type {string}
     * @memberof PatchedWebHook
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedWebHook
     */
    'created'?: string;
}
/**
 * * `manage_community` - Manage Community * `manage_forum_spaces` - Manage Forum Space * `invite_members` - Invite Members * `view_knowledge_base` - View Knowledge Base
 * @export
 * @enum {string}
 */

export const PermsGroupingsEnum = {
    ManageCommunity: 'manage_community',
    ManageForumSpaces: 'manage_forum_spaces',
    InviteMembers: 'invite_members',
    ViewKnowledgeBase: 'view_knowledge_base'
} as const;

export type PermsGroupingsEnum = typeof PermsGroupingsEnum[keyof typeof PermsGroupingsEnum];


/**
 * 
 * @export
 * @interface PostSearchResult
 */
export interface PostSearchResult {
    /**
     * 
     * @type {string}
     * @memberof PostSearchResult
     */
    'seqNum': string;
    /**
     * 
     * @type {User}
     * @memberof PostSearchResult
     */
    'author': User;
    /**
     * 
     * @type {string}
     * @memberof PostSearchResult
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchResult
     */
    'highlightedText': string;
    /**
     * 
     * @type {PostSearchResultEmbeddedThread}
     * @memberof PostSearchResult
     */
    'thread': PostSearchResultEmbeddedThread;
    /**
     * 
     * @type {BasePostSearchResult}
     * @memberof PostSearchResult
     */
    'replyToPost': BasePostSearchResult;
}
/**
 * 
 * @export
 * @interface PostSearchResultEmbeddedThread
 */
export interface PostSearchResultEmbeddedThread {
    /**
     * 
     * @type {string}
     * @memberof PostSearchResultEmbeddedThread
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchResultEmbeddedThread
     */
    'title': string;
    /**
     * 
     * @type {SearchResultEmbeddedForumSpace}
     * @memberof PostSearchResultEmbeddedThread
     */
    'forumSpace': SearchResultEmbeddedForumSpace;
    /**
     * 
     * @type {User}
     * @memberof PostSearchResultEmbeddedThread
     */
    'author': User;
}
/**
 * 
 * @export
 * @interface PreviousSessionList
 */
export interface PreviousSessionList {
    /**
     * 
     * @type {string}
     * @memberof PreviousSessionList
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PreviousSessionList
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PreviousSessionList
     */
    'created': string;
}
/**
 * * `public` - Public * `open` - Open * `private` - Private * `secret` - Secret
 * @export
 * @enum {string}
 */

export const PrivacyEnum = {
    Public: 'public',
    Open: 'open',
    Private: 'private',
    Secret: 'secret'
} as const;

export type PrivacyEnum = typeof PrivacyEnum[keyof typeof PrivacyEnum];


/**
 * Inlined as it is a private user serialiser and should be used with caution. Inherits ModelSerializer for validation on write.
 * @export
 * @interface PrivateWriteUser
 */
export interface PrivateWriteUser {
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'handle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'profileImage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'profileColor'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'bio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'headline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'github'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'linkedin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrivateWriteUser
     */
    'location'?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PrivateWriteUser
     */
    'preferences'?: any;
}
/**
 * 
 * @export
 * @interface Prompt
 */
export interface Prompt {
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    'text'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Prompt
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Prompt
     */
    'agent'?: string;
    /**
     * 
     * @type {CopilotConfig}
     * @memberof Prompt
     */
    'copilotConfig'?: CopilotConfig;
}
/**
 * A minimal user for showing reaction info.
 * @export
 * @interface Reacters
 */
export interface Reacters {
    /**
     * 
     * @type {string}
     * @memberof Reacters
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Reacters
     */
    'handle': string;
}
/**
 * 
 * @export
 * @interface Reaction
 */
export interface Reaction {
    /**
     * 
     * @type {string}
     * @memberof Reaction
     */
    'emoji': string;
    /**
     * 
     * @type {number}
     * @memberof Reaction
     */
    'count': number;
    /**
     * 
     * @type {boolean}
     * @memberof Reaction
     */
    'userReacted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Reaction
     */
    'userReactedUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Reaction
     */
    'created': string;
    /**
     * 
     * @type {Array<Reacters>}
     * @memberof Reaction
     */
    'reacters': Array<Reacters>;
}
/**
 * 
 * @export
 * @interface ReactionCreateSerialiser
 */
export interface ReactionCreateSerialiser {
    /**
     * 
     * @type {string}
     * @memberof ReactionCreateSerialiser
     */
    'emoji': string;
}
/**
 * A _fast_ read-only User serialiser.
 * @export
 * @interface ReplierSerialiser
 */
export interface ReplierSerialiser {
    /**
     * 
     * @type {string}
     * @memberof ReplierSerialiser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ReplierSerialiser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReplierSerialiser
     */
    'handle': string;
    /**
     * 
     * @type {string}
     * @memberof ReplierSerialiser
     */
    'profileImage': string;
    /**
     * 
     * @type {string}
     * @memberof ReplierSerialiser
     */
    'profileColor': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RestrictedAccess = {
    Restricted: 'restricted'
} as const;

export type RestrictedAccess = typeof RestrictedAccess[keyof typeof RestrictedAccess];


/**
 * * `admin` - Admin * `team` - Team
 * @export
 * @enum {string}
 */

export const RoleEnum = {
    Admin: 'admin',
    Team: 'team'
} as const;

export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


/**
 * 
 * @export
 * @interface RoleSerialiser
 */
export interface RoleSerialiser {
    /**
     * 
     * @type {string}
     * @memberof RoleSerialiser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof RoleSerialiser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RoleSerialiser
     */
    'color': string;
    /**
     * 
     * @type {boolean}
     * @memberof RoleSerialiser
     */
    'isMembers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleSerialiser
     */
    'isTeam': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RoleSerialiser
     */
    'isAdmins': boolean;
}
/**
 * 
 * @export
 * @interface SearchResultEmbeddedForumSpace
 */
export interface SearchResultEmbeddedForumSpace {
    /**
     * 
     * @type {string}
     * @memberof SearchResultEmbeddedForumSpace
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultEmbeddedForumSpace
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultEmbeddedForumSpace
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultEmbeddedForumSpace
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultEmbeddedForumSpace
     */
    'iconDark': string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultEmbeddedForumSpace
     */
    'solvableThreads': boolean;
}
/**
 * 
 * @export
 * @interface SemanticRelations
 */
export interface SemanticRelations {
    /**
     * 
     * @type {Array<Document>}
     * @memberof SemanticRelations
     */
    'documents': Array<Document>;
    /**
     * 
     * @type {Array<Discussion>}
     * @memberof SemanticRelations
     */
    'discussions': Array<Discussion>;
}
/**
 * 
 * @export
 * @interface Session
 */
export interface Session {
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    'title': string;
    /**
     * 
     * @type {SessionUser}
     * @memberof Session
     */
    'user': SessionUser;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    'created': string;
    /**
     * 
     * @type {boolean}
     * @memberof Session
     */
    'escalated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Session
     */
    'audited': boolean;
    /**
     * 
     * @type {SessionUser}
     * @memberof Session
     */
    'auditedBy': SessionUser;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    'auditedAt': string;
    /**
     * 
     * @type {string}
     * @memberof Session
     */
    'status'?: string;
    /**
     * 
     * @type {number}
     * @memberof Session
     */
    'traceCount': number;
}
/**
 * Serializes aggregate analytics for chat sessions and traces in nested format.
 * @export
 * @interface SessionAnalytics
 */
export interface SessionAnalytics {
    /**
     * 
     * @type {SessionStats}
     * @memberof SessionAnalytics
     */
    'sessions': SessionStats;
    /**
     * 
     * @type {TraceStats}
     * @memberof SessionAnalytics
     */
    'traces': TraceStats;
}
/**
 * 
 * @export
 * @interface SessionDetail
 */
export interface SessionDetail {
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'title': string;
    /**
     * 
     * @type {SourceEnum}
     * @memberof SessionDetail
     */
    'source': SourceEnum;
    /**
     * 
     * @type {SessionUser}
     * @memberof SessionDetail
     */
    'user': SessionUser;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'created': string;
    /**
     * 
     * @type {Feedback}
     * @memberof SessionDetail
     */
    'feedback': Feedback;
    /**
     * 
     * @type {boolean}
     * @memberof SessionDetail
     */
    'escalated': boolean;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'escalationReason': string;
    /**
     * 
     * @type {EscalationRule}
     * @memberof SessionDetail
     */
    'escalationRule'?: EscalationRule;
    /**
     * 
     * @type {boolean}
     * @memberof SessionDetail
     */
    'audited': boolean;
    /**
     * 
     * @type {SessionUser}
     * @memberof SessionDetail
     */
    'auditedBy': SessionUser;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'auditedAt': string;
    /**
     * 
     * @type {Array<Trace>}
     * @memberof SessionDetail
     */
    'traces': Array<Trace>;
    /**
     * 
     * @type {SessionDetailStatusEnum}
     * @memberof SessionDetail
     */
    'status': SessionDetailStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'ticket': string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'sunshineConversationId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'intentMatch': string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'intentMatchName': string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SessionDetail
     */
    'metadata': { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<ConversationItem>}
     * @memberof SessionDetail
     */
    'conversationHistory': Array<ConversationItem>;
    /**
     * 
     * @type {number}
     * @memberof SessionDetail
     */
    'csat': number;
    /**
     * 
     * @type {string}
     * @memberof SessionDetail
     */
    'csatAt': string;
    /**
     * 
     * @type {Array<PreviousSessionList>}
     * @memberof SessionDetail
     */
    'previousConversations': Array<PreviousSessionList>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SessionDetailStatusEnum = {
    Answered: 'answered',
    NotAnswered: 'not-answered'
} as const;

export type SessionDetailStatusEnum = typeof SessionDetailStatusEnum[keyof typeof SessionDetailStatusEnum];


/**
 * Session-level rates.
 * @export
 * @interface SessionRates
 */
export interface SessionRates {
    /**
     * 
     * @type {number}
     * @memberof SessionRates
     */
    'deflection': number;
    /**
     * 
     * @type {number}
     * @memberof SessionRates
     */
    'involvement': number;
    /**
     * 
     * @type {number}
     * @memberof SessionRates
     */
    'escalation': number;
}
/**
 * Session-level statistics.
 * @export
 * @interface SessionStats
 */
export interface SessionStats {
    /**
     * 
     * @type {number}
     * @memberof SessionStats
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStats
     */
    'escalated': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStats
     */
    'deflected': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStats
     */
    'involved': number;
    /**
     * 
     * @type {SessionRates}
     * @memberof SessionStats
     */
    'rates': SessionRates;
}
/**
 * A _fast_ read-only User serialiser.
 * @export
 * @interface SessionUser
 */
export interface SessionUser {
    /**
     * 
     * @type {string}
     * @memberof SessionUser
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SessionUser
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SessionUser
     */
    'handle': string;
    /**
     * 
     * @type {string}
     * @memberof SessionUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SessionUser
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionUser
     */
    'profileImage': string;
}
/**
 * 
 * @export
 * @interface SolutionPost
 */
export interface SolutionPost {
    /**
     * 
     * @type {string}
     * @memberof SolutionPost
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SolutionPost
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof SolutionPost
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof SolutionPost
     */
    'seqNum': string;
    /**
     * 
     * @type {boolean}
     * @memberof SolutionPost
     */
    'isRemoved': boolean;
    /**
     * 
     * @type {User}
     * @memberof SolutionPost
     */
    'author': User;
}
/**
 * * `widget` - Widget * `zendesk` - Zendesk * `intercom` - Intercom * `salesforce` - Salesforce * `copilot` - Copilot * `evals` - Evals
 * @export
 * @enum {string}
 */

export const SourceEnum = {
    Widget: 'widget',
    Zendesk: 'zendesk',
    Intercom: 'intercom',
    Salesforce: 'salesforce',
    Copilot: 'copilot',
    Evals: 'evals'
} as const;

export type SourceEnum = typeof SourceEnum[keyof typeof SourceEnum];


/**
 * 
 * @export
 * @interface SpaceGroup
 */
export interface SpaceGroup {
    /**
     * 
     * @type {string}
     * @memberof SpaceGroup
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof SpaceGroup
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SpaceGroup
     */
    'created': string;
    /**
     * 
     * @type {Array<GenericSpace>}
     * @memberof SpaceGroup
     */
    'spaces': Array<GenericSpace>;
    /**
     * 
     * @type {boolean}
     * @memberof SpaceGroup
     */
    'isDefault': boolean;
    /**
     * 
     * @type {SpaceType312Enum}
     * @memberof SpaceGroup
     */
    'spaceType': SpaceType312Enum;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SpaceGroupPermission = {
    AddSpacegroup: 'add_spacegroup',
    ChangeSpacegroup: 'change_spacegroup',
    DeleteSpacegroup: 'delete_spacegroup'
} as const;

export type SpaceGroupPermission = typeof SpaceGroupPermission[keyof typeof SpaceGroupPermission];


/**
 * 
 * @export
 * @interface SpaceGroupPermissions
 */
export interface SpaceGroupPermissions {
    /**
     * 
     * @type {string}
     * @memberof SpaceGroupPermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<SpaceGroupPermission>}
     * @memberof SpaceGroupPermissions
     */
    'permissions': Array<SpaceGroupPermission> | null;
}
/**
 * 
 * @export
 * @interface SpaceGroupSpaceNotifications
 */
export interface SpaceGroupSpaceNotifications {
    /**
     * 
     * @type {string}
     * @memberof SpaceGroupSpaceNotifications
     */
    'uuid': string;
    /**
     * 
     * @type {Array<GenericSpaceNotifications>}
     * @memberof SpaceGroupSpaceNotifications
     */
    'spaces': Array<GenericSpaceNotifications>;
    /**
     * 
     * @type {SpaceType312Enum}
     * @memberof SpaceGroupSpaceNotifications
     */
    'spaceType': SpaceType312Enum;
}


/**
 * 
 * @export
 * @interface SpaceGroupWithNotifications
 */
export interface SpaceGroupWithNotifications {
    /**
     * 
     * @type {SpaceGroupSpaceNotifications}
     * @memberof SpaceGroupWithNotifications
     */
    'spaceGroup': SpaceGroupSpaceNotifications;
}
/**
 * 
 * @export
 * @interface SpaceGroupWithPermissions
 */
export interface SpaceGroupWithPermissions {
    /**
     * 
     * @type {string}
     * @memberof SpaceGroupWithPermissions
     */
    'spaceGroupUuid': string;
    /**
     * 
     * @type {SpaceGroupPermissions}
     * @memberof SpaceGroupWithPermissions
     */
    'myPermissions': SpaceGroupPermissions;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SpaceType312Enum = {
    Group: 'group'
} as const;

export type SpaceType312Enum = typeof SpaceType312Enum[keyof typeof SpaceType312Enum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SpaceType980Enum = {
    Forum: 'forum'
} as const;

export type SpaceType980Enum = typeof SpaceType980Enum[keyof typeof SpaceType980Enum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SpaceTypeC91Enum = {
    Custom: 'custom'
} as const;

export type SpaceTypeC91Enum = typeof SpaceTypeC91Enum[keyof typeof SpaceTypeC91Enum];


/**
 * * `draft` - Draft document - viewable by admins only * `published` - Published document - viewable by shared audience
 * @export
 * @enum {string}
 */

export const StatusD10Enum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type StatusD10Enum = typeof StatusD10Enum[keyof typeof StatusD10Enum];


/**
 * 
 * @export
 * @interface SwitchSolution
 */
export interface SwitchSolution {
    /**
     * 
     * @type {string}
     * @memberof SwitchSolution
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface SwitchboardDisableResponse
 */
export interface SwitchboardDisableResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SwitchboardDisableResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof SwitchboardDisableResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SwitchboardStatus
 */
export interface SwitchboardStatus {
    /**
     * 
     * @type {boolean}
     * @memberof SwitchboardStatus
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof SwitchboardStatus
     */
    'switchboardId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SwitchboardStatus
     */
    'integrationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SwitchboardStatus
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ThreadAuthor
 */
export interface ThreadAuthor {
    /**
     * 
     * @type {string}
     * @memberof ThreadAuthor
     */
    'handle': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadAuthor
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadAuthor
     */
    'profileImage': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadAuthor
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadAuthor
     */
    'profileColor': string;
    /**
     * 
     * @type {Array<RoleSerialiser>}
     * @memberof ThreadAuthor
     */
    'roles': Array<RoleSerialiser>;
}
/**
 * 
 * @export
 * @interface ThreadPost
 */
export interface ThreadPost {
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'modified': string;
    /**
     * 
     * @type {ThreadAuthor}
     * @memberof ThreadPost
     */
    'author': ThreadAuthor;
    /**
     * 
     * @type {number}
     * @memberof ThreadPost
     */
    'seqNum': number;
    /**
     * 
     * @type {boolean}
     * @memberof ThreadPost
     */
    'isRemoved': boolean;
    /**
     * 
     * @type {any}
     * @memberof ThreadPost
     */
    'content': any;
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'parentIsRemoved': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'replyToPostUuid'?: string | null;
    /**
     * 
     * @type {User}
     * @memberof ThreadPost
     */
    'replyToPostAuthor': User | null;
    /**
     * 
     * @type {number}
     * @memberof ThreadPost
     */
    'repliesCount': number;
    /**
     * 
     * @type {Array<Reaction>}
     * @memberof ThreadPost
     */
    'reactions': Array<Reaction>;
    /**
     * 
     * @type {boolean}
     * @memberof ThreadPost
     */
    'userUpvoted': boolean;
    /**
     * 
     * @type {number}
     * @memberof ThreadPost
     */
    'upvoteCount': number;
    /**
     * 
     * @type {string}
     * @memberof ThreadPost
     */
    'thread': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ThreadPostPermission = {
    AddThreadpost: 'add_threadpost',
    ViewThreadpost: 'view_threadpost',
    ChangeThreadpost: 'change_threadpost',
    DeleteThreadpost: 'delete_threadpost',
    UpvoteThreadpost: 'upvote_threadpost'
} as const;

export type ThreadPostPermission = typeof ThreadPostPermission[keyof typeof ThreadPostPermission];


/**
 * 
 * @export
 * @interface ThreadPostPermissions
 */
export interface ThreadPostPermissions {
    /**
     * 
     * @type {string}
     * @memberof ThreadPostPermissions
     */
    'userId': string;
    /**
     * 
     * @type {Array<ThreadPostPermission>}
     * @memberof ThreadPostPermissions
     */
    'permissions': Array<ThreadPostPermission> | null;
}
/**
 * 
 * @export
 * @interface ThreadPostWithPermissions
 */
export interface ThreadPostWithPermissions {
    /**
     * 
     * @type {ThreadPost}
     * @memberof ThreadPostWithPermissions
     */
    'threadPost': ThreadPost;
    /**
     * 
     * @type {ThreadPostPermissions}
     * @memberof ThreadPostWithPermissions
     */
    'myPermissions': ThreadPostPermissions;
}
/**
 * 
 * @export
 * @interface ThreadSearchResult
 */
export interface ThreadSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ThreadSearchResult
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSearchResult
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSearchResult
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSearchResult
     */
    'highlightedTitle': string;
    /**
     * 
     * @type {string}
     * @memberof ThreadSearchResult
     */
    'highlightedText': string;
    /**
     * 
     * @type {User}
     * @memberof ThreadSearchResult
     */
    'author': User;
    /**
     * 
     * @type {boolean}
     * @memberof ThreadSearchResult
     */
    'solution': boolean;
    /**
     * 
     * @type {SearchResultEmbeddedForumSpace}
     * @memberof ThreadSearchResult
     */
    'forumSpace': SearchResultEmbeddedForumSpace;
}
/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'created': string;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof Ticket
     */
    'comments': Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     */
    'requester': string;
}
/**
 * 
 * @export
 * @interface Tool
 */
export interface Tool {
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Tool
     */
    'description': string;
    /**
     * 
     * @type {Array<ToolParameter>}
     * @memberof Tool
     */
    'parameters': Array<ToolParameter>;
}
/**
 * 
 * @export
 * @interface ToolParameter
 */
export interface ToolParameter {
    /**
     * 
     * @type {string}
     * @memberof ToolParameter
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ToolParameter
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ToolParameter
     */
    'description': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TopLevelPermission = {
    AddCommunity: 'add_community'
} as const;

export type TopLevelPermission = typeof TopLevelPermission[keyof typeof TopLevelPermission];


/**
 * 
 * @export
 * @interface TopLevelPermissions
 */
export interface TopLevelPermissions {
    /**
     * 
     * @type {Array<TopLevelPermission>}
     * @memberof TopLevelPermissions
     */
    'permissions': Array<TopLevelPermission> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TopLevelPermissions
     */
    'flags': Array<string> | null;
}
/**
 * 
 * @export
 * @interface Trace
 */
export interface Trace {
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'input': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Trace
     */
    'images': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'output': string;
    /**
     * 
     * @type {Array<Context>}
     * @memberof Trace
     */
    'contexts': Array<Context>;
    /**
     * Returns True/False if user has submitted feedback, otherwise null
     * @type {boolean}
     * @memberof Trace
     */
    'wasHelpful': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Trace
     */
    'explanation': string;
    /**
     * 
     * @type {Array<TraceFeedback>}
     * @memberof Trace
     */
    'feedback': Array<TraceFeedback>;
    /**
     * 
     * @type {boolean}
     * @memberof Trace
     */
    'answered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Trace
     */
    'isSmalltalk': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Trace
     */
    'errored': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Trace
     */
    'shouldDisplayDocs': boolean;
    /**
     * 
     * @type {any}
     * @memberof Trace
     */
    'agentExecutionStepsSummary'?: any | null;
    /**
     * 
     * @type {TraceConversationItemTypeEnum}
     * @memberof Trace
     */
    'conversationItemType': TraceConversationItemTypeEnum;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof Trace
     */
    'comments': Array<Comment>;
    /**
     * 
     * @type {Escalation}
     * @memberof Trace
     */
    'escalation'?: Escalation | null;
    /**
     * 
     * @type {any}
     * @memberof Trace
     */
    'toolCallSummary': any | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TraceConversationItemTypeEnum = {
    Trace: 'trace'
} as const;

export type TraceConversationItemTypeEnum = typeof TraceConversationItemTypeEnum[keyof typeof TraceConversationItemTypeEnum];


/**
 * 
 * @export
 * @interface TraceFeedback
 */
export interface TraceFeedback {
    /**
     * 
     * @type {string}
     * @memberof TraceFeedback
     */
    'trace': string;
    /**
     * 
     * @type {string}
     * @memberof TraceFeedback
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof TraceFeedback
     */
    'id': number;
}
/**
 * Trace-level rates.
 * @export
 * @interface TraceRates
 */
export interface TraceRates {
    /**
     * 
     * @type {number}
     * @memberof TraceRates
     */
    'answer': number;
    /**
     * 
     * @type {number}
     * @memberof TraceRates
     */
    'nonAnswer': number;
    /**
     * 
     * @type {number}
     * @memberof TraceRates
     */
    'escalation': number;
}
/**
 * Trace-level statistics.
 * @export
 * @interface TraceStats
 */
export interface TraceStats {
    /**
     * 
     * @type {number}
     * @memberof TraceStats
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof TraceStats
     */
    'answered': number;
    /**
     * 
     * @type {number}
     * @memberof TraceStats
     */
    'unanswered': number;
    /**
     * 
     * @type {number}
     * @memberof TraceStats
     */
    'escalated': number;
    /**
     * 
     * @type {TraceRates}
     * @memberof TraceStats
     */
    'rates': TraceRates;
}
/**
 * A _fast_ read-only User serialiser.
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'handle': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'profileImage': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'profileColor': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'joinedCommunityAt': string | null;
    /**
     * 
     * @type {Array<CommunityRolePreview>}
     * @memberof User
     */
    'roles': Array<CommunityRolePreview> | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'twitter'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'instagram'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'github'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'linkedin'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'location'?: string;
}
/**
 * 
 * @export
 * @interface UserIds
 */
export interface UserIds {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserIds
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface UserSession
 */
export interface UserSession {
    /**
     * 
     * @type {string}
     * @memberof UserSession
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof UserSession
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSession
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UserSession
     */
    'created': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSession
     */
    'escalated': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSession
     */
    'lastResponse': string | null;
}
/**
 * 
 * @export
 * @interface UserSessionDetail
 */
export interface UserSessionDetail {
    /**
     * 
     * @type {string}
     * @memberof UserSessionDetail
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof UserSessionDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSessionDetail
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UserSessionDetail
     */
    'created': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSessionDetail
     */
    'escalated': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSessionDetail
     */
    'escalationDrain': string | null;
    /**
     * 
     * @type {Array<Trace>}
     * @memberof UserSessionDetail
     */
    'traces': Array<Trace>;
    /**
     * 
     * @type {Ticket}
     * @memberof UserSessionDetail
     */
    'ticket': Ticket | null;
}
/**
 * 
 * @export
 * @interface WebHook
 */
export interface WebHook {
    /**
     * 
     * @type {Array<string>}
     * @memberof WebHook
     */
    'events': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WebHook
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof WebHook
     */
    'target': string;
    /**
     * 
     * @type {HookUser}
     * @memberof WebHook
     */
    'user': HookUser;
    /**
     * 
     * @type {string}
     * @memberof WebHook
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof WebHook
     */
    'created': string;
}
/**
 * 
 * @export
 * @interface ZendeskOauthUrlResponse
 */
export interface ZendeskOauthUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof ZendeskOauthUrlResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof ZendeskOauthUrlResponse
     */
    'oauthUrl': string;
}

/**
 * OutverseApi - axios parameter creator
 * @export
 */
export const OutverseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserSerialiser} createUserSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCreateUserFromToken: async (createUserSerialiser: CreateUserSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserSerialiser' is not null or undefined
            assertParamExists('apiUsersCreateUserFromToken', 'createUserSerialiser', createUserSerialiser)
            const localVarPath = `/api/users/create_user_from_token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersList: async (limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
         * @param {PatchedPrivateWriteUser} [patchedPrivateWriteUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMePartialUpdate: async (patchedPrivateWriteUser?: PatchedPrivateWriteUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPrivateWriteUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedPrivateWriteUser} [patchedPrivateWriteUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPartialUpdate: async (uuid: string, patchedPrivateWriteUser?: PatchedPrivateWriteUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiUsersPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/users/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPrivateWriteUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/permissions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRetrieve: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiUsersRetrieve', 'uuid', uuid)
            const localVarPath = `/api/users/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailVerification} emailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendEmailVerification: async (emailVerification: EmailVerification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailVerification' is not null or undefined
            assertParamExists('apiUsersSendEmailVerification', 'emailVerification', emailVerification)
            const localVarPath = `/api/users/send_email_verification/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailVerification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle a flag for a user.
         * @param {FlagToggleSerialiser} flagToggleSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersToggleFlag: async (flagToggleSerialiser: FlagToggleSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flagToggleSerialiser' is not null or undefined
            assertParamExists('apiUsersToggleFlag', 'flagToggleSerialiser', flagToggleSerialiser)
            const localVarPath = `/api/users/toggle_flag/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flagToggleSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PrivateWriteUser} [privateWriteUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUpdate: async (uuid: string, privateWriteUser?: PrivateWriteUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('apiUsersUpdate', 'uuid', uuid)
            const localVarPath = `/api/users/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(privateWriteUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks authenticated payload Issues a custom token
         * @param {MetadataVerification} metadataVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersWidgetAuth: async (metadataVerification: MetadataVerification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'metadataVerification' is not null or undefined
            assertParamExists('apiUsersWidgetAuth', 'metadataVerification', metadataVerification)
            const localVarPath = `/api/users/widget_auth/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(metadataVerification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} password 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenCreate: async (username: string, password: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('authTokenCreate', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('authTokenCreate', 'password', password)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authTokenCreate', 'token', token)
            const localVarPath = `/auth-token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (username !== undefined) { 
                localVarFormParams.append('username', username as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.append('password', password as any);
            }
    
            if (token !== undefined) { 
                localVarFormParams.append('token', token as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {Prompt} prompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatHandler: async (communitySlug: string, prompt: Prompt, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('chatHandler', 'communitySlug', communitySlug)
            // verify required parameter 'prompt' is not null or undefined
            assertParamExists('chatHandler', 'prompt', prompt)
            const localVarPath = `/api/community/communities/{community_slug}/chat/handler/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prompt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesAdminsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesAdminsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/admins/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesAdminsRetrieve: async (communitySlug: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesAdminsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesAdminsRetrieve', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/admins/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ChangelogEntryWrite} changelogEntryWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesCreate: async (communitySlug: string, changelogEntryWrite: ChangelogEntryWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChangelogEntriesCreate', 'communitySlug', communitySlug)
            // verify required parameter 'changelogEntryWrite' is not null or undefined
            assertParamExists('communitiesChangelogEntriesCreate', 'changelogEntryWrite', changelogEntryWrite)
            const localVarPath = `/api/community/communities/{community_slug}/changelog-entries/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changelogEntryWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChangelogEntriesDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesChangelogEntriesDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/changelog-entries/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesList: async (communitySlug: string, ordering?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChangelogEntriesList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/changelog-entries/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedChangelogEntryWrite} [patchedChangelogEntryWrite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesPartialUpdate: async (communitySlug: string, uuid: string, patchedChangelogEntryWrite?: PatchedChangelogEntryWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChangelogEntriesPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesChangelogEntriesPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/changelog-entries/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedChangelogEntryWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChangelogEntriesRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesChangelogEntriesRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/changelog-entries/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ChangelogEntryWrite} changelogEntryWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesUpdate: async (communitySlug: string, uuid: string, changelogEntryWrite: ChangelogEntryWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChangelogEntriesUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesChangelogEntriesUpdate', 'uuid', uuid)
            // verify required parameter 'changelogEntryWrite' is not null or undefined
            assertParamExists('communitiesChangelogEntriesUpdate', 'changelogEntryWrite', changelogEntryWrite)
            const localVarPath = `/api/community/communities/{community_slug}/changelog-entries/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changelogEntryWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} sessionId 
         * @param {string} traceId 
         * @param {ChatFeedback} chatFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChatEvaluateTrace: async (communitySlug: string, sessionId: string, traceId: string, chatFeedback: ChatFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesChatEvaluateTrace', 'communitySlug', communitySlug)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('communitiesChatEvaluateTrace', 'sessionId', sessionId)
            // verify required parameter 'traceId' is not null or undefined
            assertParamExists('communitiesChatEvaluateTrace', 'traceId', traceId)
            // verify required parameter 'chatFeedback' is not null or undefined
            assertParamExists('communitiesChatEvaluateTrace', 'chatFeedback', chatFeedback)
            const localVarPath = `/api/community/communities/{community_slug}/chat/evaluate/{session_id}/{trace_id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"session_id"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"trace_id"}}`, encodeURIComponent(String(traceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ContentLink} contentLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksCreate: async (communitySlug: string, contentLink: ContentLink, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesContentLinksCreate', 'communitySlug', communitySlug)
            // verify required parameter 'contentLink' is not null or undefined
            assertParamExists('communitiesContentLinksCreate', 'contentLink', contentLink)
            const localVarPath = `/api/community/communities/{community_slug}/content-links/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contentLink, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesContentLinksDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesContentLinksDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/content-links/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedContentLink} [patchedContentLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksPartialUpdate: async (communitySlug: string, uuid: string, patchedContentLink?: PatchedContentLink, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesContentLinksPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesContentLinksPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/content-links/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedContentLink, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesContentLinksRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesContentLinksRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/content-links/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ContentLink} contentLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksUpdate: async (communitySlug: string, uuid: string, contentLink: ContentLink, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesContentLinksUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesContentLinksUpdate', 'uuid', uuid)
            // verify required parameter 'contentLink' is not null or undefined
            assertParamExists('communitiesContentLinksUpdate', 'contentLink', contentLink)
            const localVarPath = `/api/community/communities/{community_slug}/content-links/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contentLink, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContextSourcesList: async (communitySlug: string, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesContextSourcesList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/context-sources/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommunityCreation} [communityCreation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCreate: async (communityCreation?: CommunityCreation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/community/communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityCreation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {PatchedCommunityCRM} [patchedCommunityCRM] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCrm: async (slug: string, patchedCommunityCRM?: PatchedCommunityCRM, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesCrm', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/crm/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCommunityCRM, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {CustomSpaceContent} customSpaceContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesContent: async (communitySlug: string, uuid: string, customSpaceContent: CustomSpaceContent, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesCustomSpacesContent', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesCustomSpacesContent', 'uuid', uuid)
            // verify required parameter 'customSpaceContent' is not null or undefined
            assertParamExists('communitiesCustomSpacesContent', 'customSpaceContent', customSpaceContent)
            const localVarPath = `/api/community/communities/{community_slug}/custom_spaces/{uuid}/content/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customSpaceContent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CustomSpace} customSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesCreate: async (communitySlug: string, customSpace: CustomSpace, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesCustomSpacesCreate', 'communitySlug', communitySlug)
            // verify required parameter 'customSpace' is not null or undefined
            assertParamExists('communitiesCustomSpacesCreate', 'customSpace', customSpace)
            const localVarPath = `/api/community/communities/{community_slug}/custom_spaces/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customSpace, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesCustomSpacesDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesCustomSpacesDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/custom_spaces/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedCustomSpace} [patchedCustomSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesPartialUpdate: async (communitySlug: string, uuid: string, patchedCustomSpace?: PatchedCustomSpace, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesCustomSpacesPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesCustomSpacesPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/custom_spaces/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCustomSpace, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesCustomSpacesRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesCustomSpacesRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/custom_spaces/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {CustomSpace} customSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesUpdate: async (communitySlug: string, uuid: string, customSpace: CustomSpace, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesCustomSpacesUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesCustomSpacesUpdate', 'uuid', uuid)
            // verify required parameter 'customSpace' is not null or undefined
            assertParamExists('communitiesCustomSpacesUpdate', 'customSpace', customSpace)
            const localVarPath = `/api/community/communities/{community_slug}/custom_spaces/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customSpace, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * In order to set a key on the community, run: community.widget_secret = generate_hmac_secret() community.save()  Not adding an api route for that for safety reasons, in case the api somehow became exposed.
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDevelopmentGetAuthedPayload: async (communitySlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDevelopmentGetAuthedPayload', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/development/get_authed_payload/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsCreate: async (communitySlug: string, document: Document, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsCreate', 'communitySlug', communitySlug)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('communitiesDocumentsCreate', 'document', document)
            const localVarPath = `/api/community/communities/{community_slug}/documents/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {CRDTDraft} cRDTDraft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsDraft: async (communitySlug: string, uuid: string, cRDTDraft: CRDTDraft, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsDraft', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsDraft', 'uuid', uuid)
            // verify required parameter 'cRDTDraft' is not null or undefined
            assertParamExists('communitiesDocumentsDraft', 'cRDTDraft', cRDTDraft)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/draft/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cRDTDraft, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsFavourite: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsFavourite', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsFavourite', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/favourite/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedDocument} [patchedDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsPartialUpdate: async (communitySlug: string, uuid: string, patchedDocument?: PatchedDocument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsUnfavourite: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsUnfavourite', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsUnfavourite', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/favourite/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsUpdate: async (communitySlug: string, uuid: string, document: Document, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesDocumentsUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesDocumentsUpdate', 'uuid', uuid)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('communitiesDocumentsUpdate', 'document', document)
            const localVarPath = `/api/community/communities/{community_slug}/documents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(document, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {EscalationRule} escalationRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesCreate: async (communitySlug: string, escalationRule: EscalationRule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesEscalationRulesCreate', 'communitySlug', communitySlug)
            // verify required parameter 'escalationRule' is not null or undefined
            assertParamExists('communitiesEscalationRulesCreate', 'escalationRule', escalationRule)
            const localVarPath = `/api/community/communities/{community_slug}/escalation-rules/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(escalationRule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesDestroy: async (communitySlug: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesEscalationRulesDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesEscalationRulesDestroy', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/escalation-rules/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {CommunitiesEscalationRulesListAgentEnum} [agent] * &#x60;zendesk&#x60; - Zendesk * &#x60;customer&#x60; - Customer
         * @param {number} [createdBy] 
         * @param {boolean} [enabled] 
         * @param {boolean} [isTriggeredEarly] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {boolean} [requiresConfirmation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesList: async (communitySlug: string, agent?: CommunitiesEscalationRulesListAgentEnum, createdBy?: number, enabled?: boolean, isTriggeredEarly?: boolean, page?: number, requiresConfirmation?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesEscalationRulesList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/escalation-rules/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (agent !== undefined) {
                localVarQueryParameter['agent'] = agent;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            if (isTriggeredEarly !== undefined) {
                localVarQueryParameter['is_triggered_early'] = isTriggeredEarly;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (requiresConfirmation !== undefined) {
                localVarQueryParameter['requires_confirmation'] = requiresConfirmation;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {PatchedEscalationRule} [patchedEscalationRule] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesPartialUpdate: async (communitySlug: string, id: number, patchedEscalationRule?: PatchedEscalationRule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesEscalationRulesPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesEscalationRulesPartialUpdate', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/escalation-rules/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedEscalationRule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesRetrieve: async (communitySlug: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesEscalationRulesRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesEscalationRulesRetrieve', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/escalation-rules/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {EscalationRule} escalationRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesUpdate: async (communitySlug: string, id: number, escalationRule: EscalationRule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesEscalationRulesUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesEscalationRulesUpdate', 'id', id)
            // verify required parameter 'escalationRule' is not null or undefined
            assertParamExists('communitiesEscalationRulesUpdate', 'escalationRule', escalationRule)
            const localVarPath = `/api/community/communities/{community_slug}/escalation-rules/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(escalationRule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFavouritesList: async (communitySlug: string, ordering?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFavouritesList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/favourites/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {Folder} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersCreate: async (communitySlug: string, folder: Folder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersCreate', 'communitySlug', communitySlug)
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('communitiesFoldersCreate', 'folder', folder)
            const localVarPath = `/api/community/communities/{community_slug}/folders/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesFoldersDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/folders/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Custom list that checks view perms on each doc.
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersList: async (communitySlug: string, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/folders/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Ordering} ordering 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersMoveDocument: async (communitySlug: string, uuid: string, ordering: Ordering, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersMoveDocument', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesFoldersMoveDocument', 'uuid', uuid)
            // verify required parameter 'ordering' is not null or undefined
            assertParamExists('communitiesFoldersMoveDocument', 'ordering', ordering)
            const localVarPath = `/api/community/communities/{community_slug}/folders/{uuid}/move_document/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordering, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedFolder} [patchedFolder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersPartialUpdate: async (communitySlug: string, uuid: string, patchedFolder?: PatchedFolder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesFoldersPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/folders/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedFolder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesFoldersRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/folders/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Folder} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersUpdate: async (communitySlug: string, uuid: string, folder: Folder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesFoldersUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesFoldersUpdate', 'uuid', uuid)
            // verify required parameter 'folder' is not null or undefined
            assertParamExists('communitiesFoldersUpdate', 'folder', folder)
            const localVarPath = `/api/community/communities/{community_slug}/folders/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(folder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {boolean} [canAddForumthread] Only retrieve forum spaces that the user is allowed to add forum threads to
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [title] Only retrieve forum spaces beginning with title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesForumSpacesList: async (communitySlug: string, canAddForumthread?: boolean, ordering?: string, page?: number, title?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesForumSpacesList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/forum_spaces/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (canAddForumthread !== undefined) {
                localVarQueryParameter['can_add_forumthread'] = canAddForumthread;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {WebHook} webHook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksCreate: async (communitySlug: string, webHook: WebHook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksCreate', 'communitySlug', communitySlug)
            // verify required parameter 'webHook' is not null or undefined
            assertParamExists('communitiesHooksCreate', 'webHook', webHook)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webHook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesHooksDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksEventsList: async (communitySlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksEventsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/events/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedWebHook} [patchedWebHook] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksPartialUpdate: async (communitySlug: string, uuid: string, patchedWebHook?: PatchedWebHook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesHooksPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedWebHook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesHooksRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {WebHook} webHook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksUpdate: async (communitySlug: string, uuid: string, webHook: WebHook, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesHooksUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesHooksUpdate', 'uuid', uuid)
            // verify required parameter 'webHook' is not null or undefined
            assertParamExists('communitiesHooksUpdate', 'webHook', webHook)
            const localVarPath = `/api/community/communities/{community_slug}/hooks/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webHook, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {IntentWrite} intentWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsCreate: async (communitySlug: string, intentWrite: IntentWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesIntentsCreate', 'communitySlug', communitySlug)
            // verify required parameter 'intentWrite' is not null or undefined
            assertParamExists('communitiesIntentsCreate', 'intentWrite', intentWrite)
            const localVarPath = `/api/community/communities/{community_slug}/intents/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesIntentsDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesIntentsDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/intents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsList: async (communitySlug: string, ordering?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesIntentsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/intents/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedIntentWrite} [patchedIntentWrite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsPartialUpdate: async (communitySlug: string, uuid: string, patchedIntentWrite?: PatchedIntentWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesIntentsPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesIntentsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/intents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedIntentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesIntentsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesIntentsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/intents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {IntentWrite} intentWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsUpdate: async (communitySlug: string, uuid: string, intentWrite: IntentWrite, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesIntentsUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesIntentsUpdate', 'uuid', uuid)
            // verify required parameter 'intentWrite' is not null or undefined
            assertParamExists('communitiesIntentsUpdate', 'intentWrite', intentWrite)
            const localVarPath = `/api/community/communities/{community_slug}/intents/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intentWrite, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInvitationsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesInvitationsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/invitations/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} inviteCode Invite code to check.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeCheck: async (communitySlug: string, inviteCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesInviteCodeCheck', 'communitySlug', communitySlug)
            // verify required parameter 'inviteCode' is not null or undefined
            assertParamExists('communitiesInviteCodeCheck', 'inviteCode', inviteCode)
            const localVarPath = `/api/community/communities/{community_slug}/invite_code/check/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (inviteCode !== undefined) {
                localVarQueryParameter['invite_code'] = inviteCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This is slightly awkward and uncanonical in HTTP terms. The only ID supplied here is the parent community\'s, so this isn\'t actually a \"retrieve\" on the resource represented by CommunityInviteCodeViewset but rather a retrieve on the parent (as such perhaps it belongs back with the parent in the end).
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeGet: async (communitySlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesInviteCodeGet', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/invite_code/get/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {InviteMember} inviteMember 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeInviteMember: async (communitySlug: string, inviteMember: InviteMember, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesInviteCodeInviteMember', 'communitySlug', communitySlug)
            // verify required parameter 'inviteMember' is not null or undefined
            assertParamExists('communitiesInviteCodeInviteMember', 'inviteMember', inviteMember)
            const localVarPath = `/api/community/communities/{community_slug}/invite_code/invite_member/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteMember, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {InviteTeamMember} inviteTeamMember 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeInviteTeamMember: async (communitySlug: string, inviteTeamMember: InviteTeamMember, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesInviteCodeInviteTeamMember', 'communitySlug', communitySlug)
            // verify required parameter 'inviteTeamMember' is not null or undefined
            assertParamExists('communitiesInviteCodeInviteTeamMember', 'inviteTeamMember', inviteTeamMember)
            const localVarPath = `/api/community/communities/{community_slug}/invite_code/invite_team_member/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteTeamMember, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CommunityInviteCode} [communityInviteCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeRefresh: async (communitySlug: string, communityInviteCode?: CommunityInviteCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesInviteCodeRefresh', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/invite_code/refresh/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityInviteCode, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {LabelSerialiser} labelSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsCreate: async (communitySlug: string, labelSerialiser: LabelSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLabelsCreate', 'communitySlug', communitySlug)
            // verify required parameter 'labelSerialiser' is not null or undefined
            assertParamExists('communitiesLabelsCreate', 'labelSerialiser', labelSerialiser)
            const localVarPath = `/api/community/communities/{community_slug}/labels/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labelSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLabelsDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesLabelsDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/labels/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsList: async (communitySlug: string, ordering?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLabelsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/labels/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedLabelSerialiser} [patchedLabelSerialiser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsPartialUpdate: async (communitySlug: string, uuid: string, patchedLabelSerialiser?: PatchedLabelSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLabelsPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesLabelsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/labels/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedLabelSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLabelsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesLabelsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/labels/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {LabelSerialiser} labelSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsUpdate: async (communitySlug: string, uuid: string, labelSerialiser: LabelSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLabelsUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesLabelsUpdate', 'uuid', uuid)
            // verify required parameter 'labelSerialiser' is not null or undefined
            assertParamExists('communitiesLabelsUpdate', 'labelSerialiser', labelSerialiser)
            const localVarPath = `/api/community/communities/{community_slug}/labels/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(labelSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] 
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [userIsAdmin] Only retrieve communities of which the user is an admin
         * @param {boolean} [userIsMember] Only retrieve communities of which the user is a member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesList: async (limit?: number, name?: string, offset?: number, ordering?: string, userIsAdmin?: boolean, userIsMember?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/community/communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (userIsAdmin !== undefined) {
                localVarQueryParameter['user_is_admin'] = userIsAdmin;
            }

            if (userIsMember !== undefined) {
                localVarQueryParameter['user_is_member'] = userIsMember;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Session and Trace analytics endpoint.
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsAnalytics: async (communitySlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLlmSessionsAnalytics', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/llm-sessions/analytics/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsAudit: async (communitySlug: string, slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLlmSessionsAudit', 'communitySlug', communitySlug)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesLlmSessionsAudit', 'slug', slug)
            const localVarPath = `/api/community/communities/{community_slug}/llm-sessions/{slug}/audit/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {boolean} [audited] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {boolean} [escalated] 
         * @param {Array<string>} [intent] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {Array<string>} [rule] 
         * @param {CommunitiesLlmSessionsListSourceEnum} [source] * &#x60;widget&#x60; - Widget * &#x60;zendesk&#x60; - Zendesk * &#x60;intercom&#x60; - Intercom * &#x60;salesforce&#x60; - Salesforce * &#x60;copilot&#x60; - Copilot * &#x60;evals&#x60; - Evals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsList: async (communitySlug: string, audited?: boolean, createdAfter?: string, createdBefore?: string, escalated?: boolean, intent?: Array<string>, ordering?: string, page?: number, rule?: Array<string>, source?: CommunitiesLlmSessionsListSourceEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLlmSessionsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/llm-sessions/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (audited !== undefined) {
                localVarQueryParameter['audited'] = audited;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = (createdAfter as any instanceof Date) ?
                    (createdAfter as any).toISOString().substring(0,10) :
                    createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = (createdBefore as any instanceof Date) ?
                    (createdBefore as any).toISOString().substring(0,10) :
                    createdBefore;
            }

            if (escalated !== undefined) {
                localVarQueryParameter['escalated'] = escalated;
            }

            if (intent) {
                localVarQueryParameter['intent'] = intent;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rule) {
                localVarQueryParameter['rule'] = rule;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsRetrieve: async (communitySlug: string, slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLlmSessionsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesLlmSessionsRetrieve', 'slug', slug)
            const localVarPath = `/api/community/communities/{community_slug}/llm-sessions/{slug}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsUnaudit: async (communitySlug: string, slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesLlmSessionsUnaudit', 'communitySlug', communitySlug)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesLlmSessionsUnaudit', 'slug', slug)
            const localVarPath = `/api/community/communities/{community_slug}/llm-sessions/{slug}/audit/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesMembersDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/members/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersDisableSlack: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersDisableSlack', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesMembersDisableSlack', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/members/{uuid}/disable_slack/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the email of a community member using PrivateUserSerializer.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersGetEmail: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersGetEmail', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesMembersGetEmail', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/members/{uuid}/get_email/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersList: async (communitySlug: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/members/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersNotificationPreferences: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersNotificationPreferences', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesMembersNotificationPreferences', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/members/{uuid}/notification_preferences/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedNotificationChannelPreference} [patchedNotificationChannelPreference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersNotificationPreferences2: async (communitySlug: string, uuid: string, patchedNotificationChannelPreference?: PatchedNotificationChannelPreference, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersNotificationPreferences2', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesMembersNotificationPreferences2', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/members/{uuid}/notification_preferences/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedNotificationChannelPreference, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesMembersRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesMembersRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/members/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {Ordering} ordering 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMoveSpaceGroup: async (slug: string, ordering: Ordering, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesMoveSpaceGroup', 'slug', slug)
            // verify required parameter 'ordering' is not null or undefined
            assertParamExists('communitiesMoveSpaceGroup', 'ordering', ordering)
            const localVarPath = `/api/community/communities/{slug}/move_space_group/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordering, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesNotificationSubscriptions: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesNotificationSubscriptions', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/notification_subscriptions/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {PatchedCommunityFull} [patchedCommunityFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPartialUpdate: async (slug: string, patchedCommunityFull?: PatchedCommunityFull, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesPartialUpdate', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCommunityFull, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPermissions: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesPermissions', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/permissions/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ThreadPost} threadPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsCreate: async (communitySlug: string, threadPost: ThreadPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsCreate', 'communitySlug', communitySlug)
            // verify required parameter 'threadPost' is not null or undefined
            assertParamExists('communitiesPostsCreate', 'threadPost', threadPost)
            const localVarPath = `/api/community/communities/{community_slug}/posts/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(threadPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} reactionUuid 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsDeleteReaction: async (communitySlug: string, reactionUuid: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsDeleteReaction', 'communitySlug', communitySlug)
            // verify required parameter 'reactionUuid' is not null or undefined
            assertParamExists('communitiesPostsDeleteReaction', 'reactionUuid', reactionUuid)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsDeleteReaction', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/reaction/{reaction_uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"reaction_uuid"}}`, encodeURIComponent(String(reactionUuid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [forumSpaceUuid] 
         * @param {string} [forumThreadUuid] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [page] The page number to use, starting from 1
         * @param {string} [replyToPostUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsList: async (communitySlug: string, forumSpaceUuid?: string, forumThreadUuid?: string, ordering?: string, page?: string, replyToPostUuid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/posts/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (forumSpaceUuid !== undefined) {
                localVarQueryParameter['forum_space_uuid'] = forumSpaceUuid;
            }

            if (forumThreadUuid !== undefined) {
                localVarQueryParameter['forum_thread_uuid'] = forumThreadUuid;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (replyToPostUuid !== undefined) {
                localVarQueryParameter['reply_to_post__uuid'] = replyToPostUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedThreadPost} [patchedThreadPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsPartialUpdate: async (communitySlug: string, uuid: string, patchedThreadPost?: PatchedThreadPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedThreadPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a reaction for post, returns the post with updated reaction list
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ReactionCreateSerialiser} reactionCreateSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsReaction: async (communitySlug: string, uuid: string, reactionCreateSerialiser: ReactionCreateSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsReaction', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsReaction', 'uuid', uuid)
            // verify required parameter 'reactionCreateSerialiser' is not null or undefined
            assertParamExists('communitiesPostsReaction', 'reactionCreateSerialiser', reactionCreateSerialiser)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/reaction/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactionCreateSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsRemoveUpvote: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsRemoveUpvote', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsRemoveUpvote', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/upvote/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsReport: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsReport', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsReport', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/report/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ThreadPost} threadPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsUpdate: async (communitySlug: string, uuid: string, threadPost: ThreadPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsUpdate', 'uuid', uuid)
            // verify required parameter 'threadPost' is not null or undefined
            assertParamExists('communitiesPostsUpdate', 'threadPost', threadPost)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(threadPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsUpvote: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesPostsUpvote', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesPostsUpvote', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/posts/{uuid}/upvote/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesRetrieve: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesRetrieve', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesRolesList: async (communitySlug: string, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesRolesList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/roles/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CommunitiesSemanticSearchGetEntityTypeEnum} entityType entity type
         * @param {string} uuid entity uuid to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSemanticSearchGet: async (communitySlug: string, entityType: CommunitiesSemanticSearchGetEntityTypeEnum, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSemanticSearchGet', 'communitySlug', communitySlug)
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('communitiesSemanticSearchGet', 'entityType', entityType)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesSemanticSearchGet', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/semantic_search/get/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {CommunityIntercomAppId} communityIntercomAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSetIntercomAppId: async (slug: string, communityIntercomAppId: CommunityIntercomAppId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesSetIntercomAppId', 'slug', slug)
            // verify required parameter 'communityIntercomAppId' is not null or undefined
            assertParamExists('communitiesSetIntercomAppId', 'communityIntercomAppId', communityIntercomAppId)
            const localVarPath = `/api/community/communities/{slug}/set_intercom_app_id/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityIntercomAppId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {CommunityZendeskSubdomain} communityZendeskSubdomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSetZendeskSubdomain: async (slug: string, communityZendeskSubdomain: CommunityZendeskSubdomain, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesSetZendeskSubdomain', 'slug', slug)
            // verify required parameter 'communityZendeskSubdomain' is not null or undefined
            assertParamExists('communitiesSetZendeskSubdomain', 'communityZendeskSubdomain', communityZendeskSubdomain)
            const localVarPath = `/api/community/communities/{slug}/set_zendesk_subdomain/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityZendeskSubdomain, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CommunitySignUpRequest} [communitySignUpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSignUpsCreate: async (communitySlug: string, communitySignUpRequest?: CommunitySignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSignUpsCreate', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/sign-ups/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communitySignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSignUpsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSignUpsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/sign-ups/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Snippets are just Documents that are marked as snippets (via the `is_snippet` field).  They are however used somewhat differently to normal documents. - Not included in the knowledge base product (ie. the folders tree api call) - In the agent, they can be used as context just like normal documents, but are not surfaced to users speaking   with the agent. They are however visible in conversation history (for debug purposes). Ie. they are a kind of   internal document that can have an impact on the agent\'s responses, but don\'t get shown to users.
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSnippetsList: async (communitySlug: string, ordering?: string, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSnippetsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/snippets/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {SpaceGroup} spaceGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsCreate: async (communitySlug: string, spaceGroup: SpaceGroup, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsCreate', 'communitySlug', communitySlug)
            // verify required parameter 'spaceGroup' is not null or undefined
            assertParamExists('communitiesSpaceGroupsCreate', 'spaceGroup', spaceGroup)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spaceGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesSpaceGroupsDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Custom list that checks view perms on each space.
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Ordering} ordering 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsMoveSpace: async (communitySlug: string, uuid: string, ordering: Ordering, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsMoveSpace', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesSpaceGroupsMoveSpace', 'uuid', uuid)
            // verify required parameter 'ordering' is not null or undefined
            assertParamExists('communitiesSpaceGroupsMoveSpace', 'ordering', ordering)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/{uuid}/move_space/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ordering, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsNotificationsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsNotificationsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/notifications/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedSpaceGroup} [patchedSpaceGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsPartialUpdate: async (communitySlug: string, uuid: string, patchedSpaceGroup?: PatchedSpaceGroup, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesSpaceGroupsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedSpaceGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsPermsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsPermsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/perms/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesSpaceGroupsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {SpaceGroup} spaceGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsUpdate: async (communitySlug: string, uuid: string, spaceGroup: SpaceGroup, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesSpaceGroupsUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesSpaceGroupsUpdate', 'uuid', uuid)
            // verify required parameter 'spaceGroup' is not null or undefined
            assertParamExists('communitiesSpaceGroupsUpdate', 'spaceGroup', spaceGroup)
            const localVarPath = `/api/community/communities/{community_slug}/space_groups/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(spaceGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSubscribeToNewMemberEvent: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesSubscribeToNewMemberEvent', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/subscribe_to_new_member_event/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSwitchboardDisable: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesSwitchboardDisable', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/switchboard_disable/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSwitchboardStatus: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesSwitchboardStatus', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/switchboard_status/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [cursor] Cursor to use for pagination
         * @param {Array<string>} [forumSpaceUuid] 
         * @param {Array<string>} [labelUuid] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [solved] 
         * @param {boolean} [unread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsAnnotationsList: async (communitySlug: string, cursor?: string, forumSpaceUuid?: Array<string>, labelUuid?: Array<string>, ordering?: string, solved?: boolean, unread?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsAnnotationsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/threads/annotations/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (forumSpaceUuid) {
                localVarQueryParameter['forum_space_uuid'] = forumSpaceUuid;
            }

            if (labelUuid) {
                localVarQueryParameter['label_uuid'] = labelUuid;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (solved !== undefined) {
                localVarQueryParameter['solved'] = solved;
            }

            if (unread !== undefined) {
                localVarQueryParameter['unread'] = unread;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ForumThread} forumThread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsCreate: async (communitySlug: string, forumThread: ForumThread, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsCreate', 'communitySlug', communitySlug)
            // verify required parameter 'forumThread' is not null or undefined
            assertParamExists('communitiesThreadsCreate', 'forumThread', forumThread)
            const localVarPath = `/api/community/communities/{community_slug}/threads/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumThread, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsDeletePin: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsDeletePin', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsDeletePin', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/pin/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} reactionUuid 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsDeleteReaction: async (communitySlug: string, reactionUuid: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsDeleteReaction', 'communitySlug', communitySlug)
            // verify required parameter 'reactionUuid' is not null or undefined
            assertParamExists('communitiesThreadsDeleteReaction', 'reactionUuid', reactionUuid)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsDeleteReaction', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/reaction/{reaction_uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"reaction_uuid"}}`, encodeURIComponent(String(reactionUuid)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsDestroy: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsFavourite: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsFavourite', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsFavourite', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/favourite/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsHide: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsHide', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsHide', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/hide/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [cursor] Cursor to use for pagination
         * @param {Array<string>} [forumSpaceUuid] 
         * @param {Array<string>} [labelUuid] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [solved] 
         * @param {boolean} [unread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsList: async (communitySlug: string, cursor?: string, forumSpaceUuid?: Array<string>, labelUuid?: Array<string>, ordering?: string, solved?: boolean, unread?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/threads/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (forumSpaceUuid) {
                localVarQueryParameter['forum_space_uuid'] = forumSpaceUuid;
            }

            if (labelUuid) {
                localVarQueryParameter['label_uuid'] = labelUuid;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (solved !== undefined) {
                localVarQueryParameter['solved'] = solved;
            }

            if (unread !== undefined) {
                localVarQueryParameter['unread'] = unread;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsLock: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsLock', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsLock', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/lock/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsMaximize: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsMaximize', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsMaximize', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/maximize/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedForumThread} [patchedForumThread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsPartialUpdate: async (communitySlug: string, uuid: string, patchedForumThread?: PatchedForumThread, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedForumThread, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsPin: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsPin', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsPin', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/pin/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a reaction for thread, returns the Thread with updated reaction list
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ReactionCreateSerialiser} reactionCreateSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsReaction: async (communitySlug: string, uuid: string, reactionCreateSerialiser: ReactionCreateSerialiser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsReaction', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsReaction', 'uuid', uuid)
            // verify required parameter 'reactionCreateSerialiser' is not null or undefined
            assertParamExists('communitiesThreadsReaction', 'reactionCreateSerialiser', reactionCreateSerialiser)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/reaction/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactionCreateSerialiser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsRemoveUpvote: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsRemoveUpvote', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsRemoveUpvote', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/upvote/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsReport: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsReport', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsReport', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/report/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsRetrieve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {SwitchSolution} switchSolution 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsSolve: async (communitySlug: string, uuid: string, switchSolution: SwitchSolution, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsSolve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsSolve', 'uuid', uuid)
            // verify required parameter 'switchSolution' is not null or undefined
            assertParamExists('communitiesThreadsSolve', 'switchSolution', switchSolution)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/solve/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchSolution, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsSubscribeToActivity: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsSubscribeToActivity', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsSubscribeToActivity', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/subscribe_to_activity/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsSubscribeToReplies: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsSubscribeToReplies', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsSubscribeToReplies', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/subscribe_to_replies/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnfavourite: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnfavourite', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnfavourite', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/favourite/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnhide: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnhide', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnhide', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/hide/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnlock: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnlock', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnlock', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/lock/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnmaximize: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnmaximize', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnmaximize', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/maximize/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnsolve: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnsolve', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnsolve', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/solve/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnsubscribeFromActivity: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnsubscribeFromActivity', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnsubscribeFromActivity', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/unsubscribe_from_activity/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnsubscribeFromReplies: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUnsubscribeFromReplies', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUnsubscribeFromReplies', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/unsubscribe_from_replies/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ForumThread} forumThread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUpdate: async (communitySlug: string, uuid: string, forumThread: ForumThread, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUpdate', 'uuid', uuid)
            // verify required parameter 'forumThread' is not null or undefined
            assertParamExists('communitiesThreadsUpdate', 'forumThread', forumThread)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumThread, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUpvote: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsUpvote', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsUpvote', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/upvote/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsVisit: async (communitySlug: string, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesThreadsVisit', 'communitySlug', communitySlug)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('communitiesThreadsVisit', 'uuid', uuid)
            const localVarPath = `/api/community/communities/{community_slug}/threads/{uuid}/visit/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of available tools based on community configuration, using LangChain tool definitions.
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesToolsList: async (communitySlug: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesToolsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/tools/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {TraceFeedback} traceFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackCreate: async (communitySlug: string, traceFeedback: TraceFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesTraceFeedbackCreate', 'communitySlug', communitySlug)
            // verify required parameter 'traceFeedback' is not null or undefined
            assertParamExists('communitiesTraceFeedbackCreate', 'traceFeedback', traceFeedback)
            const localVarPath = `/api/community/communities/{community_slug}/trace-feedback/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackDestroy: async (communitySlug: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesTraceFeedbackDestroy', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesTraceFeedbackDestroy', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/trace-feedback/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} [author] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [trace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackList: async (communitySlug: string, author?: number, page?: number, trace?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesTraceFeedbackList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/trace-feedback/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (trace !== undefined) {
                localVarQueryParameter['trace'] = trace;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {PatchedTraceFeedback} [patchedTraceFeedback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackPartialUpdate: async (communitySlug: string, id: number, patchedTraceFeedback?: PatchedTraceFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesTraceFeedbackPartialUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesTraceFeedbackPartialUpdate', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/trace-feedback/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedTraceFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackRetrieve: async (communitySlug: string, id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesTraceFeedbackRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesTraceFeedbackRetrieve', 'id', id)
            const localVarPath = `/api/community/communities/{community_slug}/trace-feedback/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {TraceFeedback} traceFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackUpdate: async (communitySlug: string, id: number, traceFeedback: TraceFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesTraceFeedbackUpdate', 'communitySlug', communitySlug)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('communitiesTraceFeedbackUpdate', 'id', id)
            // verify required parameter 'traceFeedback' is not null or undefined
            assertParamExists('communitiesTraceFeedbackUpdate', 'traceFeedback', traceFeedback)
            const localVarPath = `/api/community/communities/{community_slug}/trace-feedback/{id}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(traceFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUnsubscribeFromNewMemberEvent: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesUnsubscribeFromNewMemberEvent', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/unsubscribe_from_new_member_event/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {CommunityFull} [communityFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUpdate: async (slug: string, communityFull?: CommunityFull, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesUpdate', 'slug', slug)
            const localVarPath = `/api/community/communities/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityFull, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUserSessionsList: async (communitySlug: string, ordering?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesUserSessionsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/communities/{community_slug}/user-sessions/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUserSessionsRetrieve: async (communitySlug: string, slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('communitiesUserSessionsRetrieve', 'communitySlug', communitySlug)
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('communitiesUserSessionsRetrieve', 'slug', slug)
            const localVarPath = `/api/community/communities/{community_slug}/user-sessions/{slug}/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)))
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} document UUID of the document to get feedback for
         * @param {string} modifiedAfter Start date of the feedback time range
         * @param {string} modifiedBefore End date of the feedback time range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentFeedbackCountCountForDoc: async (document: string, modifiedAfter: string, modifiedBefore: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'document' is not null or undefined
            assertParamExists('documentFeedbackCountCountForDoc', 'document', document)
            // verify required parameter 'modifiedAfter' is not null or undefined
            assertParamExists('documentFeedbackCountCountForDoc', 'modifiedAfter', modifiedAfter)
            // verify required parameter 'modifiedBefore' is not null or undefined
            assertParamExists('documentFeedbackCountCountForDoc', 'modifiedBefore', modifiedBefore)
            const localVarPath = `/api/community/document-feedback-count/count_for_doc/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (document !== undefined) {
                localVarQueryParameter['document'] = document;
            }

            if (modifiedAfter !== undefined) {
                localVarQueryParameter['modified_after'] = modifiedAfter;
            }

            if (modifiedBefore !== undefined) {
                localVarQueryParameter['modified_before'] = modifiedBefore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for document feedback
         * @param {DocumentFeedback} documentFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentFeedbackCreate: async (documentFeedback: DocumentFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentFeedback' is not null or undefined
            assertParamExists('documentFeedbackCreate', 'documentFeedback', documentFeedback)
            const localVarPath = `/api/community/document-feedback/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * CRUD for document feedback
         * @param {number} id A unique integer value identifying this document feedback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentFeedbackRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('documentFeedbackRetrieve', 'id', id)
            const localVarPath = `/api/community/document-feedback/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForumSpace} forumSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceCreate: async (forumSpace: ForumSpace, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forumSpace' is not null or undefined
            assertParamExists('forumSpaceCreate', 'forumSpace', forumSpace)
            const localVarPath = `/api/community/forum-space/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumSpace, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceDestroy: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceFavourite: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceFavourite', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/favourite/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedForumSpace} [patchedForumSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpacePartialUpdate: async (uuid: string, patchedForumSpace?: PatchedForumSpace, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpacePartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedForumSpace, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceRetrieve: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceSubscribeToActivity: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceSubscribeToActivity', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/subscribe_to_activity/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceUnfavourite: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceUnfavourite', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/favourite/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceUnsubscribeFromActivity: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceUnsubscribeFromActivity', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/unsubscribe_from_activity/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ForumSpace} forumSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceUpdate: async (uuid: string, forumSpace: ForumSpace, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceUpdate', 'uuid', uuid)
            // verify required parameter 'forumSpace' is not null or undefined
            assertParamExists('forumSpaceUpdate', 'forumSpace', forumSpace)
            const localVarPath = `/api/community/forum-space/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumSpace, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceVisit: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('forumSpaceVisit', 'uuid', uuid)
            const localVarPath = `/api/community/forum-space/{uuid}/visit/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} community 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightsNewMembersInsight: async (community: string, createdAfter?: string, createdBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'community' is not null or undefined
            assertParamExists('insightsNewMembersInsight', 'community', community)
            const localVarPath = `/api/community/insights/new-members/insight/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (community !== undefined) {
                localVarQueryParameter['community'] = community;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = createdBefore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} community 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightsThreadsCreatedInsight: async (community: string, createdAfter?: string, createdBefore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'community' is not null or undefined
            assertParamExists('insightsThreadsCreatedInsight', 'community', community)
            const localVarPath = `/api/community/insights/threads-created/insight/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (community !== undefined) {
                localVarQueryParameter['community'] = community;
            }

            if (createdAfter !== undefined) {
                localVarQueryParameter['created_after'] = createdAfter;
            }

            if (createdBefore !== undefined) {
                localVarQueryParameter['created_before'] = createdBefore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} url The url to use for extraction of open graph metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opengraphExtract: async (url: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'url' is not null or undefined
            assertParamExists('opengraphExtract', 'url', url)
            const localVarPath = `/api/community/opengraph/extract/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} organisationUuid 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsCommunitiesList: async (organisationUuid: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organisationUuid' is not null or undefined
            assertParamExists('organisationsCommunitiesList', 'organisationUuid', organisationUuid)
            const localVarPath = `/api/community/organisations/{organisation_uuid}/communities/`
                .replace(`{${"organisation_uuid"}}`, encodeURIComponent(String(organisationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List organisations
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] 
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsList: async (limit?: number, name?: string, offset?: number, ordering?: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/community/organisations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedOrganisation} [patchedOrganisation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsPartialUpdate: async (uuid: string, patchedOrganisation?: PatchedOrganisation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('organisationsPartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/organisations/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedOrganisation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsRetrieve: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('organisationsRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/organisations/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {Organisation} [organisation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsUpdate: async (uuid: string, organisation?: Organisation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('organisationsUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/organisations/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organisation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedUserId} [patchedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleAddMember: async (uuid: string, patchedUserId?: PatchedUserId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('roleAddMember', 'uuid', uuid)
            const localVarPath = `/api/community/role/{uuid}/add_member/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [communitySlug] Identifies the community that the community role should be created for.
         * @param {CommunityRole} [communityRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleCreate: async (communitySlug?: string, communityRole?: CommunityRole, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/community/role/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (communitySlug !== undefined) {
                localVarQueryParameter['community_slug'] = communitySlug;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleDestroy: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('roleDestroy', 'uuid', uuid)
            const localVarPath = `/api/community/role/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedCommunityRole} [patchedCommunityRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolePartialUpdate: async (uuid: string, patchedCommunityRole?: PatchedCommunityRole, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('rolePartialUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/role/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCommunityRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedUserId} [patchedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleRemoveMember: async (uuid: string, patchedUserId?: PatchedUserId, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('roleRemoveMember', 'uuid', uuid)
            const localVarPath = `/api/community/role/{uuid}/remove_member/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUserId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleRetrieve: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('roleRetrieve', 'uuid', uuid)
            const localVarPath = `/api/community/role/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {CommunityRole} [communityRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleUpdate: async (uuid: string, communityRole?: CommunityRole, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('roleUpdate', 'uuid', uuid)
            const localVarPath = `/api/community/role/{uuid}/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communityRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} uuid 
         * @param {UserIds} userIds 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleUpdateMembers: async (uuid: string, userIds: UserIds, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('roleUpdateMembers', 'uuid', uuid)
            // verify required parameter 'userIds' is not null or undefined
            assertParamExists('roleUpdateMembers', 'userIds', userIds)
            const localVarPath = `/api/community/role/{uuid}/update_members/`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userIds, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {string} [type] content link type to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContentList: async (communitySlug: string, ordering?: string, page?: number, search?: string, type?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchContentList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/content/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContentPreviewsList: async (communitySlug: string, ordering?: string, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchContentPreviewsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/content/previews/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsList: async (communitySlug: string, ordering?: string, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchDocumentsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/documents/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsV2List: async (communitySlug: string, ordering?: string, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchDocumentsV2List', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/documents-v2/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {string} [thread] thread uuid to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPostsList: async (communitySlug: string, author?: string, forum?: string, ordering?: string, page?: number, search?: string, thread?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchPostsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/posts/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (forum !== undefined) {
                localVarQueryParameter['forum'] = forum;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (thread !== undefined) {
                localVarQueryParameter['thread'] = thread;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {string} [thread] thread uuid to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPostsV2List: async (communitySlug: string, author?: string, forum?: string, page?: number, search?: string, thread?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchPostsV2List', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/posts-v2/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (forum !== undefined) {
                localVarQueryParameter['forum'] = forum;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (thread !== undefined) {
                localVarQueryParameter['thread'] = thread;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreadsList: async (communitySlug: string, author?: string, forum?: string, ordering?: string, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchThreadsList', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/threads/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (forum !== undefined) {
                localVarQueryParameter['forum'] = forum;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreadsV2List: async (communitySlug: string, author?: string, forum?: string, page?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communitySlug' is not null or undefined
            assertParamExists('searchThreadsV2List', 'communitySlug', communitySlug)
            const localVarPath = `/api/community/search/{community_slug}/threads-v2/`
                .replace(`{${"community_slug"}}`, encodeURIComponent(String(communitySlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (forum !== undefined) {
                localVarQueryParameter['forum'] = forum;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seoCommunityList: async (ordering?: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/community/seo/community/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OutverseApi - functional programming interface
 * @export
 */
export const OutverseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OutverseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateUserSerialiser} createUserSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersCreateUserFromToken(createUserSerialiser: CreateUserSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserSerialiser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersCreateUserFromToken(createUserSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersCreateUserFromToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersList(limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedPrivateWriteUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersList(limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivateWriteUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
         * @param {PatchedPrivateWriteUser} [patchedPrivateWriteUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersMePartialUpdate(patchedPrivateWriteUser?: PatchedPrivateWriteUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivateWriteUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersMePartialUpdate(patchedPrivateWriteUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersMePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedPrivateWriteUser} [patchedPrivateWriteUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersPartialUpdate(uuid: string, patchedPrivateWriteUser?: PatchedPrivateWriteUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivateWriteUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersPartialUpdate(uuid, patchedPrivateWriteUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TopLevelPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersRetrieve(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivateWriteUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersRetrieve(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmailVerification} emailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersSendEmailVerification(emailVerification: EmailVerification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailVerification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersSendEmailVerification(emailVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersSendEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle a flag for a user.
         * @param {FlagToggleSerialiser} flagToggleSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersToggleFlag(flagToggleSerialiser: FlagToggleSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlagToggleSerialiser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersToggleFlag(flagToggleSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersToggleFlag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PrivateWriteUser} [privateWriteUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersUpdate(uuid: string, privateWriteUser?: PrivateWriteUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivateWriteUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersUpdate(uuid, privateWriteUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks authenticated payload Issues a custom token
         * @param {MetadataVerification} metadataVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUsersWidgetAuth(metadataVerification: MetadataVerification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUsersWidgetAuth(metadataVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.apiUsersWidgetAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} password 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authTokenCreate(username: string, password: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authTokenCreate(username, password, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.authTokenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {Prompt} prompt 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatHandler(communitySlug: string, prompt: Prompt, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatHandler(communitySlug, prompt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.chatHandler']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesAdminsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesAdminsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesAdminsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesAdminsRetrieve(communitySlug: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesAdminsRetrieve(communitySlug, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesAdminsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ChangelogEntryWrite} changelogEntryWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChangelogEntriesCreate(communitySlug: string, changelogEntryWrite: ChangelogEntryWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangelogEntryWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChangelogEntriesCreate(communitySlug, changelogEntryWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChangelogEntriesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChangelogEntriesDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChangelogEntriesDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChangelogEntriesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChangelogEntriesList(communitySlug: string, ordering?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedChangelogEntryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChangelogEntriesList(communitySlug, ordering, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChangelogEntriesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedChangelogEntryWrite} [patchedChangelogEntryWrite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChangelogEntriesPartialUpdate(communitySlug: string, uuid: string, patchedChangelogEntryWrite?: PatchedChangelogEntryWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangelogEntryWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChangelogEntriesPartialUpdate(communitySlug, uuid, patchedChangelogEntryWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChangelogEntriesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChangelogEntriesRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangelogEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChangelogEntriesRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChangelogEntriesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ChangelogEntryWrite} changelogEntryWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChangelogEntriesUpdate(communitySlug: string, uuid: string, changelogEntryWrite: ChangelogEntryWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangelogEntryWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChangelogEntriesUpdate(communitySlug, uuid, changelogEntryWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChangelogEntriesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} sessionId 
         * @param {string} traceId 
         * @param {ChatFeedback} chatFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesChatEvaluateTrace(communitySlug: string, sessionId: string, traceId: string, chatFeedback: ChatFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesChatEvaluateTrace(communitySlug, sessionId, traceId, chatFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesChatEvaluateTrace']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ContentLink} contentLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesContentLinksCreate(communitySlug: string, contentLink: ContentLink, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesContentLinksCreate(communitySlug, contentLink, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesContentLinksCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesContentLinksDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesContentLinksDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesContentLinksDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedContentLink} [patchedContentLink] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesContentLinksPartialUpdate(communitySlug: string, uuid: string, patchedContentLink?: PatchedContentLink, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesContentLinksPartialUpdate(communitySlug, uuid, patchedContentLink, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesContentLinksPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesContentLinksRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesContentLinksRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesContentLinksRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ContentLink} contentLink 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesContentLinksUpdate(communitySlug: string, uuid: string, contentLink: ContentLink, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentLink>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesContentLinksUpdate(communitySlug, uuid, contentLink, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesContentLinksUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesContextSourcesList(communitySlug: string, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContextSource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesContextSourcesList(communitySlug, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesContextSourcesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommunityCreation} [communityCreation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCreate(communityCreation?: CommunityCreation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Community>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCreate(communityCreation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {PatchedCommunityCRM} [patchedCommunityCRM] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCrm(slug: string, patchedCommunityCRM?: PatchedCommunityCRM, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCRM>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCrm(slug, patchedCommunityCRM, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCrm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {CustomSpaceContent} customSpaceContent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCustomSpacesContent(communitySlug: string, uuid: string, customSpaceContent: CustomSpaceContent, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSpaceContent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCustomSpacesContent(communitySlug, uuid, customSpaceContent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCustomSpacesContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CustomSpace} customSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCustomSpacesCreate(communitySlug: string, customSpace: CustomSpace, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCustomSpacesCreate(communitySlug, customSpace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCustomSpacesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCustomSpacesDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCustomSpacesDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCustomSpacesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedCustomSpace} [patchedCustomSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCustomSpacesPartialUpdate(communitySlug: string, uuid: string, patchedCustomSpace?: PatchedCustomSpace, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCustomSpacesPartialUpdate(communitySlug, uuid, patchedCustomSpace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCustomSpacesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCustomSpacesRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSpaceWithPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCustomSpacesRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCustomSpacesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {CustomSpace} customSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesCustomSpacesUpdate(communitySlug: string, uuid: string, customSpace: CustomSpace, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesCustomSpacesUpdate(communitySlug, uuid, customSpace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesCustomSpacesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * In order to set a key on the community, run: community.widget_secret = generate_hmac_secret() community.save()  Not adding an api route for that for safety reasons, in case the api somehow became exposed.
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDevelopmentGetAuthedPayload(communitySlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthedPayload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDevelopmentGetAuthedPayload(communitySlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDevelopmentGetAuthedPayload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsCreate(communitySlug: string, document: Document, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsCreate(communitySlug, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {CRDTDraft} cRDTDraft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsDraft(communitySlug: string, uuid: string, cRDTDraft: CRDTDraft, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsDraft(communitySlug, uuid, cRDTDraft, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsFavourite(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsFavourite(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsFavourite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedDocument} [patchedDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsPartialUpdate(communitySlug: string, uuid: string, patchedDocument?: PatchedDocument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsPartialUpdate(communitySlug, uuid, patchedDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentWithPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsUnfavourite(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsUnfavourite(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsUnfavourite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for documents without List.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Document} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesDocumentsUpdate(communitySlug: string, uuid: string, document: Document, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesDocumentsUpdate(communitySlug, uuid, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesDocumentsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {EscalationRule} escalationRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesEscalationRulesCreate(communitySlug: string, escalationRule: EscalationRule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesEscalationRulesCreate(communitySlug, escalationRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesEscalationRulesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesEscalationRulesDestroy(communitySlug: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesEscalationRulesDestroy(communitySlug, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesEscalationRulesDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {CommunitiesEscalationRulesListAgentEnum} [agent] * &#x60;zendesk&#x60; - Zendesk * &#x60;customer&#x60; - Customer
         * @param {number} [createdBy] 
         * @param {boolean} [enabled] 
         * @param {boolean} [isTriggeredEarly] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {boolean} [requiresConfirmation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesEscalationRulesList(communitySlug: string, agent?: CommunitiesEscalationRulesListAgentEnum, createdBy?: number, enabled?: boolean, isTriggeredEarly?: boolean, page?: number, requiresConfirmation?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEscalationRuleList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesEscalationRulesList(communitySlug, agent, createdBy, enabled, isTriggeredEarly, page, requiresConfirmation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesEscalationRulesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {PatchedEscalationRule} [patchedEscalationRule] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesEscalationRulesPartialUpdate(communitySlug: string, id: number, patchedEscalationRule?: PatchedEscalationRule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesEscalationRulesPartialUpdate(communitySlug, id, patchedEscalationRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesEscalationRulesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesEscalationRulesRetrieve(communitySlug: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesEscalationRulesRetrieve(communitySlug, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesEscalationRulesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this escalation rule.
         * @param {EscalationRule} escalationRule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesEscalationRulesUpdate(communitySlug: string, id: number, escalationRule: EscalationRule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EscalationRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesEscalationRulesUpdate(communitySlug, id, escalationRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesEscalationRulesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFavouritesList(communitySlug: string, ordering?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFavouriteList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFavouritesList(communitySlug, ordering, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFavouritesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {Folder} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersCreate(communitySlug: string, folder: Folder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersCreate(communitySlug, folder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Custom list that checks view perms on each doc.
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersList(communitySlug: string, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FolderWithPermissions>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersList(communitySlug, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Ordering} ordering 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersMoveDocument(communitySlug: string, uuid: string, ordering: Ordering, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ordering>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersMoveDocument(communitySlug, uuid, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersMoveDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedFolder} [patchedFolder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersPartialUpdate(communitySlug: string, uuid: string, patchedFolder?: PatchedFolder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersPartialUpdate(communitySlug, uuid, patchedFolder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderWithPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Folder} folder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesFoldersUpdate(communitySlug: string, uuid: string, folder: Folder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesFoldersUpdate(communitySlug, uuid, folder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesFoldersUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {boolean} [canAddForumthread] Only retrieve forum spaces that the user is allowed to add forum threads to
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [title] Only retrieve forum spaces beginning with title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesForumSpacesList(communitySlug: string, canAddForumthread?: boolean, ordering?: string, page?: number, title?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedForumSpaceWithPermissionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesForumSpacesList(communitySlug, canAddForumthread, ordering, page, title, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesForumSpacesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {WebHook} webHook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksCreate(communitySlug: string, webHook: WebHook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebHook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksCreate(communitySlug, webHook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksEventsList(communitySlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HookEvent>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksEventsList(communitySlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksEventsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedWebHookList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedWebHook} [patchedWebHook] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksPartialUpdate(communitySlug: string, uuid: string, patchedWebHook?: PatchedWebHook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebHook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksPartialUpdate(communitySlug, uuid, patchedWebHook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebHook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {WebHook} webHook 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesHooksUpdate(communitySlug: string, uuid: string, webHook: WebHook, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebHook>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesHooksUpdate(communitySlug, uuid, webHook, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesHooksUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {IntentWrite} intentWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesIntentsCreate(communitySlug: string, intentWrite: IntentWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntentWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesIntentsCreate(communitySlug, intentWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesIntentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesIntentsDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesIntentsDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesIntentsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesIntentsList(communitySlug: string, ordering?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedIntentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesIntentsList(communitySlug, ordering, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesIntentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedIntentWrite} [patchedIntentWrite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesIntentsPartialUpdate(communitySlug: string, uuid: string, patchedIntentWrite?: PatchedIntentWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntentWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesIntentsPartialUpdate(communitySlug, uuid, patchedIntentWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesIntentsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesIntentsRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Intent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesIntentsRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesIntentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD operations for Intents
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {IntentWrite} intentWrite 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesIntentsUpdate(communitySlug: string, uuid: string, intentWrite: IntentWrite, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntentWrite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesIntentsUpdate(communitySlug, uuid, intentWrite, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesIntentsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesInvitationsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedCommunityInvitationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesInvitationsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesInvitationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} inviteCode Invite code to check.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesInviteCodeCheck(communitySlug: string, inviteCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteCodeCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesInviteCodeCheck(communitySlug, inviteCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesInviteCodeCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This is slightly awkward and uncanonical in HTTP terms. The only ID supplied here is the parent community\'s, so this isn\'t actually a \"retrieve\" on the resource represented by CommunityInviteCodeViewset but rather a retrieve on the parent (as such perhaps it belongs back with the parent in the end).
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesInviteCodeGet(communitySlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityInviteCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesInviteCodeGet(communitySlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesInviteCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {InviteMember} inviteMember 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesInviteCodeInviteMember(communitySlug: string, inviteMember: InviteMember, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesInviteCodeInviteMember(communitySlug, inviteMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesInviteCodeInviteMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {InviteTeamMember} inviteTeamMember 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesInviteCodeInviteTeamMember(communitySlug: string, inviteTeamMember: InviteTeamMember, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesInviteCodeInviteTeamMember(communitySlug, inviteTeamMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesInviteCodeInviteTeamMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CommunityInviteCode} [communityInviteCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesInviteCodeRefresh(communitySlug: string, communityInviteCode?: CommunityInviteCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityInviteCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesInviteCodeRefresh(communitySlug, communityInviteCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesInviteCodeRefresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {LabelSerialiser} labelSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLabelsCreate(communitySlug: string, labelSerialiser: LabelSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelSerialiser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLabelsCreate(communitySlug, labelSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLabelsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLabelsDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLabelsDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLabelsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLabelsList(communitySlug: string, ordering?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedLabelSerialiserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLabelsList(communitySlug, ordering, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLabelsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedLabelSerialiser} [patchedLabelSerialiser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLabelsPartialUpdate(communitySlug: string, uuid: string, patchedLabelSerialiser?: PatchedLabelSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelSerialiser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLabelsPartialUpdate(communitySlug, uuid, patchedLabelSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLabelsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLabelsRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelSerialiser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLabelsRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLabelsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {LabelSerialiser} labelSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLabelsUpdate(communitySlug: string, uuid: string, labelSerialiser: LabelSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelSerialiser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLabelsUpdate(communitySlug, uuid, labelSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLabelsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] 
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [userIsAdmin] Only retrieve communities of which the user is an admin
         * @param {boolean} [userIsMember] Only retrieve communities of which the user is a member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesList(limit?: number, name?: string, offset?: number, ordering?: string, userIsAdmin?: boolean, userIsMember?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedCommunityList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesList(limit, name, offset, ordering, userIsAdmin, userIsMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Session and Trace analytics endpoint.
         * @param {string} communitySlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLlmSessionsAnalytics(communitySlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionAnalytics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLlmSessionsAnalytics(communitySlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLlmSessionsAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLlmSessionsAudit(communitySlug: string, slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLlmSessionsAudit(communitySlug, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLlmSessionsAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {boolean} [audited] 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {boolean} [escalated] 
         * @param {Array<string>} [intent] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {Array<string>} [rule] 
         * @param {CommunitiesLlmSessionsListSourceEnum} [source] * &#x60;widget&#x60; - Widget * &#x60;zendesk&#x60; - Zendesk * &#x60;intercom&#x60; - Intercom * &#x60;salesforce&#x60; - Salesforce * &#x60;copilot&#x60; - Copilot * &#x60;evals&#x60; - Evals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLlmSessionsList(communitySlug: string, audited?: boolean, createdAfter?: string, createdBefore?: string, escalated?: boolean, intent?: Array<string>, ordering?: string, page?: number, rule?: Array<string>, source?: CommunitiesLlmSessionsListSourceEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSessionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLlmSessionsList(communitySlug, audited, createdAfter, createdBefore, escalated, intent, ordering, page, rule, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLlmSessionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLlmSessionsRetrieve(communitySlug: string, slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLlmSessionsRetrieve(communitySlug, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLlmSessionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesLlmSessionsUnaudit(communitySlug: string, slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesLlmSessionsUnaudit(communitySlug, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesLlmSessionsUnaudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersDisableSlack(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersDisableSlack(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersDisableSlack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the email of a community member using PrivateUserSerializer.
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersGetEmail(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Email>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersGetEmail(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersGetEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersList(communitySlug: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersList(communitySlug, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersNotificationPreferences(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationChannelPreferences>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersNotificationPreferences(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedNotificationChannelPreference} [patchedNotificationChannelPreference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersNotificationPreferences2(communitySlug: string, uuid: string, patchedNotificationChannelPreference?: PatchedNotificationChannelPreference, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationChannelPreference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersNotificationPreferences2(communitySlug, uuid, patchedNotificationChannelPreference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersNotificationPreferences2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMembersRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMembersRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMembersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {Ordering} ordering 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesMoveSpaceGroup(slug: string, ordering: Ordering, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesMoveSpaceGroup(slug, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesMoveSpaceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesNotificationSubscriptions(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityNotifications>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesNotificationSubscriptions(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesNotificationSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {PatchedCommunityFull} [patchedCommunityFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPartialUpdate(slug: string, patchedCommunityFull?: PatchedCommunityFull, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Community>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPartialUpdate(slug, patchedCommunityFull, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPermissions(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPermissions(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ThreadPost} threadPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsCreate(communitySlug: string, threadPost: ThreadPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsCreate(communitySlug, threadPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} reactionUuid 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsDeleteReaction(communitySlug: string, reactionUuid: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsDeleteReaction(communitySlug, reactionUuid, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsDeleteReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [forumSpaceUuid] 
         * @param {string} [forumThreadUuid] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [page] The page number to use, starting from 1
         * @param {string} [replyToPostUuid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsList(communitySlug: string, forumSpaceUuid?: string, forumThreadUuid?: string, ordering?: string, page?: string, replyToPostUuid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedThreadPostWithPermissionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsList(communitySlug, forumSpaceUuid, forumThreadUuid, ordering, page, replyToPostUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedThreadPost} [patchedThreadPost] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsPartialUpdate(communitySlug: string, uuid: string, patchedThreadPost?: PatchedThreadPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsPartialUpdate(communitySlug, uuid, patchedThreadPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a reaction for post, returns the post with updated reaction list
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ReactionCreateSerialiser} reactionCreateSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsReaction(communitySlug: string, uuid: string, reactionCreateSerialiser: ReactionCreateSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsReaction(communitySlug, uuid, reactionCreateSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsRemoveUpvote(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsRemoveUpvote(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsRemoveUpvote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsReport(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsReport(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPostWithPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ThreadPost} threadPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsUpdate(communitySlug: string, uuid: string, threadPost: ThreadPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsUpdate(communitySlug, uuid, threadPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesPostsUpvote(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesPostsUpvote(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesPostsUpvote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesRetrieve(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Community>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesRetrieve(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesRolesList(communitySlug: string, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunityRole>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesRolesList(communitySlug, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesRolesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CommunitiesSemanticSearchGetEntityTypeEnum} entityType entity type
         * @param {string} uuid entity uuid to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSemanticSearchGet(communitySlug: string, entityType: CommunitiesSemanticSearchGetEntityTypeEnum, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SemanticRelations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSemanticSearchGet(communitySlug, entityType, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSemanticSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {CommunityIntercomAppId} communityIntercomAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSetIntercomAppId(slug: string, communityIntercomAppId: CommunityIntercomAppId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntercomOauthUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSetIntercomAppId(slug, communityIntercomAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSetIntercomAppId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {CommunityZendeskSubdomain} communityZendeskSubdomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSetZendeskSubdomain(slug: string, communityZendeskSubdomain: CommunityZendeskSubdomain, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZendeskOauthUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSetZendeskSubdomain(slug, communityZendeskSubdomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSetZendeskSubdomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {CommunitySignUpRequest} [communitySignUpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSignUpsCreate(communitySlug: string, communitySignUpRequest?: CommunitySignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunitySignUpRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSignUpsCreate(communitySlug, communitySignUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSignUpsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSignUpsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedCommunitySignUpRequestList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSignUpsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSignUpsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Snippets are just Documents that are marked as snippets (via the `is_snippet` field).  They are however used somewhat differently to normal documents. - Not included in the knowledge base product (ie. the folders tree api call) - In the agent, they can be used as context just like normal documents, but are not surfaced to users speaking   with the agent. They are however visible in conversation history (for debug purposes). Ie. they are a kind of   internal document that can have an impact on the agent\'s responses, but don\'t get shown to users.
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSnippetsList(communitySlug: string, ordering?: string, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDocumentList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSnippetsList(communitySlug, ordering, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSnippetsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {SpaceGroup} spaceGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsCreate(communitySlug: string, spaceGroup: SpaceGroup, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaceGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsCreate(communitySlug, spaceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Custom list that checks view perms on each space.
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedSpaceGroupList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {Ordering} ordering 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsMoveSpace(communitySlug: string, uuid: string, ordering: Ordering, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsMoveSpace(communitySlug, uuid, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsMoveSpace']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsNotificationsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedSpaceGroupWithNotificationsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsNotificationsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsNotificationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedSpaceGroup} [patchedSpaceGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsPartialUpdate(communitySlug: string, uuid: string, patchedSpaceGroup?: PatchedSpaceGroup, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaceGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsPartialUpdate(communitySlug, uuid, patchedSpaceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsPermsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedSpaceGroupWithPermissionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsPermsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsPermsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaceGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {SpaceGroup} spaceGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSpaceGroupsUpdate(communitySlug: string, uuid: string, spaceGroup: SpaceGroup, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpaceGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSpaceGroupsUpdate(communitySlug, uuid, spaceGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSpaceGroupsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSubscribeToNewMemberEvent(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityFull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSubscribeToNewMemberEvent(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSubscribeToNewMemberEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSwitchboardDisable(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwitchboardDisableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSwitchboardDisable(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSwitchboardDisable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesSwitchboardStatus(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SwitchboardStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesSwitchboardStatus(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesSwitchboardStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [cursor] Cursor to use for pagination
         * @param {Array<string>} [forumSpaceUuid] 
         * @param {Array<string>} [labelUuid] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [solved] 
         * @param {boolean} [unread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsAnnotationsList(communitySlug: string, cursor?: string, forumSpaceUuid?: Array<string>, labelUuid?: Array<string>, ordering?: string, solved?: boolean, unread?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedForumThreadWithAnnotationsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsAnnotationsList(communitySlug, cursor, forumSpaceUuid, labelUuid, ordering, solved, unread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsAnnotationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {ForumThread} forumThread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsCreate(communitySlug: string, forumThread: ForumThread, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsCreate(communitySlug, forumThread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsDeletePin(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsDeletePin(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsDeletePin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} reactionUuid 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsDeleteReaction(communitySlug: string, reactionUuid: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsDeleteReaction(communitySlug, reactionUuid, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsDeleteReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsDestroy(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsDestroy(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsFavourite(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsFavourite(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsFavourite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsHide(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsHide(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsHide']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [cursor] Cursor to use for pagination
         * @param {Array<string>} [forumSpaceUuid] 
         * @param {Array<string>} [labelUuid] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {boolean} [solved] 
         * @param {boolean} [unread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsList(communitySlug: string, cursor?: string, forumSpaceUuid?: Array<string>, labelUuid?: Array<string>, ordering?: string, solved?: boolean, unread?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedForumThreadMainFieldsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsList(communitySlug, cursor, forumSpaceUuid, labelUuid, ordering, solved, unread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsLock(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsLock(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsLock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsMaximize(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsMaximize(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsMaximize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {PatchedForumThread} [patchedForumThread] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsPartialUpdate(communitySlug: string, uuid: string, patchedForumThread?: PatchedForumThread, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsPartialUpdate(communitySlug, uuid, patchedForumThread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsPin(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsPin(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a reaction for thread, returns the Thread with updated reaction list
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ReactionCreateSerialiser} reactionCreateSerialiser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsReaction(communitySlug: string, uuid: string, reactionCreateSerialiser: ReactionCreateSerialiser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsReaction(communitySlug, uuid, reactionCreateSerialiser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsRemoveUpvote(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsRemoveUpvote(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsRemoveUpvote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsReport(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsReport(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsRetrieve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThreadWithPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsRetrieve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {SwitchSolution} switchSolution 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsSolve(communitySlug: string, uuid: string, switchSolution: SwitchSolution, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsSolve(communitySlug, uuid, switchSolution, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsSolve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsSubscribeToActivity(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsSubscribeToActivity(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsSubscribeToActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsSubscribeToReplies(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsSubscribeToReplies(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsSubscribeToReplies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnfavourite(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnfavourite(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnfavourite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnhide(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnhide(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnhide']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnlock(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnlock(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnmaximize(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnmaximize(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnmaximize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnsolve(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnsolve(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnsolve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnsubscribeFromActivity(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnsubscribeFromActivity(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnsubscribeFromActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUnsubscribeFromReplies(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUnsubscribeFromReplies(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUnsubscribeFromReplies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {ForumThread} forumThread 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUpdate(communitySlug: string, uuid: string, forumThread: ForumThread, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUpdate(communitySlug, uuid, forumThread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsUpvote(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsUpvote(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsUpvote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesThreadsVisit(communitySlug: string, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesThreadsVisit(communitySlug, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesThreadsVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of available tools based on community configuration, using LangChain tool definitions.
         * @param {string} communitySlug 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesToolsList(communitySlug: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedToolList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesToolsList(communitySlug, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesToolsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {TraceFeedback} traceFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesTraceFeedbackCreate(communitySlug: string, traceFeedback: TraceFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesTraceFeedbackCreate(communitySlug, traceFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesTraceFeedbackCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesTraceFeedbackDestroy(communitySlug: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesTraceFeedbackDestroy(communitySlug, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesTraceFeedbackDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} [author] 
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [trace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesTraceFeedbackList(communitySlug: string, author?: number, page?: number, trace?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTraceFeedbackList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesTraceFeedbackList(communitySlug, author, page, trace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesTraceFeedbackList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {PatchedTraceFeedback} [patchedTraceFeedback] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesTraceFeedbackPartialUpdate(communitySlug: string, id: number, patchedTraceFeedback?: PatchedTraceFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesTraceFeedbackPartialUpdate(communitySlug, id, patchedTraceFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesTraceFeedbackPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesTraceFeedbackRetrieve(communitySlug: string, id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesTraceFeedbackRetrieve(communitySlug, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesTraceFeedbackRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {string} communitySlug 
         * @param {number} id A unique integer value identifying this llm trace feedback.
         * @param {TraceFeedback} traceFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesTraceFeedbackUpdate(communitySlug: string, id: number, traceFeedback: TraceFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TraceFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesTraceFeedbackUpdate(communitySlug, id, traceFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesTraceFeedbackUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesUnsubscribeFromNewMemberEvent(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityFull>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesUnsubscribeFromNewMemberEvent(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesUnsubscribeFromNewMemberEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {CommunityFull} [communityFull] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesUpdate(slug: string, communityFull?: CommunityFull, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Community>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesUpdate(slug, communityFull, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesUserSessionsList(communitySlug: string, ordering?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserSessionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesUserSessionsList(communitySlug, ordering, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesUserSessionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communitiesUserSessionsRetrieve(communitySlug: string, slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSessionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communitiesUserSessionsRetrieve(communitySlug, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.communitiesUserSessionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} document UUID of the document to get feedback for
         * @param {string} modifiedAfter Start date of the feedback time range
         * @param {string} modifiedBefore End date of the feedback time range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentFeedbackCountCountForDoc(document: string, modifiedAfter: string, modifiedBefore: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentFeedbackCountCountForDoc(document, modifiedAfter, modifiedBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.documentFeedbackCountCountForDoc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for document feedback
         * @param {DocumentFeedback} documentFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentFeedbackCreate(documentFeedback: DocumentFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentFeedbackCreate(documentFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.documentFeedbackCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * CRUD for document feedback
         * @param {number} id A unique integer value identifying this document feedback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentFeedbackRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentFeedback>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentFeedbackRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.documentFeedbackRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ForumSpace} forumSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceCreate(forumSpace: ForumSpace, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceCreate(forumSpace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceDestroy(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceDestroy(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceFavourite(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceFavourite(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceFavourite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedForumSpace} [patchedForumSpace] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpacePartialUpdate(uuid: string, patchedForumSpace?: PatchedForumSpace, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpacePartialUpdate(uuid, patchedForumSpace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpacePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceRetrieve(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpaceWithPermissions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceRetrieve(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceSubscribeToActivity(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceSubscribeToActivity(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceSubscribeToActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceUnfavourite(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceUnfavourite(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceUnfavourite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceUnsubscribeFromActivity(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceUnsubscribeFromActivity(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceUnsubscribeFromActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {ForumSpace} forumSpace 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceUpdate(uuid: string, forumSpace: ForumSpace, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceUpdate(uuid, forumSpace, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumSpaceVisit(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumSpace>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumSpaceVisit(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.forumSpaceVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} community 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insightsNewMembersInsight(community: string, createdAfter?: string, createdBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Insight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insightsNewMembersInsight(community, createdAfter, createdBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.insightsNewMembersInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} community 
         * @param {string} [createdAfter] 
         * @param {string} [createdBefore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insightsThreadsCreatedInsight(community: string, createdAfter?: string, createdBefore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Insight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insightsThreadsCreatedInsight(community, createdAfter, createdBefore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.insightsThreadsCreatedInsight']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} url The url to use for extraction of open graph metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async opengraphExtract(url: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenGraph>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.opengraphExtract(url, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.opengraphExtract']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} organisationUuid 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationsCommunitiesList(organisationUuid: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedCommunityFullList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationsCommunitiesList(organisationUuid, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.organisationsCommunitiesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List organisations
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] 
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationsList(limit?: number, name?: string, offset?: number, ordering?: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedOrganisationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationsList(limit, name, offset, ordering, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.organisationsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedOrganisation} [patchedOrganisation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationsPartialUpdate(uuid: string, patchedOrganisation?: PatchedOrganisation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organisation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationsPartialUpdate(uuid, patchedOrganisation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.organisationsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationsRetrieve(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organisation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationsRetrieve(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.organisationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {Organisation} [organisation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organisationsUpdate(uuid: string, organisation?: Organisation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organisation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organisationsUpdate(uuid, organisation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.organisationsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedUserId} [patchedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleAddMember(uuid: string, patchedUserId?: PatchedUserId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleAddMember(uuid, patchedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleAddMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [communitySlug] Identifies the community that the community role should be created for.
         * @param {CommunityRole} [communityRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleCreate(communitySlug?: string, communityRole?: CommunityRole, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleCreate(communitySlug, communityRole, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleDestroy(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleDestroy(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedCommunityRole} [patchedCommunityRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolePartialUpdate(uuid: string, patchedCommunityRole?: PatchedCommunityRole, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolePartialUpdate(uuid, patchedCommunityRole, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.rolePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {PatchedUserId} [patchedUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleRemoveMember(uuid: string, patchedUserId?: PatchedUserId, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleRemoveMember(uuid, patchedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleRemoveMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleRetrieve(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleRetrieve(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {CommunityRole} [communityRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleUpdate(uuid: string, communityRole?: CommunityRole, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleUpdate(uuid, communityRole, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} uuid 
         * @param {UserIds} userIds 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async roleUpdateMembers(uuid: string, userIds: UserIds, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayOrPaginatedUserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.roleUpdateMembers(uuid, userIds, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.roleUpdateMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {string} [type] content link type to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchContentList(communitySlug: string, ordering?: string, page?: number, search?: string, type?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedContentLinkListItemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchContentList(communitySlug, ordering, page, search, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchContentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchContentPreviewsList(communitySlug: string, ordering?: string, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedContentSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchContentPreviewsList(communitySlug, ordering, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchContentPreviewsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocumentsList(communitySlug: string, ordering?: string, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDocumentSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocumentsList(communitySlug, ordering, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchDocumentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDocumentsV2List(communitySlug: string, ordering?: string, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDocumentSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDocumentsV2List(communitySlug, ordering, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchDocumentsV2List']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {string} [thread] thread uuid to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPostsList(communitySlug: string, author?: string, forum?: string, ordering?: string, page?: number, search?: string, thread?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPostSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPostsList(communitySlug, author, forum, ordering, page, search, thread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchPostsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {string} [thread] thread uuid to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchPostsV2List(communitySlug: string, author?: string, forum?: string, page?: number, search?: string, thread?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPostSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchPostsV2List(communitySlug, author, forum, page, search, thread, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchPostsV2List']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchThreadsList(communitySlug: string, author?: string, forum?: string, ordering?: string, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedThreadSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchThreadsList(communitySlug, author, forum, ordering, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchThreadsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} communitySlug 
         * @param {string} [author] author uuid to filter by
         * @param {string} [forum] forum to search within
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [search] Search string used to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchThreadsV2List(communitySlug: string, author?: string, forum?: string, page?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedThreadSearchResultList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchThreadsV2List(communitySlug, author, forum, page, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.searchThreadsV2List']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {number} [page] A page number within the paginated result set.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seoCommunityList(ordering?: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCommunitySEOSerialiserList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seoCommunityList(ordering, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OutverseApi.seoCommunityList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OutverseApi - factory interface
 * @export
 */
export const OutverseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OutverseApiFp(configuration)
    return {
        /**
         * 
         * @param {OutverseApiApiUsersCreateUserFromTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersCreateUserFromToken(requestParameters: OutverseApiApiUsersCreateUserFromTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserSerialiser> {
            return localVarFp.apiUsersCreateUserFromToken(requestParameters.createUserSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiApiUsersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersList(requestParameters: OutverseApiApiUsersListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedPrivateWriteUserList> {
            return localVarFp.apiUsersList(requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMe(options?: RawAxiosRequestConfig): AxiosPromise<PrivateWriteUser> {
            return localVarFp.apiUsersMe(options).then((request) => request(axios, basePath));
        },
        /**
         * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
         * @param {OutverseApiApiUsersMePartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersMePartialUpdate(requestParameters: OutverseApiApiUsersMePartialUpdateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PrivateWriteUser> {
            return localVarFp.apiUsersMePartialUpdate(requestParameters.patchedPrivateWriteUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiApiUsersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPartialUpdate(requestParameters: OutverseApiApiUsersPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrivateWriteUser> {
            return localVarFp.apiUsersPartialUpdate(requestParameters.uuid, requestParameters.patchedPrivateWriteUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersPermissions(options?: RawAxiosRequestConfig): AxiosPromise<TopLevelPermissions> {
            return localVarFp.apiUsersPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiApiUsersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersRetrieve(requestParameters: OutverseApiApiUsersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrivateWriteUser> {
            return localVarFp.apiUsersRetrieve(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiApiUsersSendEmailVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersSendEmailVerification(requestParameters: OutverseApiApiUsersSendEmailVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<EmailVerification> {
            return localVarFp.apiUsersSendEmailVerification(requestParameters.emailVerification, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle a flag for a user.
         * @param {OutverseApiApiUsersToggleFlagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersToggleFlag(requestParameters: OutverseApiApiUsersToggleFlagRequest, options?: RawAxiosRequestConfig): AxiosPromise<FlagToggleSerialiser> {
            return localVarFp.apiUsersToggleFlag(requestParameters.flagToggleSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiApiUsersUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersUpdate(requestParameters: OutverseApiApiUsersUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PrivateWriteUser> {
            return localVarFp.apiUsersUpdate(requestParameters.uuid, requestParameters.privateWriteUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks authenticated payload Issues a custom token
         * @param {OutverseApiApiUsersWidgetAuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUsersWidgetAuth(requestParameters: OutverseApiApiUsersWidgetAuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomToken> {
            return localVarFp.apiUsersWidgetAuth(requestParameters.metadataVerification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiAuthTokenCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenCreate(requestParameters: OutverseApiAuthTokenCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthToken> {
            return localVarFp.authTokenCreate(requestParameters.username, requestParameters.password, requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiChatHandlerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatHandler(requestParameters: OutverseApiChatHandlerRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.chatHandler(requestParameters.communitySlug, requestParameters.prompt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesAdminsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesAdminsList(requestParameters: OutverseApiCommunitiesAdminsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedUserList> {
            return localVarFp.communitiesAdminsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesAdminsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesAdminsRetrieve(requestParameters: OutverseApiCommunitiesAdminsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.communitiesAdminsRetrieve(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChangelogEntriesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesCreate(requestParameters: OutverseApiCommunitiesChangelogEntriesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangelogEntryWrite> {
            return localVarFp.communitiesChangelogEntriesCreate(requestParameters.communitySlug, requestParameters.changelogEntryWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChangelogEntriesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesDestroy(requestParameters: OutverseApiCommunitiesChangelogEntriesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesChangelogEntriesDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChangelogEntriesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesList(requestParameters: OutverseApiCommunitiesChangelogEntriesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedChangelogEntryList> {
            return localVarFp.communitiesChangelogEntriesList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChangelogEntriesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesPartialUpdate(requestParameters: OutverseApiCommunitiesChangelogEntriesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangelogEntryWrite> {
            return localVarFp.communitiesChangelogEntriesPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedChangelogEntryWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChangelogEntriesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesRetrieve(requestParameters: OutverseApiCommunitiesChangelogEntriesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangelogEntry> {
            return localVarFp.communitiesChangelogEntriesRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChangelogEntriesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChangelogEntriesUpdate(requestParameters: OutverseApiCommunitiesChangelogEntriesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangelogEntryWrite> {
            return localVarFp.communitiesChangelogEntriesUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.changelogEntryWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesChatEvaluateTraceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesChatEvaluateTrace(requestParameters: OutverseApiCommunitiesChatEvaluateTraceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesChatEvaluateTrace(requestParameters.communitySlug, requestParameters.sessionId, requestParameters.traceId, requestParameters.chatFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesContentLinksCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksCreate(requestParameters: OutverseApiCommunitiesContentLinksCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContentLink> {
            return localVarFp.communitiesContentLinksCreate(requestParameters.communitySlug, requestParameters.contentLink, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesContentLinksDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksDestroy(requestParameters: OutverseApiCommunitiesContentLinksDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesContentLinksDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesContentLinksPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksPartialUpdate(requestParameters: OutverseApiCommunitiesContentLinksPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContentLink> {
            return localVarFp.communitiesContentLinksPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedContentLink, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesContentLinksRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksRetrieve(requestParameters: OutverseApiCommunitiesContentLinksRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContentLink> {
            return localVarFp.communitiesContentLinksRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesContentLinksUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContentLinksUpdate(requestParameters: OutverseApiCommunitiesContentLinksUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContentLink> {
            return localVarFp.communitiesContentLinksUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.contentLink, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesContextSourcesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesContextSourcesList(requestParameters: OutverseApiCommunitiesContextSourcesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContextSource>> {
            return localVarFp.communitiesContextSourcesList(requestParameters.communitySlug, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCreate(requestParameters: OutverseApiCommunitiesCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Community> {
            return localVarFp.communitiesCreate(requestParameters.communityCreation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCrmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCrm(requestParameters: OutverseApiCommunitiesCrmRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityCRM> {
            return localVarFp.communitiesCrm(requestParameters.slug, requestParameters.patchedCommunityCRM, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCustomSpacesContentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesContent(requestParameters: OutverseApiCommunitiesCustomSpacesContentRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSpaceContent> {
            return localVarFp.communitiesCustomSpacesContent(requestParameters.communitySlug, requestParameters.uuid, requestParameters.customSpaceContent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCustomSpacesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesCreate(requestParameters: OutverseApiCommunitiesCustomSpacesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSpace> {
            return localVarFp.communitiesCustomSpacesCreate(requestParameters.communitySlug, requestParameters.customSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCustomSpacesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesDestroy(requestParameters: OutverseApiCommunitiesCustomSpacesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesCustomSpacesDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCustomSpacesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesPartialUpdate(requestParameters: OutverseApiCommunitiesCustomSpacesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSpace> {
            return localVarFp.communitiesCustomSpacesPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedCustomSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCustomSpacesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesRetrieve(requestParameters: OutverseApiCommunitiesCustomSpacesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSpaceWithPermissions> {
            return localVarFp.communitiesCustomSpacesRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesCustomSpacesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesCustomSpacesUpdate(requestParameters: OutverseApiCommunitiesCustomSpacesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomSpace> {
            return localVarFp.communitiesCustomSpacesUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.customSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * In order to set a key on the community, run: community.widget_secret = generate_hmac_secret() community.save()  Not adding an api route for that for safety reasons, in case the api somehow became exposed.
         * @param {OutverseApiCommunitiesDevelopmentGetAuthedPayloadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDevelopmentGetAuthedPayload(requestParameters: OutverseApiCommunitiesDevelopmentGetAuthedPayloadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthedPayload> {
            return localVarFp.communitiesDevelopmentGetAuthedPayload(requestParameters.communitySlug, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsCreate(requestParameters: OutverseApiCommunitiesDocumentsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.communitiesDocumentsCreate(requestParameters.communitySlug, requestParameters.document, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsDestroy(requestParameters: OutverseApiCommunitiesDocumentsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesDocumentsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsDraftRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsDraft(requestParameters: OutverseApiCommunitiesDocumentsDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.communitiesDocumentsDraft(requestParameters.communitySlug, requestParameters.uuid, requestParameters.cRDTDraft, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsFavouriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsFavourite(requestParameters: OutverseApiCommunitiesDocumentsFavouriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.communitiesDocumentsFavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsPartialUpdate(requestParameters: OutverseApiCommunitiesDocumentsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.communitiesDocumentsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsRetrieve(requestParameters: OutverseApiCommunitiesDocumentsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentWithPermissions> {
            return localVarFp.communitiesDocumentsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsUnfavouriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsUnfavourite(requestParameters: OutverseApiCommunitiesDocumentsUnfavouriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesDocumentsUnfavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for documents without List.
         * @param {OutverseApiCommunitiesDocumentsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesDocumentsUpdate(requestParameters: OutverseApiCommunitiesDocumentsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.communitiesDocumentsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.document, options).then((request) => request(axios, basePath));
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {OutverseApiCommunitiesEscalationRulesCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesCreate(requestParameters: OutverseApiCommunitiesEscalationRulesCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EscalationRule> {
            return localVarFp.communitiesEscalationRulesCreate(requestParameters.communitySlug, requestParameters.escalationRule, options).then((request) => request(axios, basePath));
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {OutverseApiCommunitiesEscalationRulesDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesDestroy(requestParameters: OutverseApiCommunitiesEscalationRulesDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesEscalationRulesDestroy(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {OutverseApiCommunitiesEscalationRulesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesList(requestParameters: OutverseApiCommunitiesEscalationRulesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEscalationRuleList> {
            return localVarFp.communitiesEscalationRulesList(requestParameters.communitySlug, requestParameters.agent, requestParameters.createdBy, requestParameters.enabled, requestParameters.isTriggeredEarly, requestParameters.page, requestParameters.requiresConfirmation, options).then((request) => request(axios, basePath));
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {OutverseApiCommunitiesEscalationRulesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesPartialUpdate(requestParameters: OutverseApiCommunitiesEscalationRulesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EscalationRule> {
            return localVarFp.communitiesEscalationRulesPartialUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.patchedEscalationRule, options).then((request) => request(axios, basePath));
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {OutverseApiCommunitiesEscalationRulesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesRetrieve(requestParameters: OutverseApiCommunitiesEscalationRulesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<EscalationRule> {
            return localVarFp.communitiesEscalationRulesRetrieve(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Escalation rules define a condition that triggers an escalation, created by admins/team members.
         * @param {OutverseApiCommunitiesEscalationRulesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesEscalationRulesUpdate(requestParameters: OutverseApiCommunitiesEscalationRulesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<EscalationRule> {
            return localVarFp.communitiesEscalationRulesUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.escalationRule, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFavouritesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFavouritesList(requestParameters: OutverseApiCommunitiesFavouritesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedFavouriteList> {
            return localVarFp.communitiesFavouritesList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFoldersCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersCreate(requestParameters: OutverseApiCommunitiesFoldersCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Folder> {
            return localVarFp.communitiesFoldersCreate(requestParameters.communitySlug, requestParameters.folder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFoldersDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersDestroy(requestParameters: OutverseApiCommunitiesFoldersDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesFoldersDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Custom list that checks view perms on each doc.
         * @param {OutverseApiCommunitiesFoldersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersList(requestParameters: OutverseApiCommunitiesFoldersListRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<FolderWithPermissions>> {
            return localVarFp.communitiesFoldersList(requestParameters.communitySlug, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFoldersMoveDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersMoveDocument(requestParameters: OutverseApiCommunitiesFoldersMoveDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Ordering> {
            return localVarFp.communitiesFoldersMoveDocument(requestParameters.communitySlug, requestParameters.uuid, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFoldersPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersPartialUpdate(requestParameters: OutverseApiCommunitiesFoldersPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Folder> {
            return localVarFp.communitiesFoldersPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedFolder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFoldersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersRetrieve(requestParameters: OutverseApiCommunitiesFoldersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<FolderWithPermissions> {
            return localVarFp.communitiesFoldersRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesFoldersUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesFoldersUpdate(requestParameters: OutverseApiCommunitiesFoldersUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Folder> {
            return localVarFp.communitiesFoldersUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.folder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesForumSpacesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesForumSpacesList(requestParameters: OutverseApiCommunitiesForumSpacesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedForumSpaceWithPermissionsList> {
            return localVarFp.communitiesForumSpacesList(requestParameters.communitySlug, requestParameters.canAddForumthread, requestParameters.ordering, requestParameters.page, requestParameters.title, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksCreate(requestParameters: OutverseApiCommunitiesHooksCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebHook> {
            return localVarFp.communitiesHooksCreate(requestParameters.communitySlug, requestParameters.webHook, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksDestroy(requestParameters: OutverseApiCommunitiesHooksDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesHooksDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksEventsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksEventsList(requestParameters: OutverseApiCommunitiesHooksEventsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<HookEvent>> {
            return localVarFp.communitiesHooksEventsList(requestParameters.communitySlug, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksList(requestParameters: OutverseApiCommunitiesHooksListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedWebHookList> {
            return localVarFp.communitiesHooksList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksPartialUpdate(requestParameters: OutverseApiCommunitiesHooksPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebHook> {
            return localVarFp.communitiesHooksPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedWebHook, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksRetrieve(requestParameters: OutverseApiCommunitiesHooksRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebHook> {
            return localVarFp.communitiesHooksRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve, create, update or destroy webhooks.
         * @param {OutverseApiCommunitiesHooksUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesHooksUpdate(requestParameters: OutverseApiCommunitiesHooksUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebHook> {
            return localVarFp.communitiesHooksUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.webHook, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD operations for Intents
         * @param {OutverseApiCommunitiesIntentsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsCreate(requestParameters: OutverseApiCommunitiesIntentsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntentWrite> {
            return localVarFp.communitiesIntentsCreate(requestParameters.communitySlug, requestParameters.intentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD operations for Intents
         * @param {OutverseApiCommunitiesIntentsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsDestroy(requestParameters: OutverseApiCommunitiesIntentsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesIntentsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD operations for Intents
         * @param {OutverseApiCommunitiesIntentsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsList(requestParameters: OutverseApiCommunitiesIntentsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedIntentList> {
            return localVarFp.communitiesIntentsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD operations for Intents
         * @param {OutverseApiCommunitiesIntentsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsPartialUpdate(requestParameters: OutverseApiCommunitiesIntentsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntentWrite> {
            return localVarFp.communitiesIntentsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedIntentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD operations for Intents
         * @param {OutverseApiCommunitiesIntentsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsRetrieve(requestParameters: OutverseApiCommunitiesIntentsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Intent> {
            return localVarFp.communitiesIntentsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD operations for Intents
         * @param {OutverseApiCommunitiesIntentsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesIntentsUpdate(requestParameters: OutverseApiCommunitiesIntentsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntentWrite> {
            return localVarFp.communitiesIntentsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.intentWrite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesInvitationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInvitationsList(requestParameters: OutverseApiCommunitiesInvitationsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedCommunityInvitationList> {
            return localVarFp.communitiesInvitationsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesInviteCodeCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeCheck(requestParameters: OutverseApiCommunitiesInviteCodeCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteCodeCheckResponse> {
            return localVarFp.communitiesInviteCodeCheck(requestParameters.communitySlug, requestParameters.inviteCode, options).then((request) => request(axios, basePath));
        },
        /**
         * This is slightly awkward and uncanonical in HTTP terms. The only ID supplied here is the parent community\'s, so this isn\'t actually a \"retrieve\" on the resource represented by CommunityInviteCodeViewset but rather a retrieve on the parent (as such perhaps it belongs back with the parent in the end).
         * @param {OutverseApiCommunitiesInviteCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeGet(requestParameters: OutverseApiCommunitiesInviteCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityInviteCode> {
            return localVarFp.communitiesInviteCodeGet(requestParameters.communitySlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesInviteCodeInviteMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeInviteMember(requestParameters: OutverseApiCommunitiesInviteCodeInviteMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesInviteCodeInviteMember(requestParameters.communitySlug, requestParameters.inviteMember, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesInviteCodeInviteTeamMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeInviteTeamMember(requestParameters: OutverseApiCommunitiesInviteCodeInviteTeamMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesInviteCodeInviteTeamMember(requestParameters.communitySlug, requestParameters.inviteTeamMember, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesInviteCodeRefreshRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesInviteCodeRefresh(requestParameters: OutverseApiCommunitiesInviteCodeRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityInviteCode> {
            return localVarFp.communitiesInviteCodeRefresh(requestParameters.communitySlug, requestParameters.communityInviteCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesLabelsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsCreate(requestParameters: OutverseApiCommunitiesLabelsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabelSerialiser> {
            return localVarFp.communitiesLabelsCreate(requestParameters.communitySlug, requestParameters.labelSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesLabelsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsDestroy(requestParameters: OutverseApiCommunitiesLabelsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesLabelsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesLabelsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsList(requestParameters: OutverseApiCommunitiesLabelsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedLabelSerialiserList> {
            return localVarFp.communitiesLabelsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesLabelsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsPartialUpdate(requestParameters: OutverseApiCommunitiesLabelsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabelSerialiser> {
            return localVarFp.communitiesLabelsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedLabelSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesLabelsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsRetrieve(requestParameters: OutverseApiCommunitiesLabelsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabelSerialiser> {
            return localVarFp.communitiesLabelsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesLabelsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLabelsUpdate(requestParameters: OutverseApiCommunitiesLabelsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabelSerialiser> {
            return localVarFp.communitiesLabelsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.labelSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesList(requestParameters: OutverseApiCommunitiesListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedCommunityList> {
            return localVarFp.communitiesList(requestParameters.limit, requestParameters.name, requestParameters.offset, requestParameters.ordering, requestParameters.userIsAdmin, requestParameters.userIsMember, options).then((request) => request(axios, basePath));
        },
        /**
         * Session and Trace analytics endpoint.
         * @param {OutverseApiCommunitiesLlmSessionsAnalyticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsAnalytics(requestParameters: OutverseApiCommunitiesLlmSessionsAnalyticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionAnalytics> {
            return localVarFp.communitiesLlmSessionsAnalytics(requestParameters.communitySlug, options).then((request) => request(axios, basePath));
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {OutverseApiCommunitiesLlmSessionsAuditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsAudit(requestParameters: OutverseApiCommunitiesLlmSessionsAuditRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionDetail> {
            return localVarFp.communitiesLlmSessionsAudit(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {OutverseApiCommunitiesLlmSessionsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsList(requestParameters: OutverseApiCommunitiesLlmSessionsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedSessionList> {
            return localVarFp.communitiesLlmSessionsList(requestParameters.communitySlug, requestParameters.audited, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.escalated, requestParameters.intent, requestParameters.ordering, requestParameters.page, requestParameters.rule, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {OutverseApiCommunitiesLlmSessionsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsRetrieve(requestParameters: OutverseApiCommunitiesLlmSessionsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<SessionDetail> {
            return localVarFp.communitiesLlmSessionsRetrieve(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
         * @param {OutverseApiCommunitiesLlmSessionsUnauditRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesLlmSessionsUnaudit(requestParameters: OutverseApiCommunitiesLlmSessionsUnauditRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesLlmSessionsUnaudit(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMembersDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersDestroy(requestParameters: OutverseApiCommunitiesMembersDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesMembersDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMembersDisableSlackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersDisableSlack(requestParameters: OutverseApiCommunitiesMembersDisableSlackRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.communitiesMembersDisableSlack(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the email of a community member using PrivateUserSerializer.
         * @param {OutverseApiCommunitiesMembersGetEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersGetEmail(requestParameters: OutverseApiCommunitiesMembersGetEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<Email> {
            return localVarFp.communitiesMembersGetEmail(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMembersListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersList(requestParameters: OutverseApiCommunitiesMembersListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedUserList> {
            return localVarFp.communitiesMembersList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMembersNotificationPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersNotificationPreferences(requestParameters: OutverseApiCommunitiesMembersNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationChannelPreferences> {
            return localVarFp.communitiesMembersNotificationPreferences(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMembersNotificationPreferences2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersNotificationPreferences2(requestParameters: OutverseApiCommunitiesMembersNotificationPreferences2Request, options?: RawAxiosRequestConfig): AxiosPromise<NotificationChannelPreference> {
            return localVarFp.communitiesMembersNotificationPreferences2(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedNotificationChannelPreference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMembersRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMembersRetrieve(requestParameters: OutverseApiCommunitiesMembersRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.communitiesMembersRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesMoveSpaceGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesMoveSpaceGroup(requestParameters: OutverseApiCommunitiesMoveSpaceGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesMoveSpaceGroup(requestParameters.slug, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesNotificationSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesNotificationSubscriptions(requestParameters: OutverseApiCommunitiesNotificationSubscriptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityNotifications> {
            return localVarFp.communitiesNotificationSubscriptions(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPartialUpdate(requestParameters: OutverseApiCommunitiesPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Community> {
            return localVarFp.communitiesPartialUpdate(requestParameters.slug, requestParameters.patchedCommunityFull, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPermissions(requestParameters: OutverseApiCommunitiesPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityPermissions> {
            return localVarFp.communitiesPermissions(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsCreate(requestParameters: OutverseApiCommunitiesPostsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPost> {
            return localVarFp.communitiesPostsCreate(requestParameters.communitySlug, requestParameters.threadPost, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsDeleteReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsDeleteReaction(requestParameters: OutverseApiCommunitiesPostsDeleteReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesPostsDeleteReaction(requestParameters.communitySlug, requestParameters.reactionUuid, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsDestroy(requestParameters: OutverseApiCommunitiesPostsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesPostsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsList(requestParameters: OutverseApiCommunitiesPostsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedThreadPostWithPermissionsList> {
            return localVarFp.communitiesPostsList(requestParameters.communitySlug, requestParameters.forumSpaceUuid, requestParameters.forumThreadUuid, requestParameters.ordering, requestParameters.page, requestParameters.replyToPostUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsPartialUpdate(requestParameters: OutverseApiCommunitiesPostsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPost> {
            return localVarFp.communitiesPostsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedThreadPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a reaction for post, returns the post with updated reaction list
         * @param {OutverseApiCommunitiesPostsReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsReaction(requestParameters: OutverseApiCommunitiesPostsReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPost> {
            return localVarFp.communitiesPostsReaction(requestParameters.communitySlug, requestParameters.uuid, requestParameters.reactionCreateSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsRemoveUpvoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsRemoveUpvote(requestParameters: OutverseApiCommunitiesPostsRemoveUpvoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesPostsRemoveUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsReport(requestParameters: OutverseApiCommunitiesPostsReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPost> {
            return localVarFp.communitiesPostsReport(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsRetrieve(requestParameters: OutverseApiCommunitiesPostsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPostWithPermissions> {
            return localVarFp.communitiesPostsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsUpdate(requestParameters: OutverseApiCommunitiesPostsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPost> {
            return localVarFp.communitiesPostsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.threadPost, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesPostsUpvoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesPostsUpvote(requestParameters: OutverseApiCommunitiesPostsUpvoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThreadPost> {
            return localVarFp.communitiesPostsUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesRetrieve(requestParameters: OutverseApiCommunitiesRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Community> {
            return localVarFp.communitiesRetrieve(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesRolesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesRolesList(requestParameters: OutverseApiCommunitiesRolesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommunityRole>> {
            return localVarFp.communitiesRolesList(requestParameters.communitySlug, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSemanticSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSemanticSearchGet(requestParameters: OutverseApiCommunitiesSemanticSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SemanticRelations> {
            return localVarFp.communitiesSemanticSearchGet(requestParameters.communitySlug, requestParameters.entityType, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSetIntercomAppIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSetIntercomAppId(requestParameters: OutverseApiCommunitiesSetIntercomAppIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<IntercomOauthUrlResponse> {
            return localVarFp.communitiesSetIntercomAppId(requestParameters.slug, requestParameters.communityIntercomAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSetZendeskSubdomainRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSetZendeskSubdomain(requestParameters: OutverseApiCommunitiesSetZendeskSubdomainRequest, options?: RawAxiosRequestConfig): AxiosPromise<ZendeskOauthUrlResponse> {
            return localVarFp.communitiesSetZendeskSubdomain(requestParameters.slug, requestParameters.communityZendeskSubdomain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSignUpsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSignUpsCreate(requestParameters: OutverseApiCommunitiesSignUpsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunitySignUpRequest> {
            return localVarFp.communitiesSignUpsCreate(requestParameters.communitySlug, requestParameters.communitySignUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSignUpsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSignUpsList(requestParameters: OutverseApiCommunitiesSignUpsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedCommunitySignUpRequestList> {
            return localVarFp.communitiesSignUpsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Snippets are just Documents that are marked as snippets (via the `is_snippet` field).  They are however used somewhat differently to normal documents. - Not included in the knowledge base product (ie. the folders tree api call) - In the agent, they can be used as context just like normal documents, but are not surfaced to users speaking   with the agent. They are however visible in conversation history (for debug purposes). Ie. they are a kind of   internal document that can have an impact on the agent\'s responses, but don\'t get shown to users.
         * @param {OutverseApiCommunitiesSnippetsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSnippetsList(requestParameters: OutverseApiCommunitiesSnippetsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDocumentList> {
            return localVarFp.communitiesSnippetsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsCreate(requestParameters: OutverseApiCommunitiesSpaceGroupsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpaceGroup> {
            return localVarFp.communitiesSpaceGroupsCreate(requestParameters.communitySlug, requestParameters.spaceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsDestroy(requestParameters: OutverseApiCommunitiesSpaceGroupsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesSpaceGroupsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Custom list that checks view perms on each space.
         * @param {OutverseApiCommunitiesSpaceGroupsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsList(requestParameters: OutverseApiCommunitiesSpaceGroupsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedSpaceGroupList> {
            return localVarFp.communitiesSpaceGroupsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsMoveSpaceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsMoveSpace(requestParameters: OutverseApiCommunitiesSpaceGroupsMoveSpaceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesSpaceGroupsMoveSpace(requestParameters.communitySlug, requestParameters.uuid, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsNotificationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsNotificationsList(requestParameters: OutverseApiCommunitiesSpaceGroupsNotificationsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedSpaceGroupWithNotificationsList> {
            return localVarFp.communitiesSpaceGroupsNotificationsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsPartialUpdate(requestParameters: OutverseApiCommunitiesSpaceGroupsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpaceGroup> {
            return localVarFp.communitiesSpaceGroupsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedSpaceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsPermsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsPermsList(requestParameters: OutverseApiCommunitiesSpaceGroupsPermsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedSpaceGroupWithPermissionsList> {
            return localVarFp.communitiesSpaceGroupsPermsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsRetrieve(requestParameters: OutverseApiCommunitiesSpaceGroupsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpaceGroup> {
            return localVarFp.communitiesSpaceGroupsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSpaceGroupsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSpaceGroupsUpdate(requestParameters: OutverseApiCommunitiesSpaceGroupsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpaceGroup> {
            return localVarFp.communitiesSpaceGroupsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.spaceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSubscribeToNewMemberEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSubscribeToNewMemberEvent(requestParameters: OutverseApiCommunitiesSubscribeToNewMemberEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityFull> {
            return localVarFp.communitiesSubscribeToNewMemberEvent(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSwitchboardDisableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSwitchboardDisable(requestParameters: OutverseApiCommunitiesSwitchboardDisableRequest, options?: RawAxiosRequestConfig): AxiosPromise<SwitchboardDisableResponse> {
            return localVarFp.communitiesSwitchboardDisable(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesSwitchboardStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesSwitchboardStatus(requestParameters: OutverseApiCommunitiesSwitchboardStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SwitchboardStatus> {
            return localVarFp.communitiesSwitchboardStatus(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsAnnotationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsAnnotationsList(requestParameters: OutverseApiCommunitiesThreadsAnnotationsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedForumThreadWithAnnotationsList> {
            return localVarFp.communitiesThreadsAnnotationsList(requestParameters.communitySlug, requestParameters.cursor, requestParameters.forumSpaceUuid, requestParameters.labelUuid, requestParameters.ordering, requestParameters.solved, requestParameters.unread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsCreate(requestParameters: OutverseApiCommunitiesThreadsCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsCreate(requestParameters.communitySlug, requestParameters.forumThread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsDeletePinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsDeletePin(requestParameters: OutverseApiCommunitiesThreadsDeletePinRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsDeletePin(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsDeleteReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsDeleteReaction(requestParameters: OutverseApiCommunitiesThreadsDeleteReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsDeleteReaction(requestParameters.communitySlug, requestParameters.reactionUuid, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsDestroy(requestParameters: OutverseApiCommunitiesThreadsDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsFavouriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsFavourite(requestParameters: OutverseApiCommunitiesThreadsFavouriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsFavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsHideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsHide(requestParameters: OutverseApiCommunitiesThreadsHideRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsHide(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsList(requestParameters: OutverseApiCommunitiesThreadsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedForumThreadMainFieldsList> {
            return localVarFp.communitiesThreadsList(requestParameters.communitySlug, requestParameters.cursor, requestParameters.forumSpaceUuid, requestParameters.labelUuid, requestParameters.ordering, requestParameters.solved, requestParameters.unread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsLockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsLock(requestParameters: OutverseApiCommunitiesThreadsLockRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsLock(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsMaximizeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsMaximize(requestParameters: OutverseApiCommunitiesThreadsMaximizeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsMaximize(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsPartialUpdate(requestParameters: OutverseApiCommunitiesThreadsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedForumThread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsPinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsPin(requestParameters: OutverseApiCommunitiesThreadsPinRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsPin(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a reaction for thread, returns the Thread with updated reaction list
         * @param {OutverseApiCommunitiesThreadsReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsReaction(requestParameters: OutverseApiCommunitiesThreadsReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsReaction(requestParameters.communitySlug, requestParameters.uuid, requestParameters.reactionCreateSerialiser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsRemoveUpvoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsRemoveUpvote(requestParameters: OutverseApiCommunitiesThreadsRemoveUpvoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsRemoveUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsReport(requestParameters: OutverseApiCommunitiesThreadsReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsReport(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsRetrieve(requestParameters: OutverseApiCommunitiesThreadsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThreadWithPermissions> {
            return localVarFp.communitiesThreadsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsSolveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsSolve(requestParameters: OutverseApiCommunitiesThreadsSolveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsSolve(requestParameters.communitySlug, requestParameters.uuid, requestParameters.switchSolution, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsSubscribeToActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsSubscribeToActivity(requestParameters: OutverseApiCommunitiesThreadsSubscribeToActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsSubscribeToActivity(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsSubscribeToRepliesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsSubscribeToReplies(requestParameters: OutverseApiCommunitiesThreadsSubscribeToRepliesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsSubscribeToReplies(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnfavouriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnfavourite(requestParameters: OutverseApiCommunitiesThreadsUnfavouriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsUnfavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnhideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnhide(requestParameters: OutverseApiCommunitiesThreadsUnhideRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsUnhide(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnlockRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnlock(requestParameters: OutverseApiCommunitiesThreadsUnlockRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsUnlock(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnmaximizeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnmaximize(requestParameters: OutverseApiCommunitiesThreadsUnmaximizeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsUnmaximize(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnsolveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnsolve(requestParameters: OutverseApiCommunitiesThreadsUnsolveRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesThreadsUnsolve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnsubscribeFromActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnsubscribeFromActivity(requestParameters: OutverseApiCommunitiesThreadsUnsubscribeFromActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsUnsubscribeFromActivity(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUnsubscribeFromRepliesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUnsubscribeFromReplies(requestParameters: OutverseApiCommunitiesThreadsUnsubscribeFromRepliesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsUnsubscribeFromReplies(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUpdate(requestParameters: OutverseApiCommunitiesThreadsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.forumThread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsUpvoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsUpvote(requestParameters: OutverseApiCommunitiesThreadsUpvoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesThreadsVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesThreadsVisit(requestParameters: OutverseApiCommunitiesThreadsVisitRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumThread> {
            return localVarFp.communitiesThreadsVisit(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of available tools based on community configuration, using LangChain tool definitions.
         * @param {OutverseApiCommunitiesToolsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesToolsList(requestParameters: OutverseApiCommunitiesToolsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedToolList> {
            return localVarFp.communitiesToolsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {OutverseApiCommunitiesTraceFeedbackCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackCreate(requestParameters: OutverseApiCommunitiesTraceFeedbackCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceFeedback> {
            return localVarFp.communitiesTraceFeedbackCreate(requestParameters.communitySlug, requestParameters.traceFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {OutverseApiCommunitiesTraceFeedbackDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackDestroy(requestParameters: OutverseApiCommunitiesTraceFeedbackDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.communitiesTraceFeedbackDestroy(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {OutverseApiCommunitiesTraceFeedbackListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackList(requestParameters: OutverseApiCommunitiesTraceFeedbackListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTraceFeedbackList> {
            return localVarFp.communitiesTraceFeedbackList(requestParameters.communitySlug, requestParameters.author, requestParameters.page, requestParameters.trace, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {OutverseApiCommunitiesTraceFeedbackPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackPartialUpdate(requestParameters: OutverseApiCommunitiesTraceFeedbackPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceFeedback> {
            return localVarFp.communitiesTraceFeedbackPartialUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.patchedTraceFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {OutverseApiCommunitiesTraceFeedbackRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackRetrieve(requestParameters: OutverseApiCommunitiesTraceFeedbackRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceFeedback> {
            return localVarFp.communitiesTraceFeedbackRetrieve(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
         * @param {OutverseApiCommunitiesTraceFeedbackUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesTraceFeedbackUpdate(requestParameters: OutverseApiCommunitiesTraceFeedbackUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TraceFeedback> {
            return localVarFp.communitiesTraceFeedbackUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.traceFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesUnsubscribeFromNewMemberEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUnsubscribeFromNewMemberEvent(requestParameters: OutverseApiCommunitiesUnsubscribeFromNewMemberEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityFull> {
            return localVarFp.communitiesUnsubscribeFromNewMemberEvent(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUpdate(requestParameters: OutverseApiCommunitiesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Community> {
            return localVarFp.communitiesUpdate(requestParameters.slug, requestParameters.communityFull, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesUserSessionsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUserSessionsList(requestParameters: OutverseApiCommunitiesUserSessionsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUserSessionList> {
            return localVarFp.communitiesUserSessionsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiCommunitiesUserSessionsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communitiesUserSessionsRetrieve(requestParameters: OutverseApiCommunitiesUserSessionsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSessionDetail> {
            return localVarFp.communitiesUserSessionsRetrieve(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiDocumentFeedbackCountCountForDocRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentFeedbackCountCountForDoc(requestParameters: OutverseApiDocumentFeedbackCountCountForDocRequest, options?: RawAxiosRequestConfig): AxiosPromise<FeedbackCount> {
            return localVarFp.documentFeedbackCountCountForDoc(requestParameters.document, requestParameters.modifiedAfter, requestParameters.modifiedBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for document feedback
         * @param {OutverseApiDocumentFeedbackCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentFeedbackCreate(requestParameters: OutverseApiDocumentFeedbackCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentFeedback> {
            return localVarFp.documentFeedbackCreate(requestParameters.documentFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * CRUD for document feedback
         * @param {OutverseApiDocumentFeedbackRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentFeedbackRetrieve(requestParameters: OutverseApiDocumentFeedbackRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<DocumentFeedback> {
            return localVarFp.documentFeedbackRetrieve(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceCreate(requestParameters: OutverseApiForumSpaceCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpaceCreate(requestParameters.forumSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceDestroy(requestParameters: OutverseApiForumSpaceDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forumSpaceDestroy(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceFavouriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceFavourite(requestParameters: OutverseApiForumSpaceFavouriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpaceFavourite(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpacePartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpacePartialUpdate(requestParameters: OutverseApiForumSpacePartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpacePartialUpdate(requestParameters.uuid, requestParameters.patchedForumSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceRetrieve(requestParameters: OutverseApiForumSpaceRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpaceWithPermissions> {
            return localVarFp.forumSpaceRetrieve(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceSubscribeToActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceSubscribeToActivity(requestParameters: OutverseApiForumSpaceSubscribeToActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpaceSubscribeToActivity(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceUnfavouriteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceUnfavourite(requestParameters: OutverseApiForumSpaceUnfavouriteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forumSpaceUnfavourite(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceUnsubscribeFromActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceUnsubscribeFromActivity(requestParameters: OutverseApiForumSpaceUnsubscribeFromActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpaceUnsubscribeFromActivity(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceUpdate(requestParameters: OutverseApiForumSpaceUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpaceUpdate(requestParameters.uuid, requestParameters.forumSpace, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiForumSpaceVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumSpaceVisit(requestParameters: OutverseApiForumSpaceVisitRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForumSpace> {
            return localVarFp.forumSpaceVisit(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiInsightsNewMembersInsightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightsNewMembersInsight(requestParameters: OutverseApiInsightsNewMembersInsightRequest, options?: RawAxiosRequestConfig): AxiosPromise<Insight> {
            return localVarFp.insightsNewMembersInsight(requestParameters.community, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiInsightsThreadsCreatedInsightRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightsThreadsCreatedInsight(requestParameters: OutverseApiInsightsThreadsCreatedInsightRequest, options?: RawAxiosRequestConfig): AxiosPromise<Insight> {
            return localVarFp.insightsThreadsCreatedInsight(requestParameters.community, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiOpengraphExtractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        opengraphExtract(requestParameters: OutverseApiOpengraphExtractRequest, options?: RawAxiosRequestConfig): AxiosPromise<OpenGraph> {
            return localVarFp.opengraphExtract(requestParameters.url, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiOrganisationsCommunitiesListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsCommunitiesList(requestParameters: OutverseApiOrganisationsCommunitiesListRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedCommunityFullList> {
            return localVarFp.organisationsCommunitiesList(requestParameters.organisationUuid, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * List organisations
         * @param {OutverseApiOrganisationsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsList(requestParameters: OutverseApiOrganisationsListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedOrganisationList> {
            return localVarFp.organisationsList(requestParameters.limit, requestParameters.name, requestParameters.offset, requestParameters.ordering, requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiOrganisationsPartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsPartialUpdate(requestParameters: OutverseApiOrganisationsPartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organisation> {
            return localVarFp.organisationsPartialUpdate(requestParameters.uuid, requestParameters.patchedOrganisation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiOrganisationsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsRetrieve(requestParameters: OutverseApiOrganisationsRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organisation> {
            return localVarFp.organisationsRetrieve(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiOrganisationsUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organisationsUpdate(requestParameters: OutverseApiOrganisationsUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Organisation> {
            return localVarFp.organisationsUpdate(requestParameters.uuid, requestParameters.organisation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleAddMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleAddMember(requestParameters: OutverseApiRoleAddMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleAddMember(requestParameters.uuid, requestParameters.patchedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleCreate(requestParameters: OutverseApiRoleCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CommunityRole> {
            return localVarFp.roleCreate(requestParameters.communitySlug, requestParameters.communityRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleDestroyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleDestroy(requestParameters: OutverseApiRoleDestroyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleDestroy(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRolePartialUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolePartialUpdate(requestParameters: OutverseApiRolePartialUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityRole> {
            return localVarFp.rolePartialUpdate(requestParameters.uuid, requestParameters.patchedCommunityRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleRemoveMemberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleRemoveMember(requestParameters: OutverseApiRoleRemoveMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.roleRemoveMember(requestParameters.uuid, requestParameters.patchedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleRetrieve(requestParameters: OutverseApiRoleRetrieveRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityRole> {
            return localVarFp.roleRetrieve(requestParameters.uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleUpdate(requestParameters: OutverseApiRoleUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityRole> {
            return localVarFp.roleUpdate(requestParameters.uuid, requestParameters.communityRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiRoleUpdateMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        roleUpdateMembers(requestParameters: OutverseApiRoleUpdateMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArrayOrPaginatedUserList> {
            return localVarFp.roleUpdateMembers(requestParameters.uuid, requestParameters.userIds, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchContentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContentList(requestParameters: OutverseApiSearchContentListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedContentLinkListItemList> {
            return localVarFp.searchContentList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchContentPreviewsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContentPreviewsList(requestParameters: OutverseApiSearchContentPreviewsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedContentSearchResultList> {
            return localVarFp.searchContentPreviewsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchDocumentsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsList(requestParameters: OutverseApiSearchDocumentsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDocumentSearchResultList> {
            return localVarFp.searchDocumentsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchDocumentsV2ListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDocumentsV2List(requestParameters: OutverseApiSearchDocumentsV2ListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedDocumentSearchResultList> {
            return localVarFp.searchDocumentsV2List(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchPostsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPostsList(requestParameters: OutverseApiSearchPostsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPostSearchResultList> {
            return localVarFp.searchPostsList(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.ordering, requestParameters.page, requestParameters.search, requestParameters.thread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchPostsV2ListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPostsV2List(requestParameters: OutverseApiSearchPostsV2ListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedPostSearchResultList> {
            return localVarFp.searchPostsV2List(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.page, requestParameters.search, requestParameters.thread, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchThreadsListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreadsList(requestParameters: OutverseApiSearchThreadsListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedThreadSearchResultList> {
            return localVarFp.searchThreadsList(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSearchThreadsV2ListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThreadsV2List(requestParameters: OutverseApiSearchThreadsV2ListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedThreadSearchResultList> {
            return localVarFp.searchThreadsV2List(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.page, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OutverseApiSeoCommunityListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seoCommunityList(requestParameters: OutverseApiSeoCommunityListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCommunitySEOSerialiserList> {
            return localVarFp.seoCommunityList(requestParameters.ordering, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiUsersCreateUserFromToken operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersCreateUserFromTokenRequest
 */
export interface OutverseApiApiUsersCreateUserFromTokenRequest {
    /**
     * 
     * @type {CreateUserSerialiser}
     * @memberof OutverseApiApiUsersCreateUserFromToken
     */
    readonly createUserSerialiser: CreateUserSerialiser
}

/**
 * Request parameters for apiUsersList operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersListRequest
 */
export interface OutverseApiApiUsersListRequest {
    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiApiUsersList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiApiUsersList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiApiUsersList
     */
    readonly ordering?: string
}

/**
 * Request parameters for apiUsersMePartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersMePartialUpdateRequest
 */
export interface OutverseApiApiUsersMePartialUpdateRequest {
    /**
     * 
     * @type {PatchedPrivateWriteUser}
     * @memberof OutverseApiApiUsersMePartialUpdate
     */
    readonly patchedPrivateWriteUser?: PatchedPrivateWriteUser
}

/**
 * Request parameters for apiUsersPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersPartialUpdateRequest
 */
export interface OutverseApiApiUsersPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiApiUsersPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedPrivateWriteUser}
     * @memberof OutverseApiApiUsersPartialUpdate
     */
    readonly patchedPrivateWriteUser?: PatchedPrivateWriteUser
}

/**
 * Request parameters for apiUsersRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersRetrieveRequest
 */
export interface OutverseApiApiUsersRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiApiUsersRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for apiUsersSendEmailVerification operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersSendEmailVerificationRequest
 */
export interface OutverseApiApiUsersSendEmailVerificationRequest {
    /**
     * 
     * @type {EmailVerification}
     * @memberof OutverseApiApiUsersSendEmailVerification
     */
    readonly emailVerification: EmailVerification
}

/**
 * Request parameters for apiUsersToggleFlag operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersToggleFlagRequest
 */
export interface OutverseApiApiUsersToggleFlagRequest {
    /**
     * 
     * @type {FlagToggleSerialiser}
     * @memberof OutverseApiApiUsersToggleFlag
     */
    readonly flagToggleSerialiser: FlagToggleSerialiser
}

/**
 * Request parameters for apiUsersUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersUpdateRequest
 */
export interface OutverseApiApiUsersUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiApiUsersUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PrivateWriteUser}
     * @memberof OutverseApiApiUsersUpdate
     */
    readonly privateWriteUser?: PrivateWriteUser
}

/**
 * Request parameters for apiUsersWidgetAuth operation in OutverseApi.
 * @export
 * @interface OutverseApiApiUsersWidgetAuthRequest
 */
export interface OutverseApiApiUsersWidgetAuthRequest {
    /**
     * 
     * @type {MetadataVerification}
     * @memberof OutverseApiApiUsersWidgetAuth
     */
    readonly metadataVerification: MetadataVerification
}

/**
 * Request parameters for authTokenCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiAuthTokenCreateRequest
 */
export interface OutverseApiAuthTokenCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiAuthTokenCreate
     */
    readonly username: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiAuthTokenCreate
     */
    readonly password: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiAuthTokenCreate
     */
    readonly token: string
}

/**
 * Request parameters for chatHandler operation in OutverseApi.
 * @export
 * @interface OutverseApiChatHandlerRequest
 */
export interface OutverseApiChatHandlerRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiChatHandler
     */
    readonly communitySlug: string

    /**
     * 
     * @type {Prompt}
     * @memberof OutverseApiChatHandler
     */
    readonly prompt: Prompt
}

/**
 * Request parameters for communitiesAdminsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesAdminsListRequest
 */
export interface OutverseApiCommunitiesAdminsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesAdminsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesAdminsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesAdminsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesAdminsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesAdminsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesAdminsRetrieveRequest
 */
export interface OutverseApiCommunitiesAdminsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesAdminsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesAdminsRetrieve
     */
    readonly id: string
}

/**
 * Request parameters for communitiesChangelogEntriesCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChangelogEntriesCreateRequest
 */
export interface OutverseApiCommunitiesChangelogEntriesCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {ChangelogEntryWrite}
     * @memberof OutverseApiCommunitiesChangelogEntriesCreate
     */
    readonly changelogEntryWrite: ChangelogEntryWrite
}

/**
 * Request parameters for communitiesChangelogEntriesDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChangelogEntriesDestroyRequest
 */
export interface OutverseApiCommunitiesChangelogEntriesDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesChangelogEntriesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChangelogEntriesListRequest
 */
export interface OutverseApiCommunitiesChangelogEntriesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesChangelogEntriesList
     */
    readonly page?: number
}

/**
 * Request parameters for communitiesChangelogEntriesPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChangelogEntriesPartialUpdateRequest
 */
export interface OutverseApiCommunitiesChangelogEntriesPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedChangelogEntryWrite}
     * @memberof OutverseApiCommunitiesChangelogEntriesPartialUpdate
     */
    readonly patchedChangelogEntryWrite?: PatchedChangelogEntryWrite
}

/**
 * Request parameters for communitiesChangelogEntriesRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChangelogEntriesRetrieveRequest
 */
export interface OutverseApiCommunitiesChangelogEntriesRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesChangelogEntriesUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChangelogEntriesUpdateRequest
 */
export interface OutverseApiCommunitiesChangelogEntriesUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChangelogEntriesUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {ChangelogEntryWrite}
     * @memberof OutverseApiCommunitiesChangelogEntriesUpdate
     */
    readonly changelogEntryWrite: ChangelogEntryWrite
}

/**
 * Request parameters for communitiesChatEvaluateTrace operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesChatEvaluateTraceRequest
 */
export interface OutverseApiCommunitiesChatEvaluateTraceRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChatEvaluateTrace
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChatEvaluateTrace
     */
    readonly sessionId: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesChatEvaluateTrace
     */
    readonly traceId: string

    /**
     * 
     * @type {ChatFeedback}
     * @memberof OutverseApiCommunitiesChatEvaluateTrace
     */
    readonly chatFeedback: ChatFeedback
}

/**
 * Request parameters for communitiesContentLinksCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesContentLinksCreateRequest
 */
export interface OutverseApiCommunitiesContentLinksCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {ContentLink}
     * @memberof OutverseApiCommunitiesContentLinksCreate
     */
    readonly contentLink: ContentLink
}

/**
 * Request parameters for communitiesContentLinksDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesContentLinksDestroyRequest
 */
export interface OutverseApiCommunitiesContentLinksDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesContentLinksPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesContentLinksPartialUpdateRequest
 */
export interface OutverseApiCommunitiesContentLinksPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedContentLink}
     * @memberof OutverseApiCommunitiesContentLinksPartialUpdate
     */
    readonly patchedContentLink?: PatchedContentLink
}

/**
 * Request parameters for communitiesContentLinksRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesContentLinksRetrieveRequest
 */
export interface OutverseApiCommunitiesContentLinksRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesContentLinksUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesContentLinksUpdateRequest
 */
export interface OutverseApiCommunitiesContentLinksUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContentLinksUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {ContentLink}
     * @memberof OutverseApiCommunitiesContentLinksUpdate
     */
    readonly contentLink: ContentLink
}

/**
 * Request parameters for communitiesContextSourcesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesContextSourcesListRequest
 */
export interface OutverseApiCommunitiesContextSourcesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesContextSourcesList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesContextSourcesList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCreateRequest
 */
export interface OutverseApiCommunitiesCreateRequest {
    /**
     * 
     * @type {CommunityCreation}
     * @memberof OutverseApiCommunitiesCreate
     */
    readonly communityCreation?: CommunityCreation
}

/**
 * Request parameters for communitiesCrm operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCrmRequest
 */
export interface OutverseApiCommunitiesCrmRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCrm
     */
    readonly slug: string

    /**
     * 
     * @type {PatchedCommunityCRM}
     * @memberof OutverseApiCommunitiesCrm
     */
    readonly patchedCommunityCRM?: PatchedCommunityCRM
}

/**
 * Request parameters for communitiesCustomSpacesContent operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCustomSpacesContentRequest
 */
export interface OutverseApiCommunitiesCustomSpacesContentRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesContent
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesContent
     */
    readonly uuid: string

    /**
     * 
     * @type {CustomSpaceContent}
     * @memberof OutverseApiCommunitiesCustomSpacesContent
     */
    readonly customSpaceContent: CustomSpaceContent
}

/**
 * Request parameters for communitiesCustomSpacesCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCustomSpacesCreateRequest
 */
export interface OutverseApiCommunitiesCustomSpacesCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {CustomSpace}
     * @memberof OutverseApiCommunitiesCustomSpacesCreate
     */
    readonly customSpace: CustomSpace
}

/**
 * Request parameters for communitiesCustomSpacesDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCustomSpacesDestroyRequest
 */
export interface OutverseApiCommunitiesCustomSpacesDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesCustomSpacesPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCustomSpacesPartialUpdateRequest
 */
export interface OutverseApiCommunitiesCustomSpacesPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedCustomSpace}
     * @memberof OutverseApiCommunitiesCustomSpacesPartialUpdate
     */
    readonly patchedCustomSpace?: PatchedCustomSpace
}

/**
 * Request parameters for communitiesCustomSpacesRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCustomSpacesRetrieveRequest
 */
export interface OutverseApiCommunitiesCustomSpacesRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesCustomSpacesUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesCustomSpacesUpdateRequest
 */
export interface OutverseApiCommunitiesCustomSpacesUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesCustomSpacesUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {CustomSpace}
     * @memberof OutverseApiCommunitiesCustomSpacesUpdate
     */
    readonly customSpace: CustomSpace
}

/**
 * Request parameters for communitiesDevelopmentGetAuthedPayload operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDevelopmentGetAuthedPayloadRequest
 */
export interface OutverseApiCommunitiesDevelopmentGetAuthedPayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDevelopmentGetAuthedPayload
     */
    readonly communitySlug: string
}

/**
 * Request parameters for communitiesDocumentsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsCreateRequest
 */
export interface OutverseApiCommunitiesDocumentsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {Document}
     * @memberof OutverseApiCommunitiesDocumentsCreate
     */
    readonly document: Document
}

/**
 * Request parameters for communitiesDocumentsDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsDestroyRequest
 */
export interface OutverseApiCommunitiesDocumentsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesDocumentsDraft operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsDraftRequest
 */
export interface OutverseApiCommunitiesDocumentsDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsDraft
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsDraft
     */
    readonly uuid: string

    /**
     * 
     * @type {CRDTDraft}
     * @memberof OutverseApiCommunitiesDocumentsDraft
     */
    readonly cRDTDraft: CRDTDraft
}

/**
 * Request parameters for communitiesDocumentsFavourite operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsFavouriteRequest
 */
export interface OutverseApiCommunitiesDocumentsFavouriteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsFavourite
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsFavourite
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesDocumentsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsPartialUpdateRequest
 */
export interface OutverseApiCommunitiesDocumentsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedDocument}
     * @memberof OutverseApiCommunitiesDocumentsPartialUpdate
     */
    readonly patchedDocument?: PatchedDocument
}

/**
 * Request parameters for communitiesDocumentsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsRetrieveRequest
 */
export interface OutverseApiCommunitiesDocumentsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesDocumentsUnfavourite operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsUnfavouriteRequest
 */
export interface OutverseApiCommunitiesDocumentsUnfavouriteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsUnfavourite
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsUnfavourite
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesDocumentsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesDocumentsUpdateRequest
 */
export interface OutverseApiCommunitiesDocumentsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesDocumentsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {Document}
     * @memberof OutverseApiCommunitiesDocumentsUpdate
     */
    readonly document: Document
}

/**
 * Request parameters for communitiesEscalationRulesCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesEscalationRulesCreateRequest
 */
export interface OutverseApiCommunitiesEscalationRulesCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesEscalationRulesCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {EscalationRule}
     * @memberof OutverseApiCommunitiesEscalationRulesCreate
     */
    readonly escalationRule: EscalationRule
}

/**
 * Request parameters for communitiesEscalationRulesDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesEscalationRulesDestroyRequest
 */
export interface OutverseApiCommunitiesEscalationRulesDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesEscalationRulesDestroy
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this escalation rule.
     * @type {number}
     * @memberof OutverseApiCommunitiesEscalationRulesDestroy
     */
    readonly id: number
}

/**
 * Request parameters for communitiesEscalationRulesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesEscalationRulesListRequest
 */
export interface OutverseApiCommunitiesEscalationRulesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly communitySlug: string

    /**
     * * &#x60;zendesk&#x60; - Zendesk * &#x60;customer&#x60; - Customer
     * @type {'customer' | 'zendesk'}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly agent?: CommunitiesEscalationRulesListAgentEnum

    /**
     * 
     * @type {number}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly createdBy?: number

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly enabled?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly isTriggeredEarly?: boolean

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly page?: number

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesEscalationRulesList
     */
    readonly requiresConfirmation?: boolean
}

/**
 * Request parameters for communitiesEscalationRulesPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesEscalationRulesPartialUpdateRequest
 */
export interface OutverseApiCommunitiesEscalationRulesPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesEscalationRulesPartialUpdate
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this escalation rule.
     * @type {number}
     * @memberof OutverseApiCommunitiesEscalationRulesPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {PatchedEscalationRule}
     * @memberof OutverseApiCommunitiesEscalationRulesPartialUpdate
     */
    readonly patchedEscalationRule?: PatchedEscalationRule
}

/**
 * Request parameters for communitiesEscalationRulesRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesEscalationRulesRetrieveRequest
 */
export interface OutverseApiCommunitiesEscalationRulesRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesEscalationRulesRetrieve
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this escalation rule.
     * @type {number}
     * @memberof OutverseApiCommunitiesEscalationRulesRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for communitiesEscalationRulesUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesEscalationRulesUpdateRequest
 */
export interface OutverseApiCommunitiesEscalationRulesUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesEscalationRulesUpdate
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this escalation rule.
     * @type {number}
     * @memberof OutverseApiCommunitiesEscalationRulesUpdate
     */
    readonly id: number

    /**
     * 
     * @type {EscalationRule}
     * @memberof OutverseApiCommunitiesEscalationRulesUpdate
     */
    readonly escalationRule: EscalationRule
}

/**
 * Request parameters for communitiesFavouritesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFavouritesListRequest
 */
export interface OutverseApiCommunitiesFavouritesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFavouritesList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesFavouritesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesFavouritesList
     */
    readonly page?: number
}

/**
 * Request parameters for communitiesFoldersCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersCreateRequest
 */
export interface OutverseApiCommunitiesFoldersCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {Folder}
     * @memberof OutverseApiCommunitiesFoldersCreate
     */
    readonly folder: Folder
}

/**
 * Request parameters for communitiesFoldersDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersDestroyRequest
 */
export interface OutverseApiCommunitiesFoldersDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesFoldersList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersListRequest
 */
export interface OutverseApiCommunitiesFoldersListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesFoldersMoveDocument operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersMoveDocumentRequest
 */
export interface OutverseApiCommunitiesFoldersMoveDocumentRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersMoveDocument
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersMoveDocument
     */
    readonly uuid: string

    /**
     * 
     * @type {Ordering}
     * @memberof OutverseApiCommunitiesFoldersMoveDocument
     */
    readonly ordering: Ordering
}

/**
 * Request parameters for communitiesFoldersPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersPartialUpdateRequest
 */
export interface OutverseApiCommunitiesFoldersPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedFolder}
     * @memberof OutverseApiCommunitiesFoldersPartialUpdate
     */
    readonly patchedFolder?: PatchedFolder
}

/**
 * Request parameters for communitiesFoldersRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersRetrieveRequest
 */
export interface OutverseApiCommunitiesFoldersRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesFoldersUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesFoldersUpdateRequest
 */
export interface OutverseApiCommunitiesFoldersUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesFoldersUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {Folder}
     * @memberof OutverseApiCommunitiesFoldersUpdate
     */
    readonly folder: Folder
}

/**
 * Request parameters for communitiesForumSpacesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesForumSpacesListRequest
 */
export interface OutverseApiCommunitiesForumSpacesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesForumSpacesList
     */
    readonly communitySlug: string

    /**
     * Only retrieve forum spaces that the user is allowed to add forum threads to
     * @type {boolean}
     * @memberof OutverseApiCommunitiesForumSpacesList
     */
    readonly canAddForumthread?: boolean

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesForumSpacesList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesForumSpacesList
     */
    readonly page?: number

    /**
     * Only retrieve forum spaces beginning with title
     * @type {string}
     * @memberof OutverseApiCommunitiesForumSpacesList
     */
    readonly title?: string
}

/**
 * Request parameters for communitiesHooksCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksCreateRequest
 */
export interface OutverseApiCommunitiesHooksCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {WebHook}
     * @memberof OutverseApiCommunitiesHooksCreate
     */
    readonly webHook: WebHook
}

/**
 * Request parameters for communitiesHooksDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksDestroyRequest
 */
export interface OutverseApiCommunitiesHooksDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesHooksEventsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksEventsListRequest
 */
export interface OutverseApiCommunitiesHooksEventsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksEventsList
     */
    readonly communitySlug: string
}

/**
 * Request parameters for communitiesHooksList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksListRequest
 */
export interface OutverseApiCommunitiesHooksListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesHooksList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesHooksList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesHooksPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksPartialUpdateRequest
 */
export interface OutverseApiCommunitiesHooksPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedWebHook}
     * @memberof OutverseApiCommunitiesHooksPartialUpdate
     */
    readonly patchedWebHook?: PatchedWebHook
}

/**
 * Request parameters for communitiesHooksRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksRetrieveRequest
 */
export interface OutverseApiCommunitiesHooksRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesHooksUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesHooksUpdateRequest
 */
export interface OutverseApiCommunitiesHooksUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesHooksUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {WebHook}
     * @memberof OutverseApiCommunitiesHooksUpdate
     */
    readonly webHook: WebHook
}

/**
 * Request parameters for communitiesIntentsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesIntentsCreateRequest
 */
export interface OutverseApiCommunitiesIntentsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {IntentWrite}
     * @memberof OutverseApiCommunitiesIntentsCreate
     */
    readonly intentWrite: IntentWrite
}

/**
 * Request parameters for communitiesIntentsDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesIntentsDestroyRequest
 */
export interface OutverseApiCommunitiesIntentsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesIntentsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesIntentsListRequest
 */
export interface OutverseApiCommunitiesIntentsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesIntentsList
     */
    readonly page?: number
}

/**
 * Request parameters for communitiesIntentsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesIntentsPartialUpdateRequest
 */
export interface OutverseApiCommunitiesIntentsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedIntentWrite}
     * @memberof OutverseApiCommunitiesIntentsPartialUpdate
     */
    readonly patchedIntentWrite?: PatchedIntentWrite
}

/**
 * Request parameters for communitiesIntentsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesIntentsRetrieveRequest
 */
export interface OutverseApiCommunitiesIntentsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesIntentsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesIntentsUpdateRequest
 */
export interface OutverseApiCommunitiesIntentsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesIntentsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {IntentWrite}
     * @memberof OutverseApiCommunitiesIntentsUpdate
     */
    readonly intentWrite: IntentWrite
}

/**
 * Request parameters for communitiesInvitationsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesInvitationsListRequest
 */
export interface OutverseApiCommunitiesInvitationsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesInvitationsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesInvitationsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesInvitationsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesInvitationsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesInviteCodeCheck operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesInviteCodeCheckRequest
 */
export interface OutverseApiCommunitiesInviteCodeCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesInviteCodeCheck
     */
    readonly communitySlug: string

    /**
     * Invite code to check.
     * @type {string}
     * @memberof OutverseApiCommunitiesInviteCodeCheck
     */
    readonly inviteCode: string
}

/**
 * Request parameters for communitiesInviteCodeGet operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesInviteCodeGetRequest
 */
export interface OutverseApiCommunitiesInviteCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesInviteCodeGet
     */
    readonly communitySlug: string
}

/**
 * Request parameters for communitiesInviteCodeInviteMember operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesInviteCodeInviteMemberRequest
 */
export interface OutverseApiCommunitiesInviteCodeInviteMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesInviteCodeInviteMember
     */
    readonly communitySlug: string

    /**
     * 
     * @type {InviteMember}
     * @memberof OutverseApiCommunitiesInviteCodeInviteMember
     */
    readonly inviteMember: InviteMember
}

/**
 * Request parameters for communitiesInviteCodeInviteTeamMember operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesInviteCodeInviteTeamMemberRequest
 */
export interface OutverseApiCommunitiesInviteCodeInviteTeamMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesInviteCodeInviteTeamMember
     */
    readonly communitySlug: string

    /**
     * 
     * @type {InviteTeamMember}
     * @memberof OutverseApiCommunitiesInviteCodeInviteTeamMember
     */
    readonly inviteTeamMember: InviteTeamMember
}

/**
 * Request parameters for communitiesInviteCodeRefresh operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesInviteCodeRefreshRequest
 */
export interface OutverseApiCommunitiesInviteCodeRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesInviteCodeRefresh
     */
    readonly communitySlug: string

    /**
     * 
     * @type {CommunityInviteCode}
     * @memberof OutverseApiCommunitiesInviteCodeRefresh
     */
    readonly communityInviteCode?: CommunityInviteCode
}

/**
 * Request parameters for communitiesLabelsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLabelsCreateRequest
 */
export interface OutverseApiCommunitiesLabelsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {LabelSerialiser}
     * @memberof OutverseApiCommunitiesLabelsCreate
     */
    readonly labelSerialiser: LabelSerialiser
}

/**
 * Request parameters for communitiesLabelsDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLabelsDestroyRequest
 */
export interface OutverseApiCommunitiesLabelsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesLabelsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLabelsListRequest
 */
export interface OutverseApiCommunitiesLabelsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesLabelsList
     */
    readonly page?: number
}

/**
 * Request parameters for communitiesLabelsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLabelsPartialUpdateRequest
 */
export interface OutverseApiCommunitiesLabelsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedLabelSerialiser}
     * @memberof OutverseApiCommunitiesLabelsPartialUpdate
     */
    readonly patchedLabelSerialiser?: PatchedLabelSerialiser
}

/**
 * Request parameters for communitiesLabelsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLabelsRetrieveRequest
 */
export interface OutverseApiCommunitiesLabelsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesLabelsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLabelsUpdateRequest
 */
export interface OutverseApiCommunitiesLabelsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLabelsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {LabelSerialiser}
     * @memberof OutverseApiCommunitiesLabelsUpdate
     */
    readonly labelSerialiser: LabelSerialiser
}

/**
 * Request parameters for communitiesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesListRequest
 */
export interface OutverseApiCommunitiesListRequest {
    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesList
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesList
     */
    readonly name?: string

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesList
     */
    readonly ordering?: string

    /**
     * Only retrieve communities of which the user is an admin
     * @type {boolean}
     * @memberof OutverseApiCommunitiesList
     */
    readonly userIsAdmin?: boolean

    /**
     * Only retrieve communities of which the user is a member
     * @type {boolean}
     * @memberof OutverseApiCommunitiesList
     */
    readonly userIsMember?: boolean
}

/**
 * Request parameters for communitiesLlmSessionsAnalytics operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLlmSessionsAnalyticsRequest
 */
export interface OutverseApiCommunitiesLlmSessionsAnalyticsRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsAnalytics
     */
    readonly communitySlug: string
}

/**
 * Request parameters for communitiesLlmSessionsAudit operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLlmSessionsAuditRequest
 */
export interface OutverseApiCommunitiesLlmSessionsAuditRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsAudit
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsAudit
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesLlmSessionsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLlmSessionsListRequest
 */
export interface OutverseApiCommunitiesLlmSessionsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly communitySlug: string

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly audited?: boolean

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly createdAfter?: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly createdBefore?: string

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly escalated?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly intent?: Array<string>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly page?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly rule?: Array<string>

    /**
     * * &#x60;widget&#x60; - Widget * &#x60;zendesk&#x60; - Zendesk * &#x60;intercom&#x60; - Intercom * &#x60;salesforce&#x60; - Salesforce * &#x60;copilot&#x60; - Copilot * &#x60;evals&#x60; - Evals
     * @type {'copilot' | 'evals' | 'intercom' | 'salesforce' | 'widget' | 'zendesk'}
     * @memberof OutverseApiCommunitiesLlmSessionsList
     */
    readonly source?: CommunitiesLlmSessionsListSourceEnum
}

/**
 * Request parameters for communitiesLlmSessionsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLlmSessionsRetrieveRequest
 */
export interface OutverseApiCommunitiesLlmSessionsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsRetrieve
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesLlmSessionsUnaudit operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesLlmSessionsUnauditRequest
 */
export interface OutverseApiCommunitiesLlmSessionsUnauditRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsUnaudit
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesLlmSessionsUnaudit
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesMembersDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersDestroyRequest
 */
export interface OutverseApiCommunitiesMembersDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesMembersDisableSlack operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersDisableSlackRequest
 */
export interface OutverseApiCommunitiesMembersDisableSlackRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersDisableSlack
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersDisableSlack
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesMembersGetEmail operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersGetEmailRequest
 */
export interface OutverseApiCommunitiesMembersGetEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersGetEmail
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersGetEmail
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesMembersList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersListRequest
 */
export interface OutverseApiCommunitiesMembersListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesMembersList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesMembersList
     */
    readonly offset?: number
}

/**
 * Request parameters for communitiesMembersNotificationPreferences operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersNotificationPreferencesRequest
 */
export interface OutverseApiCommunitiesMembersNotificationPreferencesRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersNotificationPreferences
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersNotificationPreferences
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesMembersNotificationPreferences2 operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersNotificationPreferences2Request
 */
export interface OutverseApiCommunitiesMembersNotificationPreferences2Request {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersNotificationPreferences2
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersNotificationPreferences2
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedNotificationChannelPreference}
     * @memberof OutverseApiCommunitiesMembersNotificationPreferences2
     */
    readonly patchedNotificationChannelPreference?: PatchedNotificationChannelPreference
}

/**
 * Request parameters for communitiesMembersRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMembersRetrieveRequest
 */
export interface OutverseApiCommunitiesMembersRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMembersRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesMoveSpaceGroup operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesMoveSpaceGroupRequest
 */
export interface OutverseApiCommunitiesMoveSpaceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesMoveSpaceGroup
     */
    readonly slug: string

    /**
     * 
     * @type {Ordering}
     * @memberof OutverseApiCommunitiesMoveSpaceGroup
     */
    readonly ordering: Ordering
}

/**
 * Request parameters for communitiesNotificationSubscriptions operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesNotificationSubscriptionsRequest
 */
export interface OutverseApiCommunitiesNotificationSubscriptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesNotificationSubscriptions
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPartialUpdateRequest
 */
export interface OutverseApiCommunitiesPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPartialUpdate
     */
    readonly slug: string

    /**
     * 
     * @type {PatchedCommunityFull}
     * @memberof OutverseApiCommunitiesPartialUpdate
     */
    readonly patchedCommunityFull?: PatchedCommunityFull
}

/**
 * Request parameters for communitiesPermissions operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPermissionsRequest
 */
export interface OutverseApiCommunitiesPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPermissions
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesPostsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsCreateRequest
 */
export interface OutverseApiCommunitiesPostsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {ThreadPost}
     * @memberof OutverseApiCommunitiesPostsCreate
     */
    readonly threadPost: ThreadPost
}

/**
 * Request parameters for communitiesPostsDeleteReaction operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsDeleteReactionRequest
 */
export interface OutverseApiCommunitiesPostsDeleteReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsDeleteReaction
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsDeleteReaction
     */
    readonly reactionUuid: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsDeleteReaction
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesPostsDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsDestroyRequest
 */
export interface OutverseApiCommunitiesPostsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesPostsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsListRequest
 */
export interface OutverseApiCommunitiesPostsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsList
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsList
     */
    readonly forumSpaceUuid?: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsList
     */
    readonly forumThreadUuid?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsList
     */
    readonly ordering?: string

    /**
     * The page number to use, starting from 1
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsList
     */
    readonly page?: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsList
     */
    readonly replyToPostUuid?: string
}

/**
 * Request parameters for communitiesPostsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsPartialUpdateRequest
 */
export interface OutverseApiCommunitiesPostsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedThreadPost}
     * @memberof OutverseApiCommunitiesPostsPartialUpdate
     */
    readonly patchedThreadPost?: PatchedThreadPost
}

/**
 * Request parameters for communitiesPostsReaction operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsReactionRequest
 */
export interface OutverseApiCommunitiesPostsReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsReaction
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsReaction
     */
    readonly uuid: string

    /**
     * 
     * @type {ReactionCreateSerialiser}
     * @memberof OutverseApiCommunitiesPostsReaction
     */
    readonly reactionCreateSerialiser: ReactionCreateSerialiser
}

/**
 * Request parameters for communitiesPostsRemoveUpvote operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsRemoveUpvoteRequest
 */
export interface OutverseApiCommunitiesPostsRemoveUpvoteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsRemoveUpvote
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsRemoveUpvote
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesPostsReport operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsReportRequest
 */
export interface OutverseApiCommunitiesPostsReportRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsReport
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsReport
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesPostsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsRetrieveRequest
 */
export interface OutverseApiCommunitiesPostsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesPostsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsUpdateRequest
 */
export interface OutverseApiCommunitiesPostsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {ThreadPost}
     * @memberof OutverseApiCommunitiesPostsUpdate
     */
    readonly threadPost: ThreadPost
}

/**
 * Request parameters for communitiesPostsUpvote operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesPostsUpvoteRequest
 */
export interface OutverseApiCommunitiesPostsUpvoteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsUpvote
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesPostsUpvote
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesRetrieveRequest
 */
export interface OutverseApiCommunitiesRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesRetrieve
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesRolesList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesRolesListRequest
 */
export interface OutverseApiCommunitiesRolesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesRolesList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesRolesList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesSemanticSearchGet operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSemanticSearchGetRequest
 */
export interface OutverseApiCommunitiesSemanticSearchGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSemanticSearchGet
     */
    readonly communitySlug: string

    /**
     * entity type
     * @type {'DOC' | 'REPLY' | 'THREAD'}
     * @memberof OutverseApiCommunitiesSemanticSearchGet
     */
    readonly entityType: CommunitiesSemanticSearchGetEntityTypeEnum

    /**
     * entity uuid to filter by
     * @type {string}
     * @memberof OutverseApiCommunitiesSemanticSearchGet
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesSetIntercomAppId operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSetIntercomAppIdRequest
 */
export interface OutverseApiCommunitiesSetIntercomAppIdRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSetIntercomAppId
     */
    readonly slug: string

    /**
     * 
     * @type {CommunityIntercomAppId}
     * @memberof OutverseApiCommunitiesSetIntercomAppId
     */
    readonly communityIntercomAppId: CommunityIntercomAppId
}

/**
 * Request parameters for communitiesSetZendeskSubdomain operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSetZendeskSubdomainRequest
 */
export interface OutverseApiCommunitiesSetZendeskSubdomainRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSetZendeskSubdomain
     */
    readonly slug: string

    /**
     * 
     * @type {CommunityZendeskSubdomain}
     * @memberof OutverseApiCommunitiesSetZendeskSubdomain
     */
    readonly communityZendeskSubdomain: CommunityZendeskSubdomain
}

/**
 * Request parameters for communitiesSignUpsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSignUpsCreateRequest
 */
export interface OutverseApiCommunitiesSignUpsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSignUpsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {CommunitySignUpRequest}
     * @memberof OutverseApiCommunitiesSignUpsCreate
     */
    readonly communitySignUpRequest?: CommunitySignUpRequest
}

/**
 * Request parameters for communitiesSignUpsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSignUpsListRequest
 */
export interface OutverseApiCommunitiesSignUpsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSignUpsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesSignUpsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesSignUpsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesSignUpsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesSnippetsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSnippetsListRequest
 */
export interface OutverseApiCommunitiesSnippetsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSnippetsList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesSnippetsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesSnippetsList
     */
    readonly page?: number

    /**
     * A search term.
     * @type {string}
     * @memberof OutverseApiCommunitiesSnippetsList
     */
    readonly search?: string
}

/**
 * Request parameters for communitiesSpaceGroupsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsCreateRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {SpaceGroup}
     * @memberof OutverseApiCommunitiesSpaceGroupsCreate
     */
    readonly spaceGroup: SpaceGroup
}

/**
 * Request parameters for communitiesSpaceGroupsDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsDestroyRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesSpaceGroupsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsListRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesSpaceGroupsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesSpaceGroupsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesSpaceGroupsMoveSpace operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsMoveSpaceRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsMoveSpaceRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsMoveSpace
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsMoveSpace
     */
    readonly uuid: string

    /**
     * 
     * @type {Ordering}
     * @memberof OutverseApiCommunitiesSpaceGroupsMoveSpace
     */
    readonly ordering: Ordering
}

/**
 * Request parameters for communitiesSpaceGroupsNotificationsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsNotificationsListRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsNotificationsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsNotificationsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesSpaceGroupsNotificationsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesSpaceGroupsNotificationsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsNotificationsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesSpaceGroupsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsPartialUpdateRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedSpaceGroup}
     * @memberof OutverseApiCommunitiesSpaceGroupsPartialUpdate
     */
    readonly patchedSpaceGroup?: PatchedSpaceGroup
}

/**
 * Request parameters for communitiesSpaceGroupsPermsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsPermsListRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsPermsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsPermsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesSpaceGroupsPermsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesSpaceGroupsPermsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsPermsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesSpaceGroupsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsRetrieveRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesSpaceGroupsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSpaceGroupsUpdateRequest
 */
export interface OutverseApiCommunitiesSpaceGroupsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSpaceGroupsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {SpaceGroup}
     * @memberof OutverseApiCommunitiesSpaceGroupsUpdate
     */
    readonly spaceGroup: SpaceGroup
}

/**
 * Request parameters for communitiesSubscribeToNewMemberEvent operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSubscribeToNewMemberEventRequest
 */
export interface OutverseApiCommunitiesSubscribeToNewMemberEventRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSubscribeToNewMemberEvent
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesSwitchboardDisable operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSwitchboardDisableRequest
 */
export interface OutverseApiCommunitiesSwitchboardDisableRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSwitchboardDisable
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesSwitchboardStatus operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesSwitchboardStatusRequest
 */
export interface OutverseApiCommunitiesSwitchboardStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesSwitchboardStatus
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesThreadsAnnotationsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsAnnotationsListRequest
 */
export interface OutverseApiCommunitiesThreadsAnnotationsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly communitySlug: string

    /**
     * Cursor to use for pagination
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly cursor?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly forumSpaceUuid?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly labelUuid?: Array<string>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly ordering?: string

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly solved?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesThreadsAnnotationsList
     */
    readonly unread?: boolean
}

/**
 * Request parameters for communitiesThreadsCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsCreateRequest
 */
export interface OutverseApiCommunitiesThreadsCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {ForumThread}
     * @memberof OutverseApiCommunitiesThreadsCreate
     */
    readonly forumThread: ForumThread
}

/**
 * Request parameters for communitiesThreadsDeletePin operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsDeletePinRequest
 */
export interface OutverseApiCommunitiesThreadsDeletePinRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDeletePin
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDeletePin
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsDeleteReaction operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsDeleteReactionRequest
 */
export interface OutverseApiCommunitiesThreadsDeleteReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDeleteReaction
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDeleteReaction
     */
    readonly reactionUuid: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDeleteReaction
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsDestroyRequest
 */
export interface OutverseApiCommunitiesThreadsDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDestroy
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsFavourite operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsFavouriteRequest
 */
export interface OutverseApiCommunitiesThreadsFavouriteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsFavourite
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsFavourite
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsHide operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsHideRequest
 */
export interface OutverseApiCommunitiesThreadsHideRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsHide
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsHide
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsListRequest
 */
export interface OutverseApiCommunitiesThreadsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly communitySlug: string

    /**
     * Cursor to use for pagination
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly cursor?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly forumSpaceUuid?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly labelUuid?: Array<string>

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly ordering?: string

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly solved?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof OutverseApiCommunitiesThreadsList
     */
    readonly unread?: boolean
}

/**
 * Request parameters for communitiesThreadsLock operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsLockRequest
 */
export interface OutverseApiCommunitiesThreadsLockRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsLock
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsLock
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsMaximize operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsMaximizeRequest
 */
export interface OutverseApiCommunitiesThreadsMaximizeRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsMaximize
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsMaximize
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsPartialUpdateRequest
 */
export interface OutverseApiCommunitiesThreadsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsPartialUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedForumThread}
     * @memberof OutverseApiCommunitiesThreadsPartialUpdate
     */
    readonly patchedForumThread?: PatchedForumThread
}

/**
 * Request parameters for communitiesThreadsPin operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsPinRequest
 */
export interface OutverseApiCommunitiesThreadsPinRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsPin
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsPin
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsReaction operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsReactionRequest
 */
export interface OutverseApiCommunitiesThreadsReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsReaction
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsReaction
     */
    readonly uuid: string

    /**
     * 
     * @type {ReactionCreateSerialiser}
     * @memberof OutverseApiCommunitiesThreadsReaction
     */
    readonly reactionCreateSerialiser: ReactionCreateSerialiser
}

/**
 * Request parameters for communitiesThreadsRemoveUpvote operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsRemoveUpvoteRequest
 */
export interface OutverseApiCommunitiesThreadsRemoveUpvoteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsRemoveUpvote
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsRemoveUpvote
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsReport operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsReportRequest
 */
export interface OutverseApiCommunitiesThreadsReportRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsReport
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsReport
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsRetrieveRequest
 */
export interface OutverseApiCommunitiesThreadsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsSolve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsSolveRequest
 */
export interface OutverseApiCommunitiesThreadsSolveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsSolve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsSolve
     */
    readonly uuid: string

    /**
     * 
     * @type {SwitchSolution}
     * @memberof OutverseApiCommunitiesThreadsSolve
     */
    readonly switchSolution: SwitchSolution
}

/**
 * Request parameters for communitiesThreadsSubscribeToActivity operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsSubscribeToActivityRequest
 */
export interface OutverseApiCommunitiesThreadsSubscribeToActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsSubscribeToActivity
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsSubscribeToActivity
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsSubscribeToReplies operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsSubscribeToRepliesRequest
 */
export interface OutverseApiCommunitiesThreadsSubscribeToRepliesRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsSubscribeToReplies
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsSubscribeToReplies
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnfavourite operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnfavouriteRequest
 */
export interface OutverseApiCommunitiesThreadsUnfavouriteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnfavourite
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnfavourite
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnhide operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnhideRequest
 */
export interface OutverseApiCommunitiesThreadsUnhideRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnhide
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnhide
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnlock operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnlockRequest
 */
export interface OutverseApiCommunitiesThreadsUnlockRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnlock
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnlock
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnmaximize operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnmaximizeRequest
 */
export interface OutverseApiCommunitiesThreadsUnmaximizeRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnmaximize
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnmaximize
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnsolve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnsolveRequest
 */
export interface OutverseApiCommunitiesThreadsUnsolveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnsolve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnsolve
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnsubscribeFromActivity operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnsubscribeFromActivityRequest
 */
export interface OutverseApiCommunitiesThreadsUnsubscribeFromActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnsubscribeFromActivity
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnsubscribeFromActivity
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUnsubscribeFromReplies operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUnsubscribeFromRepliesRequest
 */
export interface OutverseApiCommunitiesThreadsUnsubscribeFromRepliesRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnsubscribeFromReplies
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUnsubscribeFromReplies
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUpdateRequest
 */
export interface OutverseApiCommunitiesThreadsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUpdate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {ForumThread}
     * @memberof OutverseApiCommunitiesThreadsUpdate
     */
    readonly forumThread: ForumThread
}

/**
 * Request parameters for communitiesThreadsUpvote operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsUpvoteRequest
 */
export interface OutverseApiCommunitiesThreadsUpvoteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUpvote
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsUpvote
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesThreadsVisit operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesThreadsVisitRequest
 */
export interface OutverseApiCommunitiesThreadsVisitRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsVisit
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesThreadsVisit
     */
    readonly uuid: string
}

/**
 * Request parameters for communitiesToolsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesToolsListRequest
 */
export interface OutverseApiCommunitiesToolsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesToolsList
     */
    readonly communitySlug: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiCommunitiesToolsList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiCommunitiesToolsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesToolsList
     */
    readonly ordering?: string
}

/**
 * Request parameters for communitiesTraceFeedbackCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesTraceFeedbackCreateRequest
 */
export interface OutverseApiCommunitiesTraceFeedbackCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackCreate
     */
    readonly communitySlug: string

    /**
     * 
     * @type {TraceFeedback}
     * @memberof OutverseApiCommunitiesTraceFeedbackCreate
     */
    readonly traceFeedback: TraceFeedback
}

/**
 * Request parameters for communitiesTraceFeedbackDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesTraceFeedbackDestroyRequest
 */
export interface OutverseApiCommunitiesTraceFeedbackDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackDestroy
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this llm trace feedback.
     * @type {number}
     * @memberof OutverseApiCommunitiesTraceFeedbackDestroy
     */
    readonly id: number
}

/**
 * Request parameters for communitiesTraceFeedbackList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesTraceFeedbackListRequest
 */
export interface OutverseApiCommunitiesTraceFeedbackListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackList
     */
    readonly communitySlug: string

    /**
     * 
     * @type {number}
     * @memberof OutverseApiCommunitiesTraceFeedbackList
     */
    readonly author?: number

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesTraceFeedbackList
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackList
     */
    readonly trace?: string
}

/**
 * Request parameters for communitiesTraceFeedbackPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesTraceFeedbackPartialUpdateRequest
 */
export interface OutverseApiCommunitiesTraceFeedbackPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackPartialUpdate
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this llm trace feedback.
     * @type {number}
     * @memberof OutverseApiCommunitiesTraceFeedbackPartialUpdate
     */
    readonly id: number

    /**
     * 
     * @type {PatchedTraceFeedback}
     * @memberof OutverseApiCommunitiesTraceFeedbackPartialUpdate
     */
    readonly patchedTraceFeedback?: PatchedTraceFeedback
}

/**
 * Request parameters for communitiesTraceFeedbackRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesTraceFeedbackRetrieveRequest
 */
export interface OutverseApiCommunitiesTraceFeedbackRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackRetrieve
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this llm trace feedback.
     * @type {number}
     * @memberof OutverseApiCommunitiesTraceFeedbackRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for communitiesTraceFeedbackUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesTraceFeedbackUpdateRequest
 */
export interface OutverseApiCommunitiesTraceFeedbackUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesTraceFeedbackUpdate
     */
    readonly communitySlug: string

    /**
     * A unique integer value identifying this llm trace feedback.
     * @type {number}
     * @memberof OutverseApiCommunitiesTraceFeedbackUpdate
     */
    readonly id: number

    /**
     * 
     * @type {TraceFeedback}
     * @memberof OutverseApiCommunitiesTraceFeedbackUpdate
     */
    readonly traceFeedback: TraceFeedback
}

/**
 * Request parameters for communitiesUnsubscribeFromNewMemberEvent operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesUnsubscribeFromNewMemberEventRequest
 */
export interface OutverseApiCommunitiesUnsubscribeFromNewMemberEventRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesUnsubscribeFromNewMemberEvent
     */
    readonly slug: string
}

/**
 * Request parameters for communitiesUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesUpdateRequest
 */
export interface OutverseApiCommunitiesUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesUpdate
     */
    readonly slug: string

    /**
     * 
     * @type {CommunityFull}
     * @memberof OutverseApiCommunitiesUpdate
     */
    readonly communityFull?: CommunityFull
}

/**
 * Request parameters for communitiesUserSessionsList operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesUserSessionsListRequest
 */
export interface OutverseApiCommunitiesUserSessionsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesUserSessionsList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiCommunitiesUserSessionsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiCommunitiesUserSessionsList
     */
    readonly page?: number
}

/**
 * Request parameters for communitiesUserSessionsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiCommunitiesUserSessionsRetrieveRequest
 */
export interface OutverseApiCommunitiesUserSessionsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesUserSessionsRetrieve
     */
    readonly communitySlug: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiCommunitiesUserSessionsRetrieve
     */
    readonly slug: string
}

/**
 * Request parameters for documentFeedbackCountCountForDoc operation in OutverseApi.
 * @export
 * @interface OutverseApiDocumentFeedbackCountCountForDocRequest
 */
export interface OutverseApiDocumentFeedbackCountCountForDocRequest {
    /**
     * UUID of the document to get feedback for
     * @type {string}
     * @memberof OutverseApiDocumentFeedbackCountCountForDoc
     */
    readonly document: string

    /**
     * Start date of the feedback time range
     * @type {string}
     * @memberof OutverseApiDocumentFeedbackCountCountForDoc
     */
    readonly modifiedAfter: string

    /**
     * End date of the feedback time range
     * @type {string}
     * @memberof OutverseApiDocumentFeedbackCountCountForDoc
     */
    readonly modifiedBefore: string
}

/**
 * Request parameters for documentFeedbackCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiDocumentFeedbackCreateRequest
 */
export interface OutverseApiDocumentFeedbackCreateRequest {
    /**
     * 
     * @type {DocumentFeedback}
     * @memberof OutverseApiDocumentFeedbackCreate
     */
    readonly documentFeedback: DocumentFeedback
}

/**
 * Request parameters for documentFeedbackRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiDocumentFeedbackRetrieveRequest
 */
export interface OutverseApiDocumentFeedbackRetrieveRequest {
    /**
     * A unique integer value identifying this document feedback.
     * @type {number}
     * @memberof OutverseApiDocumentFeedbackRetrieve
     */
    readonly id: number
}

/**
 * Request parameters for forumSpaceCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceCreateRequest
 */
export interface OutverseApiForumSpaceCreateRequest {
    /**
     * 
     * @type {ForumSpace}
     * @memberof OutverseApiForumSpaceCreate
     */
    readonly forumSpace: ForumSpace
}

/**
 * Request parameters for forumSpaceDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceDestroyRequest
 */
export interface OutverseApiForumSpaceDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for forumSpaceFavourite operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceFavouriteRequest
 */
export interface OutverseApiForumSpaceFavouriteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceFavourite
     */
    readonly uuid: string
}

/**
 * Request parameters for forumSpacePartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpacePartialUpdateRequest
 */
export interface OutverseApiForumSpacePartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpacePartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedForumSpace}
     * @memberof OutverseApiForumSpacePartialUpdate
     */
    readonly patchedForumSpace?: PatchedForumSpace
}

/**
 * Request parameters for forumSpaceRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceRetrieveRequest
 */
export interface OutverseApiForumSpaceRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for forumSpaceSubscribeToActivity operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceSubscribeToActivityRequest
 */
export interface OutverseApiForumSpaceSubscribeToActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceSubscribeToActivity
     */
    readonly uuid: string
}

/**
 * Request parameters for forumSpaceUnfavourite operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceUnfavouriteRequest
 */
export interface OutverseApiForumSpaceUnfavouriteRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceUnfavourite
     */
    readonly uuid: string
}

/**
 * Request parameters for forumSpaceUnsubscribeFromActivity operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceUnsubscribeFromActivityRequest
 */
export interface OutverseApiForumSpaceUnsubscribeFromActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceUnsubscribeFromActivity
     */
    readonly uuid: string
}

/**
 * Request parameters for forumSpaceUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceUpdateRequest
 */
export interface OutverseApiForumSpaceUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {ForumSpace}
     * @memberof OutverseApiForumSpaceUpdate
     */
    readonly forumSpace: ForumSpace
}

/**
 * Request parameters for forumSpaceVisit operation in OutverseApi.
 * @export
 * @interface OutverseApiForumSpaceVisitRequest
 */
export interface OutverseApiForumSpaceVisitRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiForumSpaceVisit
     */
    readonly uuid: string
}

/**
 * Request parameters for insightsNewMembersInsight operation in OutverseApi.
 * @export
 * @interface OutverseApiInsightsNewMembersInsightRequest
 */
export interface OutverseApiInsightsNewMembersInsightRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiInsightsNewMembersInsight
     */
    readonly community: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiInsightsNewMembersInsight
     */
    readonly createdAfter?: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiInsightsNewMembersInsight
     */
    readonly createdBefore?: string
}

/**
 * Request parameters for insightsThreadsCreatedInsight operation in OutverseApi.
 * @export
 * @interface OutverseApiInsightsThreadsCreatedInsightRequest
 */
export interface OutverseApiInsightsThreadsCreatedInsightRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiInsightsThreadsCreatedInsight
     */
    readonly community: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiInsightsThreadsCreatedInsight
     */
    readonly createdAfter?: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiInsightsThreadsCreatedInsight
     */
    readonly createdBefore?: string
}

/**
 * Request parameters for opengraphExtract operation in OutverseApi.
 * @export
 * @interface OutverseApiOpengraphExtractRequest
 */
export interface OutverseApiOpengraphExtractRequest {
    /**
     * The url to use for extraction of open graph metadata
     * @type {string}
     * @memberof OutverseApiOpengraphExtract
     */
    readonly url: string
}

/**
 * Request parameters for organisationsCommunitiesList operation in OutverseApi.
 * @export
 * @interface OutverseApiOrganisationsCommunitiesListRequest
 */
export interface OutverseApiOrganisationsCommunitiesListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiOrganisationsCommunitiesList
     */
    readonly organisationUuid: string

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiOrganisationsCommunitiesList
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiOrganisationsCommunitiesList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiOrganisationsCommunitiesList
     */
    readonly ordering?: string
}

/**
 * Request parameters for organisationsList operation in OutverseApi.
 * @export
 * @interface OutverseApiOrganisationsListRequest
 */
export interface OutverseApiOrganisationsListRequest {
    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiOrganisationsList
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof OutverseApiOrganisationsList
     */
    readonly name?: string

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiOrganisationsList
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiOrganisationsList
     */
    readonly ordering?: string

    /**
     * 
     * @type {string}
     * @memberof OutverseApiOrganisationsList
     */
    readonly slug?: string
}

/**
 * Request parameters for organisationsPartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiOrganisationsPartialUpdateRequest
 */
export interface OutverseApiOrganisationsPartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiOrganisationsPartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedOrganisation}
     * @memberof OutverseApiOrganisationsPartialUpdate
     */
    readonly patchedOrganisation?: PatchedOrganisation
}

/**
 * Request parameters for organisationsRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiOrganisationsRetrieveRequest
 */
export interface OutverseApiOrganisationsRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiOrganisationsRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for organisationsUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiOrganisationsUpdateRequest
 */
export interface OutverseApiOrganisationsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiOrganisationsUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {Organisation}
     * @memberof OutverseApiOrganisationsUpdate
     */
    readonly organisation?: Organisation
}

/**
 * Request parameters for roleAddMember operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleAddMemberRequest
 */
export interface OutverseApiRoleAddMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRoleAddMember
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedUserId}
     * @memberof OutverseApiRoleAddMember
     */
    readonly patchedUserId?: PatchedUserId
}

/**
 * Request parameters for roleCreate operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleCreateRequest
 */
export interface OutverseApiRoleCreateRequest {
    /**
     * Identifies the community that the community role should be created for.
     * @type {string}
     * @memberof OutverseApiRoleCreate
     */
    readonly communitySlug?: string

    /**
     * 
     * @type {CommunityRole}
     * @memberof OutverseApiRoleCreate
     */
    readonly communityRole?: CommunityRole
}

/**
 * Request parameters for roleDestroy operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleDestroyRequest
 */
export interface OutverseApiRoleDestroyRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRoleDestroy
     */
    readonly uuid: string
}

/**
 * Request parameters for rolePartialUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiRolePartialUpdateRequest
 */
export interface OutverseApiRolePartialUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRolePartialUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedCommunityRole}
     * @memberof OutverseApiRolePartialUpdate
     */
    readonly patchedCommunityRole?: PatchedCommunityRole
}

/**
 * Request parameters for roleRemoveMember operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleRemoveMemberRequest
 */
export interface OutverseApiRoleRemoveMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRoleRemoveMember
     */
    readonly uuid: string

    /**
     * 
     * @type {PatchedUserId}
     * @memberof OutverseApiRoleRemoveMember
     */
    readonly patchedUserId?: PatchedUserId
}

/**
 * Request parameters for roleRetrieve operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleRetrieveRequest
 */
export interface OutverseApiRoleRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRoleRetrieve
     */
    readonly uuid: string
}

/**
 * Request parameters for roleUpdate operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleUpdateRequest
 */
export interface OutverseApiRoleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRoleUpdate
     */
    readonly uuid: string

    /**
     * 
     * @type {CommunityRole}
     * @memberof OutverseApiRoleUpdate
     */
    readonly communityRole?: CommunityRole
}

/**
 * Request parameters for roleUpdateMembers operation in OutverseApi.
 * @export
 * @interface OutverseApiRoleUpdateMembersRequest
 */
export interface OutverseApiRoleUpdateMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiRoleUpdateMembers
     */
    readonly uuid: string

    /**
     * 
     * @type {UserIds}
     * @memberof OutverseApiRoleUpdateMembers
     */
    readonly userIds: UserIds

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OutverseApiRoleUpdateMembers
     */
    readonly limit?: number

    /**
     * The initial index from which to return the results.
     * @type {number}
     * @memberof OutverseApiRoleUpdateMembers
     */
    readonly offset?: number

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiRoleUpdateMembers
     */
    readonly ordering?: string
}

/**
 * Request parameters for searchContentList operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchContentListRequest
 */
export interface OutverseApiSearchContentListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchContentList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSearchContentList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchContentList
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchContentList
     */
    readonly search?: string

    /**
     * content link type to filter by
     * @type {string}
     * @memberof OutverseApiSearchContentList
     */
    readonly type?: string
}

/**
 * Request parameters for searchContentPreviewsList operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchContentPreviewsListRequest
 */
export interface OutverseApiSearchContentPreviewsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchContentPreviewsList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSearchContentPreviewsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchContentPreviewsList
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchContentPreviewsList
     */
    readonly search?: string
}

/**
 * Request parameters for searchDocumentsList operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchDocumentsListRequest
 */
export interface OutverseApiSearchDocumentsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchDocumentsList
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSearchDocumentsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchDocumentsList
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchDocumentsList
     */
    readonly search?: string
}

/**
 * Request parameters for searchDocumentsV2List operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchDocumentsV2ListRequest
 */
export interface OutverseApiSearchDocumentsV2ListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchDocumentsV2List
     */
    readonly communitySlug: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSearchDocumentsV2List
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchDocumentsV2List
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchDocumentsV2List
     */
    readonly search?: string
}

/**
 * Request parameters for searchPostsList operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchPostsListRequest
 */
export interface OutverseApiSearchPostsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchPostsList
     */
    readonly communitySlug: string

    /**
     * author uuid to filter by
     * @type {string}
     * @memberof OutverseApiSearchPostsList
     */
    readonly author?: string

    /**
     * forum to search within
     * @type {string}
     * @memberof OutverseApiSearchPostsList
     */
    readonly forum?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSearchPostsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchPostsList
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchPostsList
     */
    readonly search?: string

    /**
     * thread uuid to filter by
     * @type {string}
     * @memberof OutverseApiSearchPostsList
     */
    readonly thread?: string
}

/**
 * Request parameters for searchPostsV2List operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchPostsV2ListRequest
 */
export interface OutverseApiSearchPostsV2ListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchPostsV2List
     */
    readonly communitySlug: string

    /**
     * author uuid to filter by
     * @type {string}
     * @memberof OutverseApiSearchPostsV2List
     */
    readonly author?: string

    /**
     * forum to search within
     * @type {string}
     * @memberof OutverseApiSearchPostsV2List
     */
    readonly forum?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchPostsV2List
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchPostsV2List
     */
    readonly search?: string

    /**
     * thread uuid to filter by
     * @type {string}
     * @memberof OutverseApiSearchPostsV2List
     */
    readonly thread?: string
}

/**
 * Request parameters for searchThreadsList operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchThreadsListRequest
 */
export interface OutverseApiSearchThreadsListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchThreadsList
     */
    readonly communitySlug: string

    /**
     * author uuid to filter by
     * @type {string}
     * @memberof OutverseApiSearchThreadsList
     */
    readonly author?: string

    /**
     * forum to search within
     * @type {string}
     * @memberof OutverseApiSearchThreadsList
     */
    readonly forum?: string

    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSearchThreadsList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchThreadsList
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchThreadsList
     */
    readonly search?: string
}

/**
 * Request parameters for searchThreadsV2List operation in OutverseApi.
 * @export
 * @interface OutverseApiSearchThreadsV2ListRequest
 */
export interface OutverseApiSearchThreadsV2ListRequest {
    /**
     * 
     * @type {string}
     * @memberof OutverseApiSearchThreadsV2List
     */
    readonly communitySlug: string

    /**
     * author uuid to filter by
     * @type {string}
     * @memberof OutverseApiSearchThreadsV2List
     */
    readonly author?: string

    /**
     * forum to search within
     * @type {string}
     * @memberof OutverseApiSearchThreadsV2List
     */
    readonly forum?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSearchThreadsV2List
     */
    readonly page?: number

    /**
     * Search string used to filter
     * @type {string}
     * @memberof OutverseApiSearchThreadsV2List
     */
    readonly search?: string
}

/**
 * Request parameters for seoCommunityList operation in OutverseApi.
 * @export
 * @interface OutverseApiSeoCommunityListRequest
 */
export interface OutverseApiSeoCommunityListRequest {
    /**
     * Which field to use when ordering the results.
     * @type {string}
     * @memberof OutverseApiSeoCommunityList
     */
    readonly ordering?: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OutverseApiSeoCommunityList
     */
    readonly page?: number
}

/**
 * OutverseApi - object-oriented interface
 * @export
 * @class OutverseApi
 * @extends {BaseAPI}
 */
export class OutverseApi extends BaseAPI {
    /**
     * 
     * @param {OutverseApiApiUsersCreateUserFromTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersCreateUserFromToken(requestParameters: OutverseApiApiUsersCreateUserFromTokenRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersCreateUserFromToken(requestParameters.createUserSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiApiUsersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersList(requestParameters: OutverseApiApiUsersListRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersList(requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersMe(options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The handling of serialization is manual inside this method. We are using `UserSerializer` for both responses, but the shape of the PATCH request is `PrivateWriteUserSerializer`. This is the reason we are using serializer_class=UserSerializer for the action decorator, but request=PrivateWriteUserSerializer for the extend_schema for PATCH.
     * @param {OutverseApiApiUsersMePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersMePartialUpdate(requestParameters: OutverseApiApiUsersMePartialUpdateRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersMePartialUpdate(requestParameters.patchedPrivateWriteUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiApiUsersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersPartialUpdate(requestParameters: OutverseApiApiUsersPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersPartialUpdate(requestParameters.uuid, requestParameters.patchedPrivateWriteUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersPermissions(options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiApiUsersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersRetrieve(requestParameters: OutverseApiApiUsersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiApiUsersSendEmailVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersSendEmailVerification(requestParameters: OutverseApiApiUsersSendEmailVerificationRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersSendEmailVerification(requestParameters.emailVerification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle a flag for a user.
     * @param {OutverseApiApiUsersToggleFlagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersToggleFlag(requestParameters: OutverseApiApiUsersToggleFlagRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersToggleFlag(requestParameters.flagToggleSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiApiUsersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersUpdate(requestParameters: OutverseApiApiUsersUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersUpdate(requestParameters.uuid, requestParameters.privateWriteUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks authenticated payload Issues a custom token
     * @param {OutverseApiApiUsersWidgetAuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public apiUsersWidgetAuth(requestParameters: OutverseApiApiUsersWidgetAuthRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).apiUsersWidgetAuth(requestParameters.metadataVerification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiAuthTokenCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public authTokenCreate(requestParameters: OutverseApiAuthTokenCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).authTokenCreate(requestParameters.username, requestParameters.password, requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiChatHandlerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public chatHandler(requestParameters: OutverseApiChatHandlerRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).chatHandler(requestParameters.communitySlug, requestParameters.prompt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesAdminsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesAdminsList(requestParameters: OutverseApiCommunitiesAdminsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesAdminsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesAdminsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesAdminsRetrieve(requestParameters: OutverseApiCommunitiesAdminsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesAdminsRetrieve(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChangelogEntriesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChangelogEntriesCreate(requestParameters: OutverseApiCommunitiesChangelogEntriesCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChangelogEntriesCreate(requestParameters.communitySlug, requestParameters.changelogEntryWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChangelogEntriesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChangelogEntriesDestroy(requestParameters: OutverseApiCommunitiesChangelogEntriesDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChangelogEntriesDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChangelogEntriesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChangelogEntriesList(requestParameters: OutverseApiCommunitiesChangelogEntriesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChangelogEntriesList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChangelogEntriesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChangelogEntriesPartialUpdate(requestParameters: OutverseApiCommunitiesChangelogEntriesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChangelogEntriesPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedChangelogEntryWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChangelogEntriesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChangelogEntriesRetrieve(requestParameters: OutverseApiCommunitiesChangelogEntriesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChangelogEntriesRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChangelogEntriesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChangelogEntriesUpdate(requestParameters: OutverseApiCommunitiesChangelogEntriesUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChangelogEntriesUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.changelogEntryWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesChatEvaluateTraceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesChatEvaluateTrace(requestParameters: OutverseApiCommunitiesChatEvaluateTraceRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesChatEvaluateTrace(requestParameters.communitySlug, requestParameters.sessionId, requestParameters.traceId, requestParameters.chatFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesContentLinksCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesContentLinksCreate(requestParameters: OutverseApiCommunitiesContentLinksCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesContentLinksCreate(requestParameters.communitySlug, requestParameters.contentLink, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesContentLinksDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesContentLinksDestroy(requestParameters: OutverseApiCommunitiesContentLinksDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesContentLinksDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesContentLinksPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesContentLinksPartialUpdate(requestParameters: OutverseApiCommunitiesContentLinksPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesContentLinksPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedContentLink, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesContentLinksRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesContentLinksRetrieve(requestParameters: OutverseApiCommunitiesContentLinksRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesContentLinksRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesContentLinksUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesContentLinksUpdate(requestParameters: OutverseApiCommunitiesContentLinksUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesContentLinksUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.contentLink, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesContextSourcesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesContextSourcesList(requestParameters: OutverseApiCommunitiesContextSourcesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesContextSourcesList(requestParameters.communitySlug, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCreate(requestParameters: OutverseApiCommunitiesCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCreate(requestParameters.communityCreation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCrmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCrm(requestParameters: OutverseApiCommunitiesCrmRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCrm(requestParameters.slug, requestParameters.patchedCommunityCRM, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCustomSpacesContentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCustomSpacesContent(requestParameters: OutverseApiCommunitiesCustomSpacesContentRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCustomSpacesContent(requestParameters.communitySlug, requestParameters.uuid, requestParameters.customSpaceContent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCustomSpacesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCustomSpacesCreate(requestParameters: OutverseApiCommunitiesCustomSpacesCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCustomSpacesCreate(requestParameters.communitySlug, requestParameters.customSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCustomSpacesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCustomSpacesDestroy(requestParameters: OutverseApiCommunitiesCustomSpacesDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCustomSpacesDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCustomSpacesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCustomSpacesPartialUpdate(requestParameters: OutverseApiCommunitiesCustomSpacesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCustomSpacesPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedCustomSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCustomSpacesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCustomSpacesRetrieve(requestParameters: OutverseApiCommunitiesCustomSpacesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCustomSpacesRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesCustomSpacesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesCustomSpacesUpdate(requestParameters: OutverseApiCommunitiesCustomSpacesUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesCustomSpacesUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.customSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * In order to set a key on the community, run: community.widget_secret = generate_hmac_secret() community.save()  Not adding an api route for that for safety reasons, in case the api somehow became exposed.
     * @param {OutverseApiCommunitiesDevelopmentGetAuthedPayloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDevelopmentGetAuthedPayload(requestParameters: OutverseApiCommunitiesDevelopmentGetAuthedPayloadRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDevelopmentGetAuthedPayload(requestParameters.communitySlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsCreate(requestParameters: OutverseApiCommunitiesDocumentsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsCreate(requestParameters.communitySlug, requestParameters.document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsDestroy(requestParameters: OutverseApiCommunitiesDocumentsDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsDraftRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsDraft(requestParameters: OutverseApiCommunitiesDocumentsDraftRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsDraft(requestParameters.communitySlug, requestParameters.uuid, requestParameters.cRDTDraft, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsFavouriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsFavourite(requestParameters: OutverseApiCommunitiesDocumentsFavouriteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsFavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsPartialUpdate(requestParameters: OutverseApiCommunitiesDocumentsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsRetrieve(requestParameters: OutverseApiCommunitiesDocumentsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsUnfavouriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsUnfavourite(requestParameters: OutverseApiCommunitiesDocumentsUnfavouriteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsUnfavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for documents without List.
     * @param {OutverseApiCommunitiesDocumentsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesDocumentsUpdate(requestParameters: OutverseApiCommunitiesDocumentsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesDocumentsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Escalation rules define a condition that triggers an escalation, created by admins/team members.
     * @param {OutverseApiCommunitiesEscalationRulesCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesEscalationRulesCreate(requestParameters: OutverseApiCommunitiesEscalationRulesCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesEscalationRulesCreate(requestParameters.communitySlug, requestParameters.escalationRule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Escalation rules define a condition that triggers an escalation, created by admins/team members.
     * @param {OutverseApiCommunitiesEscalationRulesDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesEscalationRulesDestroy(requestParameters: OutverseApiCommunitiesEscalationRulesDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesEscalationRulesDestroy(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Escalation rules define a condition that triggers an escalation, created by admins/team members.
     * @param {OutverseApiCommunitiesEscalationRulesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesEscalationRulesList(requestParameters: OutverseApiCommunitiesEscalationRulesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesEscalationRulesList(requestParameters.communitySlug, requestParameters.agent, requestParameters.createdBy, requestParameters.enabled, requestParameters.isTriggeredEarly, requestParameters.page, requestParameters.requiresConfirmation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Escalation rules define a condition that triggers an escalation, created by admins/team members.
     * @param {OutverseApiCommunitiesEscalationRulesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesEscalationRulesPartialUpdate(requestParameters: OutverseApiCommunitiesEscalationRulesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesEscalationRulesPartialUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.patchedEscalationRule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Escalation rules define a condition that triggers an escalation, created by admins/team members.
     * @param {OutverseApiCommunitiesEscalationRulesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesEscalationRulesRetrieve(requestParameters: OutverseApiCommunitiesEscalationRulesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesEscalationRulesRetrieve(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Escalation rules define a condition that triggers an escalation, created by admins/team members.
     * @param {OutverseApiCommunitiesEscalationRulesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesEscalationRulesUpdate(requestParameters: OutverseApiCommunitiesEscalationRulesUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesEscalationRulesUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.escalationRule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFavouritesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFavouritesList(requestParameters: OutverseApiCommunitiesFavouritesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFavouritesList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFoldersCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersCreate(requestParameters: OutverseApiCommunitiesFoldersCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersCreate(requestParameters.communitySlug, requestParameters.folder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFoldersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersDestroy(requestParameters: OutverseApiCommunitiesFoldersDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Custom list that checks view perms on each doc.
     * @param {OutverseApiCommunitiesFoldersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersList(requestParameters: OutverseApiCommunitiesFoldersListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersList(requestParameters.communitySlug, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFoldersMoveDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersMoveDocument(requestParameters: OutverseApiCommunitiesFoldersMoveDocumentRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersMoveDocument(requestParameters.communitySlug, requestParameters.uuid, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFoldersPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersPartialUpdate(requestParameters: OutverseApiCommunitiesFoldersPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedFolder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFoldersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersRetrieve(requestParameters: OutverseApiCommunitiesFoldersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesFoldersUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesFoldersUpdate(requestParameters: OutverseApiCommunitiesFoldersUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesFoldersUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.folder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesForumSpacesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesForumSpacesList(requestParameters: OutverseApiCommunitiesForumSpacesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesForumSpacesList(requestParameters.communitySlug, requestParameters.canAddForumthread, requestParameters.ordering, requestParameters.page, requestParameters.title, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksCreate(requestParameters: OutverseApiCommunitiesHooksCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksCreate(requestParameters.communitySlug, requestParameters.webHook, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksDestroy(requestParameters: OutverseApiCommunitiesHooksDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksEventsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksEventsList(requestParameters: OutverseApiCommunitiesHooksEventsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksEventsList(requestParameters.communitySlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksList(requestParameters: OutverseApiCommunitiesHooksListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksPartialUpdate(requestParameters: OutverseApiCommunitiesHooksPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedWebHook, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksRetrieve(requestParameters: OutverseApiCommunitiesHooksRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve, create, update or destroy webhooks.
     * @param {OutverseApiCommunitiesHooksUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesHooksUpdate(requestParameters: OutverseApiCommunitiesHooksUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesHooksUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.webHook, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD operations for Intents
     * @param {OutverseApiCommunitiesIntentsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesIntentsCreate(requestParameters: OutverseApiCommunitiesIntentsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesIntentsCreate(requestParameters.communitySlug, requestParameters.intentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD operations for Intents
     * @param {OutverseApiCommunitiesIntentsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesIntentsDestroy(requestParameters: OutverseApiCommunitiesIntentsDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesIntentsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD operations for Intents
     * @param {OutverseApiCommunitiesIntentsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesIntentsList(requestParameters: OutverseApiCommunitiesIntentsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesIntentsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD operations for Intents
     * @param {OutverseApiCommunitiesIntentsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesIntentsPartialUpdate(requestParameters: OutverseApiCommunitiesIntentsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesIntentsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedIntentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD operations for Intents
     * @param {OutverseApiCommunitiesIntentsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesIntentsRetrieve(requestParameters: OutverseApiCommunitiesIntentsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesIntentsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD operations for Intents
     * @param {OutverseApiCommunitiesIntentsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesIntentsUpdate(requestParameters: OutverseApiCommunitiesIntentsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesIntentsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.intentWrite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesInvitationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesInvitationsList(requestParameters: OutverseApiCommunitiesInvitationsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesInvitationsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesInviteCodeCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesInviteCodeCheck(requestParameters: OutverseApiCommunitiesInviteCodeCheckRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesInviteCodeCheck(requestParameters.communitySlug, requestParameters.inviteCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This is slightly awkward and uncanonical in HTTP terms. The only ID supplied here is the parent community\'s, so this isn\'t actually a \"retrieve\" on the resource represented by CommunityInviteCodeViewset but rather a retrieve on the parent (as such perhaps it belongs back with the parent in the end).
     * @param {OutverseApiCommunitiesInviteCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesInviteCodeGet(requestParameters: OutverseApiCommunitiesInviteCodeGetRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesInviteCodeGet(requestParameters.communitySlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesInviteCodeInviteMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesInviteCodeInviteMember(requestParameters: OutverseApiCommunitiesInviteCodeInviteMemberRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesInviteCodeInviteMember(requestParameters.communitySlug, requestParameters.inviteMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesInviteCodeInviteTeamMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesInviteCodeInviteTeamMember(requestParameters: OutverseApiCommunitiesInviteCodeInviteTeamMemberRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesInviteCodeInviteTeamMember(requestParameters.communitySlug, requestParameters.inviteTeamMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesInviteCodeRefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesInviteCodeRefresh(requestParameters: OutverseApiCommunitiesInviteCodeRefreshRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesInviteCodeRefresh(requestParameters.communitySlug, requestParameters.communityInviteCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesLabelsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLabelsCreate(requestParameters: OutverseApiCommunitiesLabelsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLabelsCreate(requestParameters.communitySlug, requestParameters.labelSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesLabelsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLabelsDestroy(requestParameters: OutverseApiCommunitiesLabelsDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLabelsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesLabelsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLabelsList(requestParameters: OutverseApiCommunitiesLabelsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLabelsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesLabelsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLabelsPartialUpdate(requestParameters: OutverseApiCommunitiesLabelsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLabelsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedLabelSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesLabelsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLabelsRetrieve(requestParameters: OutverseApiCommunitiesLabelsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLabelsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesLabelsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLabelsUpdate(requestParameters: OutverseApiCommunitiesLabelsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLabelsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.labelSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesList(requestParameters: OutverseApiCommunitiesListRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesList(requestParameters.limit, requestParameters.name, requestParameters.offset, requestParameters.ordering, requestParameters.userIsAdmin, requestParameters.userIsMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Session and Trace analytics endpoint.
     * @param {OutverseApiCommunitiesLlmSessionsAnalyticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLlmSessionsAnalytics(requestParameters: OutverseApiCommunitiesLlmSessionsAnalyticsRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLlmSessionsAnalytics(requestParameters.communitySlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
     * @param {OutverseApiCommunitiesLlmSessionsAuditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLlmSessionsAudit(requestParameters: OutverseApiCommunitiesLlmSessionsAuditRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLlmSessionsAudit(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
     * @param {OutverseApiCommunitiesLlmSessionsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLlmSessionsList(requestParameters: OutverseApiCommunitiesLlmSessionsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLlmSessionsList(requestParameters.communitySlug, requestParameters.audited, requestParameters.createdAfter, requestParameters.createdBefore, requestParameters.escalated, requestParameters.intent, requestParameters.ordering, requestParameters.page, requestParameters.rule, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
     * @param {OutverseApiCommunitiesLlmSessionsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLlmSessionsRetrieve(requestParameters: OutverseApiCommunitiesLlmSessionsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLlmSessionsRetrieve(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List viewset for LLM sessions with metrics attached to the response.  Viewable by anyone with CAN_VIEW_CONVERSATION_HISTORY permissions.
     * @param {OutverseApiCommunitiesLlmSessionsUnauditRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesLlmSessionsUnaudit(requestParameters: OutverseApiCommunitiesLlmSessionsUnauditRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesLlmSessionsUnaudit(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMembersDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersDestroy(requestParameters: OutverseApiCommunitiesMembersDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMembersDisableSlackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersDisableSlack(requestParameters: OutverseApiCommunitiesMembersDisableSlackRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersDisableSlack(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the email of a community member using PrivateUserSerializer.
     * @param {OutverseApiCommunitiesMembersGetEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersGetEmail(requestParameters: OutverseApiCommunitiesMembersGetEmailRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersGetEmail(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMembersListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersList(requestParameters: OutverseApiCommunitiesMembersListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMembersNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersNotificationPreferences(requestParameters: OutverseApiCommunitiesMembersNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersNotificationPreferences(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMembersNotificationPreferences2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersNotificationPreferences2(requestParameters: OutverseApiCommunitiesMembersNotificationPreferences2Request, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersNotificationPreferences2(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedNotificationChannelPreference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMembersRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMembersRetrieve(requestParameters: OutverseApiCommunitiesMembersRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMembersRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesMoveSpaceGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesMoveSpaceGroup(requestParameters: OutverseApiCommunitiesMoveSpaceGroupRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesMoveSpaceGroup(requestParameters.slug, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesNotificationSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesNotificationSubscriptions(requestParameters: OutverseApiCommunitiesNotificationSubscriptionsRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesNotificationSubscriptions(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPartialUpdate(requestParameters: OutverseApiCommunitiesPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPartialUpdate(requestParameters.slug, requestParameters.patchedCommunityFull, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPermissions(requestParameters: OutverseApiCommunitiesPermissionsRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPermissions(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsCreate(requestParameters: OutverseApiCommunitiesPostsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsCreate(requestParameters.communitySlug, requestParameters.threadPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsDeleteReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsDeleteReaction(requestParameters: OutverseApiCommunitiesPostsDeleteReactionRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsDeleteReaction(requestParameters.communitySlug, requestParameters.reactionUuid, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsDestroy(requestParameters: OutverseApiCommunitiesPostsDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsList(requestParameters: OutverseApiCommunitiesPostsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsList(requestParameters.communitySlug, requestParameters.forumSpaceUuid, requestParameters.forumThreadUuid, requestParameters.ordering, requestParameters.page, requestParameters.replyToPostUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsPartialUpdate(requestParameters: OutverseApiCommunitiesPostsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedThreadPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a reaction for post, returns the post with updated reaction list
     * @param {OutverseApiCommunitiesPostsReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsReaction(requestParameters: OutverseApiCommunitiesPostsReactionRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsReaction(requestParameters.communitySlug, requestParameters.uuid, requestParameters.reactionCreateSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsRemoveUpvoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsRemoveUpvote(requestParameters: OutverseApiCommunitiesPostsRemoveUpvoteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsRemoveUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsReport(requestParameters: OutverseApiCommunitiesPostsReportRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsReport(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsRetrieve(requestParameters: OutverseApiCommunitiesPostsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsUpdate(requestParameters: OutverseApiCommunitiesPostsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.threadPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesPostsUpvoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesPostsUpvote(requestParameters: OutverseApiCommunitiesPostsUpvoteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesPostsUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesRetrieve(requestParameters: OutverseApiCommunitiesRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesRetrieve(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesRolesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesRolesList(requestParameters: OutverseApiCommunitiesRolesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesRolesList(requestParameters.communitySlug, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSemanticSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSemanticSearchGet(requestParameters: OutverseApiCommunitiesSemanticSearchGetRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSemanticSearchGet(requestParameters.communitySlug, requestParameters.entityType, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSetIntercomAppIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSetIntercomAppId(requestParameters: OutverseApiCommunitiesSetIntercomAppIdRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSetIntercomAppId(requestParameters.slug, requestParameters.communityIntercomAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSetZendeskSubdomainRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSetZendeskSubdomain(requestParameters: OutverseApiCommunitiesSetZendeskSubdomainRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSetZendeskSubdomain(requestParameters.slug, requestParameters.communityZendeskSubdomain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSignUpsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSignUpsCreate(requestParameters: OutverseApiCommunitiesSignUpsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSignUpsCreate(requestParameters.communitySlug, requestParameters.communitySignUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSignUpsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSignUpsList(requestParameters: OutverseApiCommunitiesSignUpsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSignUpsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Snippets are just Documents that are marked as snippets (via the `is_snippet` field).  They are however used somewhat differently to normal documents. - Not included in the knowledge base product (ie. the folders tree api call) - In the agent, they can be used as context just like normal documents, but are not surfaced to users speaking   with the agent. They are however visible in conversation history (for debug purposes). Ie. they are a kind of   internal document that can have an impact on the agent\'s responses, but don\'t get shown to users.
     * @param {OutverseApiCommunitiesSnippetsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSnippetsList(requestParameters: OutverseApiCommunitiesSnippetsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSnippetsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsCreate(requestParameters: OutverseApiCommunitiesSpaceGroupsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsCreate(requestParameters.communitySlug, requestParameters.spaceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsDestroy(requestParameters: OutverseApiCommunitiesSpaceGroupsDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Custom list that checks view perms on each space.
     * @param {OutverseApiCommunitiesSpaceGroupsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsList(requestParameters: OutverseApiCommunitiesSpaceGroupsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsMoveSpaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsMoveSpace(requestParameters: OutverseApiCommunitiesSpaceGroupsMoveSpaceRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsMoveSpace(requestParameters.communitySlug, requestParameters.uuid, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsNotificationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsNotificationsList(requestParameters: OutverseApiCommunitiesSpaceGroupsNotificationsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsNotificationsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsPartialUpdate(requestParameters: OutverseApiCommunitiesSpaceGroupsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedSpaceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsPermsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsPermsList(requestParameters: OutverseApiCommunitiesSpaceGroupsPermsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsPermsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsRetrieve(requestParameters: OutverseApiCommunitiesSpaceGroupsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSpaceGroupsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSpaceGroupsUpdate(requestParameters: OutverseApiCommunitiesSpaceGroupsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSpaceGroupsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.spaceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSubscribeToNewMemberEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSubscribeToNewMemberEvent(requestParameters: OutverseApiCommunitiesSubscribeToNewMemberEventRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSubscribeToNewMemberEvent(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSwitchboardDisableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSwitchboardDisable(requestParameters: OutverseApiCommunitiesSwitchboardDisableRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSwitchboardDisable(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesSwitchboardStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesSwitchboardStatus(requestParameters: OutverseApiCommunitiesSwitchboardStatusRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesSwitchboardStatus(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsAnnotationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsAnnotationsList(requestParameters: OutverseApiCommunitiesThreadsAnnotationsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsAnnotationsList(requestParameters.communitySlug, requestParameters.cursor, requestParameters.forumSpaceUuid, requestParameters.labelUuid, requestParameters.ordering, requestParameters.solved, requestParameters.unread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsCreate(requestParameters: OutverseApiCommunitiesThreadsCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsCreate(requestParameters.communitySlug, requestParameters.forumThread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsDeletePinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsDeletePin(requestParameters: OutverseApiCommunitiesThreadsDeletePinRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsDeletePin(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsDeleteReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsDeleteReaction(requestParameters: OutverseApiCommunitiesThreadsDeleteReactionRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsDeleteReaction(requestParameters.communitySlug, requestParameters.reactionUuid, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsDestroy(requestParameters: OutverseApiCommunitiesThreadsDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsDestroy(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsFavouriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsFavourite(requestParameters: OutverseApiCommunitiesThreadsFavouriteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsFavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsHideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsHide(requestParameters: OutverseApiCommunitiesThreadsHideRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsHide(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsList(requestParameters: OutverseApiCommunitiesThreadsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsList(requestParameters.communitySlug, requestParameters.cursor, requestParameters.forumSpaceUuid, requestParameters.labelUuid, requestParameters.ordering, requestParameters.solved, requestParameters.unread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsLockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsLock(requestParameters: OutverseApiCommunitiesThreadsLockRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsLock(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsMaximizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsMaximize(requestParameters: OutverseApiCommunitiesThreadsMaximizeRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsMaximize(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsPartialUpdate(requestParameters: OutverseApiCommunitiesThreadsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsPartialUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.patchedForumThread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsPinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsPin(requestParameters: OutverseApiCommunitiesThreadsPinRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsPin(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a reaction for thread, returns the Thread with updated reaction list
     * @param {OutverseApiCommunitiesThreadsReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsReaction(requestParameters: OutverseApiCommunitiesThreadsReactionRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsReaction(requestParameters.communitySlug, requestParameters.uuid, requestParameters.reactionCreateSerialiser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsRemoveUpvoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsRemoveUpvote(requestParameters: OutverseApiCommunitiesThreadsRemoveUpvoteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsRemoveUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsReport(requestParameters: OutverseApiCommunitiesThreadsReportRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsReport(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsRetrieve(requestParameters: OutverseApiCommunitiesThreadsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsRetrieve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsSolveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsSolve(requestParameters: OutverseApiCommunitiesThreadsSolveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsSolve(requestParameters.communitySlug, requestParameters.uuid, requestParameters.switchSolution, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsSubscribeToActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsSubscribeToActivity(requestParameters: OutverseApiCommunitiesThreadsSubscribeToActivityRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsSubscribeToActivity(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsSubscribeToRepliesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsSubscribeToReplies(requestParameters: OutverseApiCommunitiesThreadsSubscribeToRepliesRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsSubscribeToReplies(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnfavouriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnfavourite(requestParameters: OutverseApiCommunitiesThreadsUnfavouriteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnfavourite(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnhideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnhide(requestParameters: OutverseApiCommunitiesThreadsUnhideRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnhide(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnlockRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnlock(requestParameters: OutverseApiCommunitiesThreadsUnlockRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnlock(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnmaximizeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnmaximize(requestParameters: OutverseApiCommunitiesThreadsUnmaximizeRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnmaximize(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnsolveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnsolve(requestParameters: OutverseApiCommunitiesThreadsUnsolveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnsolve(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnsubscribeFromActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnsubscribeFromActivity(requestParameters: OutverseApiCommunitiesThreadsUnsubscribeFromActivityRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnsubscribeFromActivity(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUnsubscribeFromRepliesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUnsubscribeFromReplies(requestParameters: OutverseApiCommunitiesThreadsUnsubscribeFromRepliesRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUnsubscribeFromReplies(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUpdate(requestParameters: OutverseApiCommunitiesThreadsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUpdate(requestParameters.communitySlug, requestParameters.uuid, requestParameters.forumThread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsUpvoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsUpvote(requestParameters: OutverseApiCommunitiesThreadsUpvoteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsUpvote(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesThreadsVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesThreadsVisit(requestParameters: OutverseApiCommunitiesThreadsVisitRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesThreadsVisit(requestParameters.communitySlug, requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of available tools based on community configuration, using LangChain tool definitions.
     * @param {OutverseApiCommunitiesToolsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesToolsList(requestParameters: OutverseApiCommunitiesToolsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesToolsList(requestParameters.communitySlug, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
     * @param {OutverseApiCommunitiesTraceFeedbackCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesTraceFeedbackCreate(requestParameters: OutverseApiCommunitiesTraceFeedbackCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesTraceFeedbackCreate(requestParameters.communitySlug, requestParameters.traceFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
     * @param {OutverseApiCommunitiesTraceFeedbackDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesTraceFeedbackDestroy(requestParameters: OutverseApiCommunitiesTraceFeedbackDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesTraceFeedbackDestroy(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
     * @param {OutverseApiCommunitiesTraceFeedbackListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesTraceFeedbackList(requestParameters: OutverseApiCommunitiesTraceFeedbackListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesTraceFeedbackList(requestParameters.communitySlug, requestParameters.author, requestParameters.page, requestParameters.trace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
     * @param {OutverseApiCommunitiesTraceFeedbackPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesTraceFeedbackPartialUpdate(requestParameters: OutverseApiCommunitiesTraceFeedbackPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesTraceFeedbackPartialUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.patchedTraceFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
     * @param {OutverseApiCommunitiesTraceFeedbackRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesTraceFeedbackRetrieve(requestParameters: OutverseApiCommunitiesTraceFeedbackRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesTraceFeedbackRetrieve(requestParameters.communitySlug, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for LlmTraceFeedbacks. Any user from the community can create a feedback if they have the CAN_VIEW_CONVERSATION_HISTORY_PERMISSION
     * @param {OutverseApiCommunitiesTraceFeedbackUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesTraceFeedbackUpdate(requestParameters: OutverseApiCommunitiesTraceFeedbackUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesTraceFeedbackUpdate(requestParameters.communitySlug, requestParameters.id, requestParameters.traceFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesUnsubscribeFromNewMemberEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesUnsubscribeFromNewMemberEvent(requestParameters: OutverseApiCommunitiesUnsubscribeFromNewMemberEventRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesUnsubscribeFromNewMemberEvent(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesUpdate(requestParameters: OutverseApiCommunitiesUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesUpdate(requestParameters.slug, requestParameters.communityFull, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesUserSessionsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesUserSessionsList(requestParameters: OutverseApiCommunitiesUserSessionsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesUserSessionsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiCommunitiesUserSessionsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public communitiesUserSessionsRetrieve(requestParameters: OutverseApiCommunitiesUserSessionsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).communitiesUserSessionsRetrieve(requestParameters.communitySlug, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiDocumentFeedbackCountCountForDocRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public documentFeedbackCountCountForDoc(requestParameters: OutverseApiDocumentFeedbackCountCountForDocRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).documentFeedbackCountCountForDoc(requestParameters.document, requestParameters.modifiedAfter, requestParameters.modifiedBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for document feedback
     * @param {OutverseApiDocumentFeedbackCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public documentFeedbackCreate(requestParameters: OutverseApiDocumentFeedbackCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).documentFeedbackCreate(requestParameters.documentFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * CRUD for document feedback
     * @param {OutverseApiDocumentFeedbackRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public documentFeedbackRetrieve(requestParameters: OutverseApiDocumentFeedbackRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).documentFeedbackRetrieve(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceCreate(requestParameters: OutverseApiForumSpaceCreateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceCreate(requestParameters.forumSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceDestroy(requestParameters: OutverseApiForumSpaceDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceDestroy(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceFavouriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceFavourite(requestParameters: OutverseApiForumSpaceFavouriteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceFavourite(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpacePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpacePartialUpdate(requestParameters: OutverseApiForumSpacePartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpacePartialUpdate(requestParameters.uuid, requestParameters.patchedForumSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceRetrieve(requestParameters: OutverseApiForumSpaceRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceSubscribeToActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceSubscribeToActivity(requestParameters: OutverseApiForumSpaceSubscribeToActivityRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceSubscribeToActivity(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceUnfavouriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceUnfavourite(requestParameters: OutverseApiForumSpaceUnfavouriteRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceUnfavourite(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceUnsubscribeFromActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceUnsubscribeFromActivity(requestParameters: OutverseApiForumSpaceUnsubscribeFromActivityRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceUnsubscribeFromActivity(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceUpdate(requestParameters: OutverseApiForumSpaceUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceUpdate(requestParameters.uuid, requestParameters.forumSpace, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiForumSpaceVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public forumSpaceVisit(requestParameters: OutverseApiForumSpaceVisitRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).forumSpaceVisit(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiInsightsNewMembersInsightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public insightsNewMembersInsight(requestParameters: OutverseApiInsightsNewMembersInsightRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).insightsNewMembersInsight(requestParameters.community, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiInsightsThreadsCreatedInsightRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public insightsThreadsCreatedInsight(requestParameters: OutverseApiInsightsThreadsCreatedInsightRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).insightsThreadsCreatedInsight(requestParameters.community, requestParameters.createdAfter, requestParameters.createdBefore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiOpengraphExtractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public opengraphExtract(requestParameters: OutverseApiOpengraphExtractRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).opengraphExtract(requestParameters.url, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiOrganisationsCommunitiesListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public organisationsCommunitiesList(requestParameters: OutverseApiOrganisationsCommunitiesListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).organisationsCommunitiesList(requestParameters.organisationUuid, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List organisations
     * @param {OutverseApiOrganisationsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public organisationsList(requestParameters: OutverseApiOrganisationsListRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).organisationsList(requestParameters.limit, requestParameters.name, requestParameters.offset, requestParameters.ordering, requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiOrganisationsPartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public organisationsPartialUpdate(requestParameters: OutverseApiOrganisationsPartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).organisationsPartialUpdate(requestParameters.uuid, requestParameters.patchedOrganisation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiOrganisationsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public organisationsRetrieve(requestParameters: OutverseApiOrganisationsRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).organisationsRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiOrganisationsUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public organisationsUpdate(requestParameters: OutverseApiOrganisationsUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).organisationsUpdate(requestParameters.uuid, requestParameters.organisation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleAddMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleAddMember(requestParameters: OutverseApiRoleAddMemberRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleAddMember(requestParameters.uuid, requestParameters.patchedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleCreate(requestParameters: OutverseApiRoleCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleCreate(requestParameters.communitySlug, requestParameters.communityRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleDestroyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleDestroy(requestParameters: OutverseApiRoleDestroyRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleDestroy(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRolePartialUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public rolePartialUpdate(requestParameters: OutverseApiRolePartialUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).rolePartialUpdate(requestParameters.uuid, requestParameters.patchedCommunityRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleRemoveMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleRemoveMember(requestParameters: OutverseApiRoleRemoveMemberRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleRemoveMember(requestParameters.uuid, requestParameters.patchedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleRetrieve(requestParameters: OutverseApiRoleRetrieveRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleRetrieve(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleUpdate(requestParameters: OutverseApiRoleUpdateRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleUpdate(requestParameters.uuid, requestParameters.communityRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiRoleUpdateMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public roleUpdateMembers(requestParameters: OutverseApiRoleUpdateMembersRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).roleUpdateMembers(requestParameters.uuid, requestParameters.userIds, requestParameters.limit, requestParameters.offset, requestParameters.ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchContentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchContentList(requestParameters: OutverseApiSearchContentListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchContentList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchContentPreviewsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchContentPreviewsList(requestParameters: OutverseApiSearchContentPreviewsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchContentPreviewsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchDocumentsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchDocumentsList(requestParameters: OutverseApiSearchDocumentsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchDocumentsList(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchDocumentsV2ListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchDocumentsV2List(requestParameters: OutverseApiSearchDocumentsV2ListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchDocumentsV2List(requestParameters.communitySlug, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchPostsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchPostsList(requestParameters: OutverseApiSearchPostsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchPostsList(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.ordering, requestParameters.page, requestParameters.search, requestParameters.thread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchPostsV2ListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchPostsV2List(requestParameters: OutverseApiSearchPostsV2ListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchPostsV2List(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.page, requestParameters.search, requestParameters.thread, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchThreadsListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchThreadsList(requestParameters: OutverseApiSearchThreadsListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchThreadsList(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.ordering, requestParameters.page, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSearchThreadsV2ListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public searchThreadsV2List(requestParameters: OutverseApiSearchThreadsV2ListRequest, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).searchThreadsV2List(requestParameters.communitySlug, requestParameters.author, requestParameters.forum, requestParameters.page, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OutverseApiSeoCommunityListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OutverseApi
     */
    public seoCommunityList(requestParameters: OutverseApiSeoCommunityListRequest = {}, options?: RawAxiosRequestConfig) {
        return OutverseApiFp(this.configuration).seoCommunityList(requestParameters.ordering, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CommunitiesEscalationRulesListAgentEnum = {
    Customer: 'customer',
    Zendesk: 'zendesk'
} as const;
export type CommunitiesEscalationRulesListAgentEnum = typeof CommunitiesEscalationRulesListAgentEnum[keyof typeof CommunitiesEscalationRulesListAgentEnum];
/**
 * @export
 */
export const CommunitiesLlmSessionsListSourceEnum = {
    Copilot: 'copilot',
    Evals: 'evals',
    Intercom: 'intercom',
    Salesforce: 'salesforce',
    Widget: 'widget',
    Zendesk: 'zendesk'
} as const;
export type CommunitiesLlmSessionsListSourceEnum = typeof CommunitiesLlmSessionsListSourceEnum[keyof typeof CommunitiesLlmSessionsListSourceEnum];
/**
 * @export
 */
export const CommunitiesSemanticSearchGetEntityTypeEnum = {
    Doc: 'DOC',
    Reply: 'REPLY',
    Thread: 'THREAD'
} as const;
export type CommunitiesSemanticSearchGetEntityTypeEnum = typeof CommunitiesSemanticSearchGetEntityTypeEnum[keyof typeof CommunitiesSemanticSearchGetEntityTypeEnum];


